var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e35) { throw _e35; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e36) { didErr = true; err = _e36; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).prettierPlugins = e.prettierPlugins || {}, e.prettierPlugins.html = t());
}(this, function () {
  "use strict";

  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function t(e, t, n) {
    return e(n = {
      path: t,
      exports: {},
      require: function require(e, t) {
        return function () {
          throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
        }(null == t && n.path);
      }
    }, n.exports), n.exports;
  }

  var n = t(function (e, t) {
    function n(e) {
      return t.$0 <= e && e <= t.$9;
    }
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */


    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.$EOF = 0, t.$BSPACE = 8, t.$TAB = 9, t.$LF = 10, t.$VTAB = 11, t.$FF = 12, t.$CR = 13, t.$SPACE = 32, t.$BANG = 33, t.$DQ = 34, t.$HASH = 35, t.$$ = 36, t.$PERCENT = 37, t.$AMPERSAND = 38, t.$SQ = 39, t.$LPAREN = 40, t.$RPAREN = 41, t.$STAR = 42, t.$PLUS = 43, t.$COMMA = 44, t.$MINUS = 45, t.$PERIOD = 46, t.$SLASH = 47, t.$COLON = 58, t.$SEMICOLON = 59, t.$LT = 60, t.$EQ = 61, t.$GT = 62, t.$QUESTION = 63, t.$0 = 48, t.$7 = 55, t.$9 = 57, t.$A = 65, t.$E = 69, t.$F = 70, t.$X = 88, t.$Z = 90, t.$LBRACKET = 91, t.$BACKSLASH = 92, t.$RBRACKET = 93, t.$CARET = 94, t.$_ = 95, t.$a = 97, t.$b = 98, t.$e = 101, t.$f = 102, t.$n = 110, t.$r = 114, t.$t = 116, t.$u = 117, t.$v = 118, t.$x = 120, t.$z = 122, t.$LBRACE = 123, t.$BAR = 124, t.$RBRACE = 125, t.$NBSP = 160, t.$PIPE = 124, t.$TILDA = 126, t.$AT = 64, t.$BT = 96, t.isWhitespace = function (e) {
      return e >= t.$TAB && e <= t.$SPACE || e == t.$NBSP;
    }, t.isDigit = n, t.isAsciiLetter = function (e) {
      return e >= t.$a && e <= t.$z || e >= t.$A && e <= t.$Z;
    }, t.isAsciiHexDigit = function (e) {
      return e >= t.$a && e <= t.$f || e >= t.$A && e <= t.$F || n(e);
    }, t.isNewLine = function (e) {
      return e === t.$LF || e === t.$CR;
    }, t.isOctalDigit = function (e) {
      return t.$0 <= e && e <= t.$7;
    };
  }),
      r = t(function (e, t) {
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = /*#__PURE__*/function () {
      function n(e, t, _n2) {
        _classCallCheck(this, n);

        this.filePath = e, this.name = t, this.members = _n2;
      }

      _createClass(n, [{
        key: "assertNoMembers",
        value: function assertNoMembers() {
          if (this.members.length) throw new Error("Illegal state: symbol without members expected, but got ".concat(JSON.stringify(this), "."));
        }
      }]);

      return n;
    }();

    t.StaticSymbol = n;

    t.StaticSymbolCache = /*#__PURE__*/function () {
      function _class() {
        _classCallCheck(this, _class);

        this.cache = new Map();
      }

      _createClass(_class, [{
        key: "get",
        value: function get(e, t, r) {
          var s = (r = r || []).length ? ".".concat(r.join(".")) : "",
              i = '"'.concat(e, '".').concat(t).concat(s);
          var o = this.cache.get(i);
          return o || (o = new n(e, t, r), this.cache.set(i, o)), o;
        }
      }]);

      return _class;
    }();
  }),
      s = t(function (t, n) {
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    var r = /-+([a-z0-9])/g;

    function s(e, t, n) {
      var r = e.indexOf(t);
      return -1 == r ? n : [e.slice(0, r).trim(), e.slice(r + 1).trim()];
    }

    function i(e, t, n) {
      return Array.isArray(e) ? t.visitArray(e, n) : "object" == typeof (r = e) && null !== r && Object.getPrototypeOf(r) === u ? t.visitStringMap(e, n) : null == e || "string" == typeof e || "number" == typeof e || "boolean" == typeof e ? t.visitPrimitive(e, n) : t.visitOther(e, n);
      var r;
    }

    n.dashCaseToCamelCase = function (e) {
      return e.replace(r, function () {
        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }

        return e[1].toUpperCase();
      });
    }, n.splitAtColon = function (e, t) {
      return s(e, ":", t);
    }, n.splitAtPeriod = function (e, t) {
      return s(e, ".", t);
    }, n.visitValue = i, n.isDefined = function (e) {
      return null != e;
    }, n.noUndefined = function (e) {
      return void 0 === e ? null : e;
    };
    n.ValueTransformer = /*#__PURE__*/function () {
      function _class2() {
        _classCallCheck(this, _class2);
      }

      _createClass(_class2, [{
        key: "visitArray",
        value: function visitArray(e, t) {
          var _this = this;

          return e.map(function (e) {
            return i(e, _this, t);
          });
        }
      }, {
        key: "visitStringMap",
        value: function visitStringMap(e, t) {
          var _this2 = this;

          var n = {};
          return Object.keys(e).forEach(function (r) {
            n[r] = i(e[r], _this2, t);
          }), n;
        }
      }, {
        key: "visitPrimitive",
        value: function visitPrimitive(e, t) {
          return e;
        }
      }, {
        key: "visitOther",
        value: function visitOther(e, t) {
          return e;
        }
      }]);

      return _class2;
    }(), n.SyncAsync = {
      assertSync: function assertSync(e) {
        if (c(e)) throw new Error("Illegal state: value cannot be a promise");
        return e;
      },
      then: function then(e, t) {
        return c(e) ? e.then(t) : t(e);
      },
      all: function all(e) {
        return e.some(c) ? Promise.all(e) : e;
      }
    }, n.error = function (e) {
      throw new Error("Internal Error: ".concat(e));
    }, n.syntaxError = function (e, t) {
      var n = Error(e);
      return n[o] = !0, t && (n[a] = t), n;
    };
    var o = "ngSyntaxError",
        a = "ngParseErrors";
    n.isSyntaxError = function (e) {
      return e[o];
    }, n.getParseErrors = function (e) {
      return e[a] || [];
    }, n.escapeRegExp = function (e) {
      return e.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
    };
    var u = Object.getPrototypeOf({});

    function c(e) {
      return !!e && "function" == typeof e.then;
    }

    n.utf8Encode = function (e) {
      var t = "";

      for (var _n3 = 0; _n3 < e.length; _n3++) {
        var _r = e.charCodeAt(_n3);

        if (_r >= 55296 && _r <= 56319 && e.length > _n3 + 1) {
          var _t2 = e.charCodeAt(_n3 + 1);

          _t2 >= 56320 && _t2 <= 57343 && (_n3++, _r = (_r - 55296 << 10) + _t2 - 56320 + 65536);
        }

        _r <= 127 ? t += String.fromCharCode(_r) : _r <= 2047 ? t += String.fromCharCode(_r >> 6 & 31 | 192, 63 & _r | 128) : _r <= 65535 ? t += String.fromCharCode(_r >> 12 | 224, _r >> 6 & 63 | 128, 63 & _r | 128) : _r <= 2097151 && (t += String.fromCharCode(_r >> 18 & 7 | 240, _r >> 12 & 63 | 128, _r >> 6 & 63 | 128, 63 & _r | 128));
      }

      return t;
    }, n.stringify = function e(t) {
      if ("string" == typeof t) return t;
      if (t instanceof Array) return "[" + t.map(e).join(", ") + "]";
      if (null == t) return "" + t;
      if (t.overriddenName) return "".concat(t.overriddenName);
      if (t.name) return "".concat(t.name);
      if (!t.toString) return "object";
      var n = t.toString();
      if (null == n) return "" + n;
      var r = n.indexOf("\n");
      return -1 === r ? n : n.substring(0, r);
    }, n.resolveForwardRef = function (e) {
      return "function" == typeof e && e.hasOwnProperty("__forward_ref__") ? e() : e;
    }, n.isPromise = c;

    n.Version = /*#__PURE__*/function () {
      function _class3(e) {
        _classCallCheck(this, _class3);

        this.full = e;
        var t = e.split(".");
        this.major = t[0], this.minor = t[1], this.patch = t.slice(2).join(".");
      }

      return _class3;
    }();

    var l = "undefined" != typeof window && window,
        p = "undefined" != typeof self && "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope && self,
        D = void 0 !== e && e || l || p;
    n.global = D;
  }),
      i = t(function (e, t) {
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;

    function i(e) {
      return e.replace(/\W/g, "_");
    }

    t.sanitizeIdentifier = i;
    var o = 0;

    function a(e) {
      if (!e || !e.reference) return null;
      var t = e.reference;
      if (t instanceof r.StaticSymbol) return t.name;
      if (t.__anonymousType) return t.__anonymousType;
      var n = s.stringify(t);
      return n.indexOf("(") >= 0 ? (n = "anonymous_".concat(o++), t.__anonymousType = n) : n = i(n), n;
    }

    var u;
    t.identifierName = a, t.identifierModuleUrl = function (e) {
      var t = e.reference;
      return t instanceof r.StaticSymbol ? t.filePath : "./".concat(s.stringify(t));
    }, t.viewClassName = function (e, t) {
      return "View_".concat(a({
        reference: e
      }), "_").concat(t);
    }, t.rendererTypeName = function (e) {
      return "RenderType_".concat(a({
        reference: e
      }));
    }, t.hostViewClassName = function (e) {
      return "HostView_".concat(a({
        reference: e
      }));
    }, t.componentFactoryName = function (e) {
      return "".concat(a({
        reference: e
      }), "NgFactory");
    }, function (e) {
      e[e.Pipe = 0] = "Pipe", e[e.Directive = 1] = "Directive", e[e.NgModule = 2] = "NgModule", e[e.Injectable = 3] = "Injectable";
    }(u = t.CompileSummaryKind || (t.CompileSummaryKind = {})), t.tokenName = function (e) {
      return null != e.value ? i(e.value) : a(e.identifier);
    }, t.tokenReference = function (e) {
      return null != e.identifier ? e.identifier.reference : e.value;
    };

    t.CompileStylesheetMetadata = /*#__PURE__*/function () {
      function _class4() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            e = _ref.moduleUrl,
            t = _ref.styles,
            n = _ref.styleUrls;

        _classCallCheck(this, _class4);

        this.moduleUrl = e || null, this.styles = l(t), this.styleUrls = l(n);
      }

      return _class4;
    }();

    t.CompileTemplateMetadata = /*#__PURE__*/function () {
      function _class5(_ref2) {
        var e = _ref2.encapsulation,
            t = _ref2.template,
            n = _ref2.templateUrl,
            r = _ref2.htmlAst,
            s = _ref2.styles,
            i = _ref2.styleUrls,
            o = _ref2.externalStylesheets,
            a = _ref2.animations,
            u = _ref2.ngContentSelectors,
            c = _ref2.interpolation,
            D = _ref2.isInline,
            h = _ref2.preserveWhitespaces;

        _classCallCheck(this, _class5);

        if (this.encapsulation = e, this.template = t, this.templateUrl = n, this.htmlAst = r, this.styles = l(s), this.styleUrls = l(i), this.externalStylesheets = l(o), this.animations = a ? p(a) : [], this.ngContentSelectors = u || [], c && 2 != c.length) throw new Error("'interpolation' should have a start and an end symbol.");
        this.interpolation = c, this.isInline = D, this.preserveWhitespaces = h;
      }

      _createClass(_class5, [{
        key: "toSummary",
        value: function toSummary() {
          return {
            ngContentSelectors: this.ngContentSelectors,
            encapsulation: this.encapsulation,
            styles: this.styles,
            animations: this.animations
          };
        }
      }]);

      return _class5;
    }();

    var c = /*#__PURE__*/function () {
      function c(_ref3) {
        var e = _ref3.isHost,
            t = _ref3.type,
            n = _ref3.isComponent,
            r = _ref3.selector,
            s = _ref3.exportAs,
            i = _ref3.changeDetection,
            o = _ref3.inputs,
            a = _ref3.outputs,
            u = _ref3.hostListeners,
            _c = _ref3.hostProperties,
            p = _ref3.hostAttributes,
            D = _ref3.providers,
            h = _ref3.viewProviders,
            d = _ref3.queries,
            f = _ref3.guards,
            m = _ref3.viewQueries,
            g = _ref3.entryComponents,
            E = _ref3.template,
            C = _ref3.componentViewType,
            T = _ref3.rendererType,
            y = _ref3.componentFactory;

        _classCallCheck(this, c);

        this.isHost = !!e, this.type = t, this.isComponent = n, this.selector = r, this.exportAs = s, this.changeDetection = i, this.inputs = o, this.outputs = a, this.hostListeners = u, this.hostProperties = _c, this.hostAttributes = p, this.providers = l(D), this.viewProviders = l(h), this.queries = l(d), this.guards = f, this.viewQueries = l(m), this.entryComponents = l(g), this.template = E, this.componentViewType = C, this.rendererType = T, this.componentFactory = y;
      }

      _createClass(c, [{
        key: "toSummary",
        value: function toSummary() {
          return {
            summaryKind: u.Directive,
            type: this.type,
            isComponent: this.isComponent,
            selector: this.selector,
            exportAs: this.exportAs,
            inputs: this.inputs,
            outputs: this.outputs,
            hostListeners: this.hostListeners,
            hostProperties: this.hostProperties,
            hostAttributes: this.hostAttributes,
            providers: this.providers,
            viewProviders: this.viewProviders,
            queries: this.queries,
            guards: this.guards,
            viewQueries: this.viewQueries,
            entryComponents: this.entryComponents,
            changeDetection: this.changeDetection,
            template: this.template && this.template.toSummary(),
            componentViewType: this.componentViewType,
            rendererType: this.rendererType,
            componentFactory: this.componentFactory
          };
        }
      }], [{
        key: "create",
        value: function create(_ref4) {
          var e = _ref4.isHost,
              t = _ref4.type,
              r = _ref4.isComponent,
              i = _ref4.selector,
              o = _ref4.exportAs,
              a = _ref4.changeDetection,
              u = _ref4.inputs,
              l = _ref4.outputs,
              p = _ref4.host,
              D = _ref4.providers,
              h = _ref4.viewProviders,
              d = _ref4.queries,
              f = _ref4.guards,
              m = _ref4.viewQueries,
              g = _ref4.entryComponents,
              E = _ref4.template,
              C = _ref4.componentViewType,
              T = _ref4.rendererType,
              y = _ref4.componentFactory;
          var S = {},
              _ = {},
              b = {};
          null != p && Object.keys(p).forEach(function (e) {
            var t = p[e],
                r = e.match(n);
            null === r ? b[e] = t : null != r[1] ? _[r[1]] = t : null != r[2] && (S[r[2]] = t);
          });
          var F = {};
          null != u && u.forEach(function (e) {
            var t = s.splitAtColon(e, [e, e]);
            F[t[0]] = t[1];
          });
          var A = {};
          return null != l && l.forEach(function (e) {
            var t = s.splitAtColon(e, [e, e]);
            A[t[0]] = t[1];
          }), new c({
            isHost: e,
            type: t,
            isComponent: !!r,
            selector: i,
            exportAs: o,
            changeDetection: a,
            inputs: F,
            outputs: A,
            hostListeners: S,
            hostProperties: _,
            hostAttributes: b,
            providers: D,
            viewProviders: h,
            queries: d,
            guards: f,
            viewQueries: m,
            entryComponents: g,
            template: E,
            componentViewType: C,
            rendererType: T,
            componentFactory: y
          });
        }
      }]);

      return c;
    }();

    t.CompileDirectiveMetadata = c;

    t.CompilePipeMetadata = /*#__PURE__*/function () {
      function _class6(_ref5) {
        var e = _ref5.type,
            t = _ref5.name,
            n = _ref5.pure;

        _classCallCheck(this, _class6);

        this.type = e, this.name = t, this.pure = !!n;
      }

      _createClass(_class6, [{
        key: "toSummary",
        value: function toSummary() {
          return {
            summaryKind: u.Pipe,
            type: this.type,
            name: this.name,
            pure: this.pure
          };
        }
      }]);

      return _class6;
    }();

    t.CompileShallowModuleMetadata = /*#__PURE__*/function () {
      function _class7() {
        _classCallCheck(this, _class7);
      }

      return _class7;
    }();

    t.CompileNgModuleMetadata = /*#__PURE__*/function () {
      function _class8(_ref6) {
        var e = _ref6.type,
            t = _ref6.providers,
            n = _ref6.declaredDirectives,
            r = _ref6.exportedDirectives,
            s = _ref6.declaredPipes,
            i = _ref6.exportedPipes,
            o = _ref6.entryComponents,
            a = _ref6.bootstrapComponents,
            u = _ref6.importedModules,
            c = _ref6.exportedModules,
            p = _ref6.schemas,
            D = _ref6.transitiveModule,
            h = _ref6.id;

        _classCallCheck(this, _class8);

        this.type = e || null, this.declaredDirectives = l(n), this.exportedDirectives = l(r), this.declaredPipes = l(s), this.exportedPipes = l(i), this.providers = l(t), this.entryComponents = l(o), this.bootstrapComponents = l(a), this.importedModules = l(u), this.exportedModules = l(c), this.schemas = l(p), this.id = h || null, this.transitiveModule = D || null;
      }

      _createClass(_class8, [{
        key: "toSummary",
        value: function toSummary() {
          var e = this.transitiveModule;
          return {
            summaryKind: u.NgModule,
            type: this.type,
            entryComponents: e.entryComponents,
            providers: e.providers,
            modules: e.modules,
            exportedDirectives: e.exportedDirectives,
            exportedPipes: e.exportedPipes
          };
        }
      }]);

      return _class8;
    }();

    function l(e) {
      return e || [];
    }

    t.TransitiveCompileNgModuleMetadata = /*#__PURE__*/function () {
      function _class9() {
        _classCallCheck(this, _class9);

        this.directivesSet = new Set(), this.directives = [], this.exportedDirectivesSet = new Set(), this.exportedDirectives = [], this.pipesSet = new Set(), this.pipes = [], this.exportedPipesSet = new Set(), this.exportedPipes = [], this.modulesSet = new Set(), this.modules = [], this.entryComponentsSet = new Set(), this.entryComponents = [], this.providers = [];
      }

      _createClass(_class9, [{
        key: "addProvider",
        value: function addProvider(e, t) {
          this.providers.push({
            provider: e,
            module: t
          });
        }
      }, {
        key: "addDirective",
        value: function addDirective(e) {
          this.directivesSet.has(e.reference) || (this.directivesSet.add(e.reference), this.directives.push(e));
        }
      }, {
        key: "addExportedDirective",
        value: function addExportedDirective(e) {
          this.exportedDirectivesSet.has(e.reference) || (this.exportedDirectivesSet.add(e.reference), this.exportedDirectives.push(e));
        }
      }, {
        key: "addPipe",
        value: function addPipe(e) {
          this.pipesSet.has(e.reference) || (this.pipesSet.add(e.reference), this.pipes.push(e));
        }
      }, {
        key: "addExportedPipe",
        value: function addExportedPipe(e) {
          this.exportedPipesSet.has(e.reference) || (this.exportedPipesSet.add(e.reference), this.exportedPipes.push(e));
        }
      }, {
        key: "addModule",
        value: function addModule(e) {
          this.modulesSet.has(e.reference) || (this.modulesSet.add(e.reference), this.modules.push(e));
        }
      }, {
        key: "addEntryComponent",
        value: function addEntryComponent(e) {
          this.entryComponentsSet.has(e.componentType) || (this.entryComponentsSet.add(e.componentType), this.entryComponents.push(e));
        }
      }]);

      return _class9;
    }();

    function p(e) {
      return e.reduce(function (e, t) {
        var n = Array.isArray(t) ? p(t) : t;
        return e.concat(n);
      }, []);
    }

    function D(e) {
      return e.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
    }

    t.ProviderMeta = /*#__PURE__*/function () {
      function _class10(e, _ref7) {
        var t = _ref7.useClass,
            n = _ref7.useValue,
            r = _ref7.useExisting,
            s = _ref7.useFactory,
            i = _ref7.deps,
            o = _ref7.multi;

        _classCallCheck(this, _class10);

        this.token = e, this.useClass = t || null, this.useValue = n, this.useExisting = r, this.useFactory = s || null, this.dependencies = i || null, this.multi = !!o;
      }

      return _class10;
    }(), t.flatten = p, t.templateSourceUrl = function (e, t, n) {
      var s;
      return s = n.isInline ? t.type.reference instanceof r.StaticSymbol ? "".concat(t.type.reference.filePath, ".").concat(t.type.reference.name, ".html") : "".concat(a(e), "/").concat(a(t.type), ".html") : n.templateUrl, t.type.reference instanceof r.StaticSymbol ? s : D(s);
    }, t.sharedStylesheetJitUrl = function (e, t) {
      var n = e.moduleUrl.split(/\/\\/g),
          r = n[n.length - 1];
      return D("css/".concat(t).concat(r, ".ngstyle.js"));
    }, t.ngModuleJitUrl = function (e) {
      return D("".concat(a(e.type), "/module.ngfactory.js"));
    }, t.templateJitUrl = function (e, t) {
      return D("".concat(a(e), "/").concat(a(t.type), ".ngfactory.js"));
    };
  }),
      o = t(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */

    var r = /*#__PURE__*/function () {
      function r(e, t, n, _r2) {
        _classCallCheck(this, r);

        this.file = e, this.offset = t, this.line = n, this.col = _r2;
      }

      _createClass(r, [{
        key: "toString",
        value: function toString() {
          return null != this.offset ? "".concat(this.file.url, "@").concat(this.line, ":").concat(this.col) : this.file.url;
        }
      }, {
        key: "moveBy",
        value: function moveBy(e) {
          var t = this.file.content,
              s = t.length;
          var i = this.offset,
              o = this.line,
              a = this.col;

          for (; i > 0 && e < 0;) {
            i--, e++;

            if (t.charCodeAt(i) == n.$LF) {
              o--;

              var _e2 = t.substr(0, i - 1).lastIndexOf(String.fromCharCode(n.$LF));

              a = _e2 > 0 ? i - _e2 : i;
            } else a--;
          }

          for (; i < s && e > 0;) {
            var _r5 = t.charCodeAt(i);

            i++, e--, _r5 == n.$LF ? (o++, a = 0) : a++;
          }

          return new r(this.file, i, o, a);
        }
      }, {
        key: "getContext",
        value: function getContext(e, t) {
          var n = this.file.content;
          var _r4 = this.offset;

          if (null != _r4) {
            _r4 > n.length - 1 && (_r4 = n.length - 1);
            var _s = _r4,
                _i = 0,
                _o = 0;

            for (; _i < e && _r4 > 0 && (_r4--, _i++, "\n" != n[_r4] || ++_o != t);) {
              ;
            }

            for (_i = 0, _o = 0; _i < e && _s < n.length - 1 && (_s++, _i++, "\n" != n[_s] || ++_o != t);) {
              ;
            }

            return {
              before: n.substring(_r4, this.offset),
              after: n.substring(this.offset, _s + 1)
            };
          }

          return null;
        }
      }]);

      return r;
    }();

    t.ParseLocation = r;

    var s = function s(e, t) {
      _classCallCheck(this, s);

      this.content = e, this.url = t;
    };

    t.ParseSourceFile = s;

    var o = /*#__PURE__*/function () {
      function o(e, t) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        _classCallCheck(this, o);

        this.start = e, this.end = t, this.details = n;
      }

      _createClass(o, [{
        key: "toString",
        value: function toString() {
          return this.start.file.content.substring(this.start.offset, this.end.offset);
        }
      }]);

      return o;
    }();

    var a;
    t.ParseSourceSpan = o, t.EMPTY_PARSE_LOCATION = new r(new s("", ""), 0, 0, 0), t.EMPTY_SOURCE_SPAN = new o(t.EMPTY_PARSE_LOCATION, t.EMPTY_PARSE_LOCATION), function (e) {
      e[e.WARNING = 0] = "WARNING", e[e.ERROR = 1] = "ERROR";
    }(a = t.ParseErrorLevel || (t.ParseErrorLevel = {}));
    t.ParseError = /*#__PURE__*/function () {
      function _class11(e, t) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : a.ERROR;

        _classCallCheck(this, _class11);

        this.span = e, this.msg = t, this.level = n;
      }

      _createClass(_class11, [{
        key: "contextualMessage",
        value: function contextualMessage() {
          var e = this.span.start.getContext(100, 3);
          return e ? "".concat(this.msg, ' ("').concat(e.before, "[").concat(a[this.level], " ->]").concat(e.after, '")') : this.msg;
        }
      }, {
        key: "toString",
        value: function toString() {
          var e = this.span.details ? ", ".concat(this.span.details) : "";
          return "".concat(this.contextualMessage(), ": ").concat(this.span.start).concat(e);
        }
      }]);

      return _class11;
    }(), t.typeSourceSpan = function (e, t) {
      var n = i.identifierModuleUrl(t),
          a = null != n ? "in ".concat(e, " ").concat(i.identifierName(t), " in ").concat(n) : "in ".concat(e, " ").concat(i.identifierName(t)),
          u = new s("", a);
      return new o(new r(u, -1, -1, -1), new r(u, -1, -1, -1));
    }, t.r3JitTypeSourceSpan = function (e, t, n) {
      var i = "in ".concat(e, " ").concat(t, " in ").concat(n),
          a = new s("", i);
      return new o(new r(a, -1, -1, -1), new r(a, -1, -1, -1));
    };
  }),
      a = function a(e) {
    if ("string" != typeof e) throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  };

  function u(e) {
    return {
      type: "concat",
      parts: e
    };
  }

  function c(e) {
    return {
      type: "indent",
      contents: e
    };
  }

  function l(e, t) {
    return {
      type: "align",
      contents: t,
      n: e
    };
  }

  function p(e, t) {
    return {
      type: "group",
      id: (t = t || {}).id,
      contents: e,
      break: !!t.shouldBreak,
      expandedStates: t.expandedStates
    };
  }

  var D = {
    type: "break-parent"
  },
      h = u([{
    type: "line",
    hard: !0
  }, D]),
      d = u([{
    type: "line",
    hard: !0,
    literal: !0
  }, D]);

  var f = {
    concat: u,
    join: function join(e, t) {
      var n = [];

      for (var _r6 = 0; _r6 < t.length; _r6++) {
        0 !== _r6 && n.push(e), n.push(t[_r6]);
      }

      return u(n);
    },
    line: {
      type: "line"
    },
    softline: {
      type: "line",
      soft: !0
    },
    hardline: h,
    literalline: d,
    group: p,
    conditionalGroup: function conditionalGroup(e, t) {
      return p(e[0], Object.assign({}, t, {
        expandedStates: e
      }));
    },
    fill: function fill(e) {
      return {
        type: "fill",
        parts: e
      };
    },
    lineSuffix: function lineSuffix(e) {
      return {
        type: "line-suffix",
        contents: e
      };
    },
    lineSuffixBoundary: {
      type: "line-suffix-boundary"
    },
    cursor: {
      type: "cursor",
      placeholder: Symbol("cursor")
    },
    breakParent: D,
    ifBreak: function ifBreak(e, t, n) {
      return {
        type: "if-break",
        breakContents: e,
        flatContents: t,
        groupId: (n = n || {}).groupId
      };
    },
    trim: {
      type: "trim"
    },
    indent: c,
    align: l,
    addAlignmentToDoc: function addAlignmentToDoc(e, t, n) {
      var r = e;

      if (t > 0) {
        for (var _e3 = 0; _e3 < Math.floor(t / n); ++_e3) {
          r = c(r);
        }

        r = l(t % n, r), r = l(-1 / 0, r);
      }

      return r;
    },
    markAsRoot: function markAsRoot(e) {
      return l({
        type: "root"
      }, e);
    },
    dedentToRoot: function dedentToRoot(e) {
      return l(-1 / 0, e);
    },
    dedent: function dedent(e) {
      return l(-1, e);
    }
  },
      m = function m(e) {
    return "string" == typeof e ? e.replace(function () {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref8$onlyFirst = _ref8.onlyFirst,
          e = _ref8$onlyFirst === void 0 ? !1 : _ref8$onlyFirst;

      var t = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:[a-zA-Z\\d]*(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
      return new RegExp(t, e ? void 0 : "g");
    }(), "") : e;
  };

  var g = function g(e) {
    return !Number.isNaN(e) && e >= 4352 && (e <= 4447 || 9001 === e || 9002 === e || 11904 <= e && e <= 12871 && 12351 !== e || 12880 <= e && e <= 19903 || 19968 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510 || 110592 <= e && e <= 110593 || 127488 <= e && e <= 127569 || 131072 <= e && e <= 262141);
  };

  var E = g,
      C = g;
  E.default = C;

  var T = function T(e) {
    if ("string" != typeof (e = e.replace(/\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g, "  ")) || 0 === e.length) return 0;
    e = m(e);
    var t = 0;

    for (var _n4 = 0; _n4 < e.length; _n4++) {
      var _r7 = e.codePointAt(_n4);

      _r7 <= 31 || _r7 >= 127 && _r7 <= 159 || _r7 >= 768 && _r7 <= 879 || (_r7 > 65535 && _n4++, t += E(_r7) ? 2 : 1);
    }

    return t;
  };

  var y = T,
      S = T;
  y.default = S;

  function _(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }

  var b = "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};

  function F() {
    throw new Error("setTimeout has not been defined");
  }

  function A() {
    throw new Error("clearTimeout has not been defined");
  }

  var v = F,
      w = A;

  function k(e) {
    if (v === setTimeout) return setTimeout(e, 0);
    if ((v === F || !v) && setTimeout) return v = setTimeout, setTimeout(e, 0);

    try {
      return v(e, 0);
    } catch (t) {
      try {
        return v.call(null, e, 0);
      } catch (t) {
        return v.call(this, e, 0);
      }
    }
  }

  "function" == typeof b.setTimeout && (v = setTimeout), "function" == typeof b.clearTimeout && (w = clearTimeout);
  var N,
      x = [],
      O = !1,
      R = -1;

  function P() {
    O && N && (O = !1, N.length ? x = N.concat(x) : R = -1, x.length && L());
  }

  function L() {
    if (!O) {
      var e = k(P);
      O = !0;

      for (var t = x.length; t;) {
        for (N = x, x = []; ++R < t;) {
          N && N[R].run();
        }

        R = -1, t = x.length;
      }

      N = null, O = !1, function (e) {
        if (w === clearTimeout) return clearTimeout(e);
        if ((w === A || !w) && clearTimeout) return w = clearTimeout, clearTimeout(e);

        try {
          w(e);
        } catch (t) {
          try {
            return w.call(null, e);
          } catch (t) {
            return w.call(this, e);
          }
        }
      }(e);
    }
  }

  function B(e, t) {
    this.fun = e, this.array = t;
  }

  B.prototype.run = function () {
    this.fun.apply(null, this.array);
  };

  function I() {}

  var q = I,
      $ = I,
      M = I,
      U = I,
      G = I,
      V = I,
      j = I;

  var H = b.performance || {},
      X = H.now || H.mozNow || H.msNow || H.oNow || H.webkitNow || function () {
    return new Date().getTime();
  };

  var z = new Date();
  var W = {
    nextTick: function nextTick(e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      x.push(new B(e, t)), 1 !== x.length || O || k(L);
    },
    title: "browser",
    browser: !0,
    env: {},
    argv: [],
    version: "",
    versions: {},
    on: q,
    addListener: $,
    once: M,
    off: U,
    removeListener: G,
    removeAllListeners: V,
    emit: j,
    binding: function binding(e) {
      throw new Error("process.binding is not supported");
    },
    cwd: function cwd() {
      return "/";
    },
    chdir: function chdir(e) {
      throw new Error("process.chdir is not supported");
    },
    umask: function umask() {
      return 0;
    },
    hrtime: function hrtime(e) {
      var t = .001 * X.call(H),
          n = Math.floor(t),
          r = Math.floor(t % 1 * 1e9);
      return e && (n -= e[0], (r -= e[1]) < 0 && (n--, r += 1e9)), [n, r];
    },
    platform: "browser",
    release: {},
    config: {},
    uptime: function uptime() {
      return (new Date() - z) / 1e3;
    }
  };
  var Q = "object" == typeof W && W.env && W.env.NODE_DEBUG && /\bsemver\b/i.test(W.env.NODE_DEBUG) ? function () {
    var _console;

    for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      e[_key2] = arguments[_key2];
    }

    return (_console = console).error.apply(_console, ["SEMVER"].concat(e));
  } : function () {};
  var Y = {
    SEMVER_SPEC_VERSION: "2.0.0",
    MAX_LENGTH: 256,
    MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER || 9007199254740991,
    MAX_SAFE_COMPONENT_LENGTH: 16
  },
      J = t(function (e, t) {
    var n = Y.MAX_SAFE_COMPONENT_LENGTH,
        r = (t = e.exports = {}).re = [],
        s = t.src = [],
        i = t.t = {};
    var o = 0;

    var a = function a(e, t, n) {
      var a = o++;
      Q(a, t), i[e] = a, s[a] = t, r[a] = new RegExp(t, n ? "g" : void 0);
    };

    a("NUMERICIDENTIFIER", "0|[1-9]\\d*"), a("NUMERICIDENTIFIERLOOSE", "[0-9]+"), a("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), a("MAINVERSION", "(".concat(s[i.NUMERICIDENTIFIER], ")\\.") + "(".concat(s[i.NUMERICIDENTIFIER], ")\\.") + "(".concat(s[i.NUMERICIDENTIFIER], ")")), a("MAINVERSIONLOOSE", "(".concat(s[i.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(s[i.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(s[i.NUMERICIDENTIFIERLOOSE], ")")), a("PRERELEASEIDENTIFIER", "(?:".concat(s[i.NUMERICIDENTIFIER], "|").concat(s[i.NONNUMERICIDENTIFIER], ")")), a("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(s[i.NUMERICIDENTIFIERLOOSE], "|").concat(s[i.NONNUMERICIDENTIFIER], ")")), a("PRERELEASE", "(?:-(".concat(s[i.PRERELEASEIDENTIFIER], "(?:\\.").concat(s[i.PRERELEASEIDENTIFIER], ")*))")), a("PRERELEASELOOSE", "(?:-?(".concat(s[i.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(s[i.PRERELEASEIDENTIFIERLOOSE], ")*))")), a("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), a("BUILD", "(?:\\+(".concat(s[i.BUILDIDENTIFIER], "(?:\\.").concat(s[i.BUILDIDENTIFIER], ")*))")), a("FULLPLAIN", "v?".concat(s[i.MAINVERSION]).concat(s[i.PRERELEASE], "?").concat(s[i.BUILD], "?")), a("FULL", "^".concat(s[i.FULLPLAIN], "$")), a("LOOSEPLAIN", "[v=\\s]*".concat(s[i.MAINVERSIONLOOSE]).concat(s[i.PRERELEASELOOSE], "?").concat(s[i.BUILD], "?")), a("LOOSE", "^".concat(s[i.LOOSEPLAIN], "$")), a("GTLT", "((?:<|>)?=?)"), a("XRANGEIDENTIFIERLOOSE", "".concat(s[i.NUMERICIDENTIFIERLOOSE], "|x|X|\\*")), a("XRANGEIDENTIFIER", "".concat(s[i.NUMERICIDENTIFIER], "|x|X|\\*")), a("XRANGEPLAIN", "[v=\\s]*(".concat(s[i.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(s[i.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(s[i.XRANGEIDENTIFIER], ")") + "(?:".concat(s[i.PRERELEASE], ")?").concat(s[i.BUILD], "?") + ")?)?"), a("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(s[i.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(s[i.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(s[i.XRANGEIDENTIFIERLOOSE], ")") + "(?:".concat(s[i.PRERELEASELOOSE], ")?").concat(s[i.BUILD], "?") + ")?)?"), a("XRANGE", "^".concat(s[i.GTLT], "\\s*").concat(s[i.XRANGEPLAIN], "$")), a("XRANGELOOSE", "^".concat(s[i.GTLT], "\\s*").concat(s[i.XRANGEPLAINLOOSE], "$")), a("COERCE", "".concat("(^|[^\\d])(\\d{1,").concat(n, "})") + "(?:\\.(\\d{1,".concat(n, "}))?") + "(?:\\.(\\d{1,".concat(n, "}))?") + "(?:$|[^\\d])"), a("COERCERTL", s[i.COERCE], !0), a("LONETILDE", "(?:~>?)"), a("TILDETRIM", "(\\s*)".concat(s[i.LONETILDE], "\\s+"), !0), t.tildeTrimReplace = "$1~", a("TILDE", "^".concat(s[i.LONETILDE]).concat(s[i.XRANGEPLAIN], "$")), a("TILDELOOSE", "^".concat(s[i.LONETILDE]).concat(s[i.XRANGEPLAINLOOSE], "$")), a("LONECARET", "(?:\\^)"), a("CARETTRIM", "(\\s*)".concat(s[i.LONECARET], "\\s+"), !0), t.caretTrimReplace = "$1^", a("CARET", "^".concat(s[i.LONECARET]).concat(s[i.XRANGEPLAIN], "$")), a("CARETLOOSE", "^".concat(s[i.LONECARET]).concat(s[i.XRANGEPLAINLOOSE], "$")), a("COMPARATORLOOSE", "^".concat(s[i.GTLT], "\\s*(").concat(s[i.LOOSEPLAIN], ")$|^$")), a("COMPARATOR", "^".concat(s[i.GTLT], "\\s*(").concat(s[i.FULLPLAIN], ")$|^$")), a("COMPARATORTRIM", "(\\s*)".concat(s[i.GTLT], "\\s*(").concat(s[i.LOOSEPLAIN], "|").concat(s[i.XRANGEPLAIN], ")"), !0), t.comparatorTrimReplace = "$1$2$3", a("HYPHENRANGE", "^\\s*(".concat(s[i.XRANGEPLAIN], ")") + "\\s+-\\s+" + "(".concat(s[i.XRANGEPLAIN], ")") + "\\s*$"), a("HYPHENRANGELOOSE", "^\\s*(".concat(s[i.XRANGEPLAINLOOSE], ")") + "\\s+-\\s+" + "(".concat(s[i.XRANGEPLAINLOOSE], ")") + "\\s*$"), a("STAR", "(<|>)?=?\\s*\\*"), a("GTE0", "^\\s*>=\\s*0.0.0\\s*$"), a("GTE0PRE", "^\\s*>=\\s*0.0.0-0\\s*$");
  });

  var Z = /^[0-9]+$/,
      K = function K(e, t) {
    var n = Z.test(e),
        r = Z.test(t);
    return n && r && (e = +e, t = +t), e === t ? 0 : n && !r ? -1 : r && !n ? 1 : e < t ? -1 : 1;
  };

  var ee = {
    compareIdentifiers: K,
    rcompareIdentifiers: function rcompareIdentifiers(e, t) {
      return K(t, e);
    }
  };
  var te = Y.MAX_LENGTH,
      ne = Y.MAX_SAFE_INTEGER,
      re = J.re,
      se = J.t,
      ie = ee.compareIdentifiers;

  var oe = /*#__PURE__*/function () {
    function oe(e, t) {
      _classCallCheck(this, oe);

      if (t && "object" == typeof t || (t = {
        loose: !!t,
        includePrerelease: !1
      }), e instanceof oe) {
        if (e.loose === !!t.loose && e.includePrerelease === !!t.includePrerelease) return e;
        e = e.version;
      } else if ("string" != typeof e) throw new TypeError("Invalid Version: ".concat(e));

      if (e.length > te) throw new TypeError("version is longer than ".concat(te, " characters"));
      Q("SemVer", e, t), this.options = t, this.loose = !!t.loose, this.includePrerelease = !!t.includePrerelease;
      var n = e.trim().match(t.loose ? re[se.LOOSE] : re[se.FULL]);
      if (!n) throw new TypeError("Invalid Version: ".concat(e));
      if (this.raw = e, this.major = +n[1], this.minor = +n[2], this.patch = +n[3], this.major > ne || this.major < 0) throw new TypeError("Invalid major version");
      if (this.minor > ne || this.minor < 0) throw new TypeError("Invalid minor version");
      if (this.patch > ne || this.patch < 0) throw new TypeError("Invalid patch version");
      n[4] ? this.prerelease = n[4].split(".").map(function (e) {
        if (/^[0-9]+$/.test(e)) {
          var _t3 = +e;

          if (_t3 >= 0 && _t3 < ne) return _t3;
        }

        return e;
      }) : this.prerelease = [], this.build = n[5] ? n[5].split(".") : [], this.format();
    }

    _createClass(oe, [{
      key: "format",
      value: function format() {
        return this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch), this.prerelease.length && (this.version += "-".concat(this.prerelease.join("."))), this.version;
      }
    }, {
      key: "toString",
      value: function toString() {
        return this.version;
      }
    }, {
      key: "compare",
      value: function compare(e) {
        if (Q("SemVer.compare", this.version, this.options, e), !(e instanceof oe)) {
          if ("string" == typeof e && e === this.version) return 0;
          e = new oe(e, this.options);
        }

        return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
      }
    }, {
      key: "compareMain",
      value: function compareMain(e) {
        return e instanceof oe || (e = new oe(e, this.options)), ie(this.major, e.major) || ie(this.minor, e.minor) || ie(this.patch, e.patch);
      }
    }, {
      key: "comparePre",
      value: function comparePre(e) {
        if (e instanceof oe || (e = new oe(e, this.options)), this.prerelease.length && !e.prerelease.length) return -1;
        if (!this.prerelease.length && e.prerelease.length) return 1;
        if (!this.prerelease.length && !e.prerelease.length) return 0;
        var t = 0;

        do {
          var _n5 = this.prerelease[t],
              _r8 = e.prerelease[t];
          if (Q("prerelease compare", t, _n5, _r8), void 0 === _n5 && void 0 === _r8) return 0;
          if (void 0 === _r8) return 1;
          if (void 0 === _n5) return -1;
          if (_n5 !== _r8) return ie(_n5, _r8);
        } while (++t);
      }
    }, {
      key: "compareBuild",
      value: function compareBuild(e) {
        e instanceof oe || (e = new oe(e, this.options));
        var t = 0;

        do {
          var _n6 = this.build[t],
              _r9 = e.build[t];
          if (Q("prerelease compare", t, _n6, _r9), void 0 === _n6 && void 0 === _r9) return 0;
          if (void 0 === _r9) return 1;
          if (void 0 === _n6) return -1;
          if (_n6 !== _r9) return ie(_n6, _r9);
        } while (++t);
      }
    }, {
      key: "inc",
      value: function inc(e, t) {
        switch (e) {
          case "premajor":
            this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", t);
            break;

          case "preminor":
            this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", t);
            break;

          case "prepatch":
            this.prerelease.length = 0, this.inc("patch", t), this.inc("pre", t);
            break;

          case "prerelease":
            0 === this.prerelease.length && this.inc("patch", t), this.inc("pre", t);
            break;

          case "major":
            0 === this.minor && 0 === this.patch && 0 !== this.prerelease.length || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
            break;

          case "minor":
            0 === this.patch && 0 !== this.prerelease.length || this.minor++, this.patch = 0, this.prerelease = [];
            break;

          case "patch":
            0 === this.prerelease.length && this.patch++, this.prerelease = [];
            break;

          case "pre":
            if (0 === this.prerelease.length) this.prerelease = [0];else {
              var _e4 = this.prerelease.length;

              for (; --_e4 >= 0;) {
                "number" == typeof this.prerelease[_e4] && (this.prerelease[_e4]++, _e4 = -2);
              }

              -1 === _e4 && this.prerelease.push(0);
            }
            t && (this.prerelease[0] === t ? isNaN(this.prerelease[1]) && (this.prerelease = [t, 0]) : this.prerelease = [t, 0]);
            break;

          default:
            throw new Error("invalid increment argument: ".concat(e));
        }

        return this.format(), this.raw = this.version, this;
      }
    }]);

    return oe;
  }();

  var ae = oe;

  var ue = function ue(e, t, n) {
    return new ae(e, n).compare(new ae(t, n));
  };

  var ce = function ce(e, t, n) {
    return ue(e, t, n) < 0;
  };

  var le = function le(e, t, n) {
    return ue(e, t, n) >= 0;
  },
      pe = "2.2.1",
      De = t(function (e, t) {
    function n() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }
    }

    function r() {
      return "undefined" != typeof WeakMap ? new WeakMap() : {
        add: n,
        delete: n,
        get: n,
        set: n,
        has: function has(e) {
          return !1;
        }
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = Object.prototype.hasOwnProperty,
        i = function i(e, t) {
      return s.call(e, t);
    };

    function o(e, t) {
      for (var n in t) {
        i(t, n) && (e[n] = t[n]);
      }

      return e;
    }

    var a = /^[ \t]*(?:\r\n|\r|\n)/,
        u = /(?:\r\n|\r|\n)[ \t]*$/,
        c = /^(?:[\r\n]|$)/,
        l = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/,
        p = /^[ \t]*[\r\n][ \t\r\n]*$/;

    function D(e, t, n) {
      var r = 0,
          s = e[0].match(l);
      s && (r = s[1].length);
      var i = new RegExp("(\\r\\n|\\r|\\n).{0," + r + "}", "g");
      t && (e = e.slice(1));
      var o = n.newline,
          c = n.trimLeadingNewline,
          p = n.trimTrailingNewline,
          D = "string" == typeof o,
          h = e.length;
      return e.map(function (e, t) {
        return e = e.replace(i, "$1"), 0 === t && c && (e = e.replace(a, "")), t === h - 1 && p && (e = e.replace(u, "")), D && (e = e.replace(/\r\n|\n|\r/g, function (e) {
          return o;
        })), e;
      });
    }

    function h(e, t) {
      for (var n = "", r = 0, s = e.length; r < s; r++) {
        n += e[r], r < s - 1 && (n += t[r]);
      }

      return n;
    }

    function d(e) {
      return i(e, "raw") && i(e, "length");
    }

    var f = function e(t) {
      var n = r(),
          s = r();
      return o(function r(i) {
        for (var a = [], u = 1; u < arguments.length; u++) {
          a[u - 1] = arguments[u];
        }

        if (d(i)) {
          var l = i,
              m = (a[0] === r || a[0] === f) && p.test(l[0]) && c.test(l[1]),
              g = m ? s : n,
              E = g.get(l);
          if (E || (E = D(l, m, t), g.set(l, E)), 0 === a.length) return E[0];
          var C = h(E, m ? a.slice(1) : a);
          return C;
        }

        return e(o(o({}, t), i || {}));
      }, {
        string: function string(e) {
          return D([e], !1, t)[0];
        }
      });
    }({
      trimLeadingNewline: !0,
      trimTrailingNewline: !0
    });

    t.outdent = f, t.default = f;

    try {
      e.exports = f, Object.defineProperty(f, "__esModule", {
        value: !0
      }), f.default = f, f.outdent = f;
    } catch (e) {}
  });

  function he() {
    var e = _(["\n      Require either '@prettier' or '@format' to be present in the file's first docblock comment\n      in order for it to be formatted.\n    "]);

    return he = function he() {
      return e;
    }, e;
  }

  function de() {
    var e = _(["\n      Format code starting at a given character offset.\n      The range will extend backwards to the start of the first line containing the selected statement.\n      This option cannot be used with --cursor-offset.\n    "]);

    return de = function de() {
      return e;
    }, e;
  }

  function fe() {
    var e = _(["\n      Format code ending at a given character offset (exclusive).\n      The range will extend forwards to the end of the selected statement.\n      This option cannot be used with --cursor-offset.\n    "]);

    return fe = function fe() {
      return e;
    }, e;
  }

  function me() {
    var e = _(["\n      Custom directory that contains prettier plugins in node_modules subdirectory.\n      Overrides default behavior when plugins are searched relatively to the location of Prettier.\n      Multiple values are accepted.\n    "]);

    return me = function me() {
      return e;
    }, e;
  }

  function ge() {
    var e = _(["\n          Maintain existing\n          (mixed values within one file are normalised by looking at what's used after the first line)\n        "]);

    return ge = function ge() {
      return e;
    }, e;
  }

  function Ee() {
    var e = _(["\n      Print (to stderr) where a cursor at the given position would move to after formatting.\n      This option cannot be used with --range-start and --range-end.\n    "]);

    return Ee = function Ee() {
      return e;
    }, e;
  }

  var Ce = De.outdent,
      Te = "Config",
      ye = "Editor",
      Se = "Other",
      _e = "Global",
      be = "Special",
      Fe = {
    cursorOffset: {
      since: "1.4.0",
      category: be,
      type: "int",
      default: -1,
      range: {
        start: -1,
        end: 1 / 0,
        step: 1
      },
      description: Ce(Ee()),
      cliCategory: ye
    },
    endOfLine: {
      since: "1.15.0",
      category: _e,
      type: "choice",
      default: [{
        since: "1.15.0",
        value: "auto"
      }, {
        since: "2.0.0",
        value: "lf"
      }],
      description: "Which end of line characters to apply.",
      choices: [{
        value: "lf",
        description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos"
      }, {
        value: "crlf",
        description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows"
      }, {
        value: "cr",
        description: "Carriage Return character only (\\r), used very rarely"
      }, {
        value: "auto",
        description: Ce(ge())
      }]
    },
    filepath: {
      since: "1.4.0",
      category: be,
      type: "path",
      description: "Specify the input filepath. This will be used to do parser inference.",
      cliName: "stdin-filepath",
      cliCategory: Se,
      cliDescription: "Path to the file to pretend that stdin comes from."
    },
    insertPragma: {
      since: "1.8.0",
      category: be,
      type: "boolean",
      default: !1,
      description: "Insert @format pragma into file's first docblock comment.",
      cliCategory: Se
    },
    parser: {
      since: "0.0.10",
      category: _e,
      type: "choice",
      default: [{
        since: "0.0.10",
        value: "babylon"
      }, {
        since: "1.13.0",
        value: void 0
      }],
      description: "Which parser to use.",
      exception: function exception(e) {
        return "string" == typeof e || "function" == typeof e;
      },
      choices: [{
        value: "flow",
        description: "Flow"
      }, {
        value: "babel",
        since: "1.16.0",
        description: "JavaScript"
      }, {
        value: "babel-flow",
        since: "1.16.0",
        description: "Flow"
      }, {
        value: "babel-ts",
        since: "2.0.0",
        description: "TypeScript"
      }, {
        value: "typescript",
        since: "1.4.0",
        description: "TypeScript"
      }, {
        value: "espree",
        since: "2.2.0",
        description: "JavaScript"
      }, {
        value: "meriyah",
        since: "2.2.0",
        description: "JavaScript"
      }, {
        value: "css",
        since: "1.7.1",
        description: "CSS"
      }, {
        value: "less",
        since: "1.7.1",
        description: "Less"
      }, {
        value: "scss",
        since: "1.7.1",
        description: "SCSS"
      }, {
        value: "json",
        since: "1.5.0",
        description: "JSON"
      }, {
        value: "json5",
        since: "1.13.0",
        description: "JSON5"
      }, {
        value: "json-stringify",
        since: "1.13.0",
        description: "JSON.stringify"
      }, {
        value: "graphql",
        since: "1.5.0",
        description: "GraphQL"
      }, {
        value: "markdown",
        since: "1.8.0",
        description: "Markdown"
      }, {
        value: "mdx",
        since: "1.15.0",
        description: "MDX"
      }, {
        value: "vue",
        since: "1.10.0",
        description: "Vue"
      }, {
        value: "yaml",
        since: "1.14.0",
        description: "YAML"
      }, {
        value: "glimmer",
        since: null,
        description: "Handlebars"
      }, {
        value: "html",
        since: "1.15.0",
        description: "HTML"
      }, {
        value: "angular",
        since: "1.15.0",
        description: "Angular"
      }, {
        value: "lwc",
        since: "1.17.0",
        description: "Lightning Web Components"
      }]
    },
    plugins: {
      since: "1.10.0",
      type: "path",
      array: !0,
      default: [{
        value: []
      }],
      category: _e,
      description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.",
      exception: function exception(e) {
        return "string" == typeof e || "object" == typeof e;
      },
      cliName: "plugin",
      cliCategory: Te
    },
    pluginSearchDirs: {
      since: "1.13.0",
      type: "path",
      array: !0,
      default: [{
        value: []
      }],
      category: _e,
      description: Ce(me()),
      exception: function exception(e) {
        return "string" == typeof e || "object" == typeof e;
      },
      cliName: "plugin-search-dir",
      cliCategory: Te
    },
    printWidth: {
      since: "0.0.0",
      category: _e,
      type: "int",
      default: 80,
      description: "The line length where Prettier will try wrap.",
      range: {
        start: 0,
        end: 1 / 0,
        step: 1
      }
    },
    rangeEnd: {
      since: "1.4.0",
      category: be,
      type: "int",
      default: 1 / 0,
      range: {
        start: 0,
        end: 1 / 0,
        step: 1
      },
      description: Ce(fe()),
      cliCategory: ye
    },
    rangeStart: {
      since: "1.4.0",
      category: be,
      type: "int",
      default: 0,
      range: {
        start: 0,
        end: 1 / 0,
        step: 1
      },
      description: Ce(de()),
      cliCategory: ye
    },
    requirePragma: {
      since: "1.7.0",
      category: be,
      type: "boolean",
      default: !1,
      description: Ce(he()),
      cliCategory: Se
    },
    tabWidth: {
      type: "int",
      category: _e,
      default: 2,
      description: "Number of spaces per indentation level.",
      range: {
        start: 0,
        end: 1 / 0,
        step: 1
      }
    },
    useTabs: {
      since: "1.0.0",
      category: _e,
      type: "boolean",
      default: !1,
      description: "Indent with tabs instead of spaces."
    },
    embeddedLanguageFormatting: {
      since: "2.1.0",
      category: _e,
      type: "choice",
      default: [{
        since: "2.1.0",
        value: "auto"
      }],
      description: "Control how Prettier formats quoted code embedded in the file.",
      choices: [{
        value: "auto",
        description: "Format embedded code if Prettier can automatically identify it."
      }, {
        value: "off",
        description: "Never automatically format embedded code."
      }]
    }
  };
  var Ae = {
    compare: ue,
    lt: ce,
    gte: le
  },
      ve = pe,
      we = {
    CATEGORY_CONFIG: Te,
    CATEGORY_EDITOR: ye,
    CATEGORY_FORMAT: "Format",
    CATEGORY_OTHER: Se,
    CATEGORY_OUTPUT: "Output",
    CATEGORY_GLOBAL: _e,
    CATEGORY_SPECIAL: be,
    options: Fe
  }.options;
  var ke = {
    getSupportInfo: function getSupportInfo() {
      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref9$plugins = _ref9.plugins,
          e = _ref9$plugins === void 0 ? [] : _ref9$plugins,
          _ref9$showUnreleased = _ref9.showUnreleased,
          t = _ref9$showUnreleased === void 0 ? !1 : _ref9$showUnreleased,
          _ref9$showDeprecated = _ref9.showDeprecated,
          n = _ref9$showDeprecated === void 0 ? !1 : _ref9$showDeprecated,
          _ref9$showInternal = _ref9.showInternal,
          r = _ref9$showInternal === void 0 ? !1 : _ref9$showInternal;

      var s = ve.split("-", 1)[0],
          i = e.reduce(function (e, t) {
        return e.concat(t.languages || []);
      }, []).filter(a),
          o = function (e, t) {
        return Object.entries(e).map(function (_ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
              e = _ref11[0],
              n = _ref11[1];

          return Object.assign(_defineProperty({}, t, e), n);
        });
      }(Object.assign.apply(Object, [{}].concat(_toConsumableArray(e.map(function (_ref12) {
        var e = _ref12.options;
        return e;
      })), [we])), "name").filter(function (e) {
        return a(e) && u(e);
      }).sort(function (e, t) {
        return e.name === t.name ? 0 : e.name < t.name ? -1 : 1;
      }).map(function (e) {
        if (r) return e;
        return function (e, t) {
          if (null == e) return {};
          var n,
              r,
              s = {},
              i = Object.keys(e);

          for (r = 0; r < i.length; r++) {
            n = i[r], t.indexOf(n) >= 0 || (s[n] = e[n]);
          }

          return s;
        }(e, ["cliName", "cliCategory", "cliDescription"]);
      }).map(function (t) {
        t = Object.assign({}, t), Array.isArray(t.default) && (t.default = 1 === t.default.length ? t.default[0].value : t.default.filter(a).sort(function (e, t) {
          return Ae.compare(t.since, e.since);
        })[0].value), Array.isArray(t.choices) && (t.choices = t.choices.filter(function (e) {
          return a(e) && u(e);
        }), "parser" === t.name && function (e, t, n) {
          var r = new Set(e.choices.map(function (e) {
            return e.value;
          }));

          var _iterator = _createForOfIteratorHelper(t),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _s2 = _step.value;

              if (_s2.parsers) {
                var _iterator2 = _createForOfIteratorHelper(_s2.parsers),
                    _step2;

                try {
                  var _loop = function _loop() {
                    var t = _step2.value;

                    if (!r.has(t)) {
                      r.add(t);

                      var _i2 = n.find(function (e) {
                        return e.parsers && e.parsers[t];
                      });

                      var _o2 = _s2.name;
                      _i2 && _i2.name && (_o2 += " (plugin: ".concat(_i2.name, ")")), e.choices.push({
                        value: t,
                        description: _o2
                      });
                    }
                  };

                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }(t, i, e));
        var n = e.filter(function (e) {
          return e.defaultOptions && void 0 !== e.defaultOptions[t.name];
        }).reduce(function (e, n) {
          return e[n.name] = n.defaultOptions[t.name], e;
        }, {});
        return Object.assign({}, t, {
          pluginDefaults: n
        });
      });

      return {
        languages: i,
        options: o
      };

      function a(e) {
        return t || !("since" in e) || e.since && Ae.gte(s, e.since);
      }

      function u(e) {
        return n || !("deprecated" in e) || e.deprecated && Ae.lt(s, e.deprecated);
      }
    }
  };
  var Ne = ke.getSupportInfo,
      xe = /[^\x20-\x7F]/;

  function Oe(e) {
    return function (t, n, r) {
      var s = r && r.backwards;
      if (!1 === n) return !1;
      var i = t.length;
      var o = n;

      for (; o >= 0 && o < i;) {
        var _n7 = t.charAt(o);

        if (e instanceof RegExp) {
          if (!e.test(_n7)) return o;
        } else if (!e.includes(_n7)) return o;

        s ? o-- : o++;
      }

      return (-1 === o || o === i) && o;
    };
  }

  var Re = Oe(/\s/),
      Pe = Oe(" \t"),
      Le = Oe(",; \t"),
      Be = Oe(/[^\n\r]/);

  function Ie(e, t) {
    if (!1 === t) return !1;
    if ("/" === e.charAt(t) && "*" === e.charAt(t + 1)) for (var _n8 = t + 2; _n8 < e.length; ++_n8) {
      if ("*" === e.charAt(_n8) && "/" === e.charAt(_n8 + 1)) return _n8 + 2;
    }
    return t;
  }

  function qe(e, t) {
    return !1 !== t && ("/" === e.charAt(t) && "/" === e.charAt(t + 1) ? Be(e, t) : t);
  }

  function $e(e, t, n) {
    var r = n && n.backwards;
    if (!1 === t) return !1;
    var s = e.charAt(t);

    if (r) {
      if ("\r" === e.charAt(t - 1) && "\n" === s) return t - 2;
      if ("\n" === s || "\r" === s || "\u2028" === s || "\u2029" === s) return t - 1;
    } else {
      if ("\r" === s && "\n" === e.charAt(t + 1)) return t + 2;
      if ("\n" === s || "\r" === s || "\u2028" === s || "\u2029" === s) return t + 1;
    }

    return t;
  }

  function Me(e, t, n) {
    var r = Pe(e, (n = n || {}).backwards ? t - 1 : t, n);
    return r !== $e(e, r, n);
  }

  function Ue(e, t) {
    var n = null,
        r = t;

    for (; r !== n;) {
      n = r, r = Le(e, r), r = Ie(e, r), r = Pe(e, r);
    }

    return r = qe(e, r), r = $e(e, r), !1 !== r && Me(e, r);
  }

  function Ge(e, t) {
    var n = null,
        r = t;

    for (; r !== n;) {
      n = r, r = Pe(e, r), r = Ie(e, r), r = qe(e, r), r = $e(e, r);
    }

    return r;
  }

  function Ve(e, t, n) {
    return Ge(e, n(t));
  }

  function je(e, t, n) {
    var r = 0;

    for (var _s3 = n = n || 0; _s3 < e.length; ++_s3) {
      "\t" === e[_s3] ? r = r + t - r % t : r++;
    }

    return r;
  }

  function He(e, t) {
    var n = e.slice(1, -1),
        r = {
      quote: '"',
      regex: /"/g
    },
        s = {
      quote: "'",
      regex: /'/g
    },
        i = "'" === t ? s : r,
        o = i === s ? r : s;
    var a = i.quote;

    if (n.includes(i.quote) || n.includes(o.quote)) {
      a = (n.match(i.regex) || []).length > (n.match(o.regex) || []).length ? o.quote : i.quote;
    }

    return a;
  }

  function Xe(e, t, n) {
    var r = '"' === t ? "'" : '"',
        s = e.replace(/\\([\S\s])|(["'])/g, function (e, s, i) {
      return s === r ? s : i === t ? "\\" + i : i || (n && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(s) ? s : "\\" + s);
    });
    return t + s + t;
  }

  function ze(e, t) {
    (e.comments || (e.comments = [])).push(t), t.printed = !1, "JSXText" === e.type && (t.printed = !0);
  }

  var We = {
    inferParserByLanguage: function inferParserByLanguage(e, t) {
      var _Ne = Ne({
        plugins: t.plugins
      }),
          n = _Ne.languages,
          r = n.find(function (_ref13) {
        var t = _ref13.name;
        return t.toLowerCase() === e;
      }) || n.find(function (_ref14) {
        var t = _ref14.aliases;
        return Array.isArray(t) && t.includes(e);
      }) || n.find(function (_ref15) {
        var t = _ref15.extensions;
        return Array.isArray(t) && t.includes(".".concat(e));
      });

      return r && r.parsers[0];
    },
    replaceEndOfLineWith: function replaceEndOfLineWith(e, t) {
      var n = [];

      var _iterator3 = _createForOfIteratorHelper(e.split("\n")),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _r10 = _step3.value;
          0 !== n.length && n.push(t), n.push(_r10);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return n;
    },
    getStringWidth: function getStringWidth(e) {
      return e ? xe.test(e) ? y(e) : e.length : 0;
    },
    getMaxContinuousCount: function getMaxContinuousCount(e, t) {
      var n = e.match(new RegExp("(".concat(a(t), ")+"), "g"));
      return null === n ? 0 : n.reduce(function (e, n) {
        return Math.max(e, n.length / t.length);
      }, 0);
    },
    getMinNotPresentContinuousCount: function getMinNotPresentContinuousCount(e, t) {
      var n = e.match(new RegExp("(".concat(a(t), ")+"), "g"));
      if (null === n) return 0;
      var r = new Map();
      var s = 0;

      var _iterator4 = _createForOfIteratorHelper(n),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _e6 = _step4.value;

          var _n9 = _e6.length / t.length;

          r.set(_n9, !0), _n9 > s && (s = _n9);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      for (var _e5 = 1; _e5 < s; _e5++) {
        if (!r.get(_e5)) return _e5;
      }

      return s + 1;
    },
    getPenultimate: function getPenultimate(e) {
      return e[e.length - 2];
    },
    getLast: function getLast(e) {
      return e[e.length - 1];
    },
    getNextNonSpaceNonCommentCharacterIndexWithStartIndex: Ge,
    getNextNonSpaceNonCommentCharacterIndex: Ve,
    getNextNonSpaceNonCommentCharacter: function getNextNonSpaceNonCommentCharacter(e, t, n) {
      return e.charAt(Ve(e, t, n));
    },
    skip: Oe,
    skipWhitespace: Re,
    skipSpaces: Pe,
    skipToLineEnd: Le,
    skipEverythingButNewLine: Be,
    skipInlineComment: Ie,
    skipTrailingComment: qe,
    skipNewline: $e,
    isNextLineEmptyAfterIndex: Ue,
    isNextLineEmpty: function isNextLineEmpty(e, t, n) {
      return Ue(e, n(t));
    },
    isPreviousLineEmpty: function isPreviousLineEmpty(e, t, n) {
      var r = n(t) - 1;
      return r = Pe(e, r, {
        backwards: !0
      }), r = $e(e, r, {
        backwards: !0
      }), r = Pe(e, r, {
        backwards: !0
      }), r !== $e(e, r, {
        backwards: !0
      });
    },
    hasNewline: Me,
    hasNewlineInRange: function hasNewlineInRange(e, t, n) {
      for (var _r11 = t; _r11 < n; ++_r11) {
        if ("\n" === e.charAt(_r11)) return !0;
      }

      return !1;
    },
    hasSpaces: function hasSpaces(e, t, n) {
      return Pe(e, (n = n || {}).backwards ? t - 1 : t, n) !== t;
    },
    getAlignmentSize: je,
    getIndentSize: function getIndentSize(e, t) {
      var n = e.lastIndexOf("\n");
      return -1 === n ? 0 : je(e.slice(n + 1).match(/^[\t ]*/)[0], t);
    },
    getPreferredQuote: He,
    printString: function printString(e, t, n) {
      var r = e.slice(1, -1),
          s = !r.includes('"') && !r.includes("'"),
          i = "json" === t.parser ? '"' : t.__isInHtmlAttribute ? "'" : He(e, t.singleQuote ? "'" : '"');
      return n ? s ? i + r + i : e : Xe(r, i, !("css" === t.parser || "less" === t.parser || "scss" === t.parser || t.embeddedInHtml));
    },
    printNumber: function printNumber(e) {
      return e.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
    },
    isNodeIgnoreComment: function isNodeIgnoreComment(e) {
      return "prettier-ignore" === e.value.trim();
    },
    makeString: Xe,
    addLeadingComment: function addLeadingComment(e, t) {
      t.leading = !0, t.trailing = !1, ze(e, t);
    },
    addDanglingComment: function addDanglingComment(e, t, n) {
      t.leading = !1, t.trailing = !1, n && (t.marker = n), ze(e, t);
    },
    addTrailingComment: function addTrailingComment(e, t) {
      t.leading = !1, t.trailing = !0, ze(e, t);
    },
    isFrontMatterNode: function isFrontMatterNode(e) {
      return e && "front-matter" === e.type;
    },
    getShebang: function getShebang(e) {
      if (!e.startsWith("#!")) return "";
      var t = e.indexOf("\n");
      return -1 === t ? e : e.slice(0, t);
    }
  };
  var Qe = {
    guessEndOfLine: function guessEndOfLine(e) {
      var t = e.indexOf("\r");
      return t >= 0 ? "\n" === e.charAt(t + 1) ? "crlf" : "cr" : "lf";
    },
    convertEndOfLineToChars: function convertEndOfLineToChars(e) {
      switch (e) {
        case "cr":
          return "\r";

        case "crlf":
          return "\r\n";

        default:
          return "\n";
      }
    },
    countEndOfLineChars: function countEndOfLineChars(e, t) {
      var n;
      if ("\n" === t) n = /\n/g;else if ("\r" === t) n = /\r/g;else {
        if ("\r\n" !== t) throw new Error('Unexpected "eol" '.concat(JSON.stringify(t), "."));
        n = /\r\n/g;
      }
      var r = e.match(n);
      return r ? r.length : 0;
    },
    normalizeEndOfLine: function normalizeEndOfLine(e) {
      return e.replace(/\r\n?/g, "\n");
    }
  };
  var Ye = We.getStringWidth,
      Je = Qe.convertEndOfLineToChars,
      Ze = f.concat,
      Ke = f.fill,
      et = f.cursor;
  var tt;

  function nt(e, t) {
    return st(e, {
      type: "indent"
    }, t);
  }

  function rt(e, t, n) {
    if (t === -1 / 0) return e.root || {
      value: "",
      length: 0,
      queue: []
    };
    if (t < 0) return st(e, {
      type: "dedent"
    }, n);
    if (!t) return e;
    if ("root" === t.type) return Object.assign({}, e, {
      root: e
    });
    return st(e, {
      type: "string" == typeof t ? "stringAlign" : "numberAlign",
      n: t
    }, n);
  }

  function st(e, t, n) {
    var r = "dedent" === t.type ? e.queue.slice(0, -1) : e.queue.concat(t);
    var s = "",
        i = 0,
        o = 0,
        a = 0;

    var _iterator5 = _createForOfIteratorHelper(r),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _e7 = _step5.value;

        switch (_e7.type) {
          case "indent":
            l(), n.useTabs ? u(1) : c(n.tabWidth);
            break;

          case "stringAlign":
            l(), s += _e7.n, i += _e7.n.length;
            break;

          case "numberAlign":
            o += 1, a += _e7.n;
            break;

          default:
            throw new Error("Unexpected type '".concat(_e7.type, "'"));
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    return p(), Object.assign({}, e, {
      value: s,
      length: i,
      queue: r
    });

    function u(e) {
      s += "\t".repeat(e), i += n.tabWidth * e;
    }

    function c(e) {
      s += " ".repeat(e), i += e;
    }

    function l() {
      n.useTabs ? function () {
        o > 0 && u(o);
        D();
      }() : p();
    }

    function p() {
      a > 0 && c(a), D();
    }

    function D() {
      o = 0, a = 0;
    }
  }

  function it(e) {
    if (0 === e.length) return 0;
    var t = 0;

    for (; e.length > 0 && "string" == typeof e[e.length - 1] && e[e.length - 1].match(/^[\t ]*$/);) {
      t += e.pop().length;
    }

    if (e.length && "string" == typeof e[e.length - 1]) {
      var _n10 = e[e.length - 1].replace(/[\t ]*$/, "");

      t += e[e.length - 1].length - _n10.length, e[e.length - 1] = _n10;
    }

    return t;
  }

  function ot(e, t, n, r, s) {
    var i = t.length;
    var o = [e],
        a = [];

    for (; n >= 0;) {
      if (0 === o.length) {
        if (0 === i) return !0;
        o.push(t[i - 1]), i--;
        continue;
      }

      var _o$pop = o.pop(),
          _o$pop2 = _slicedToArray(_o$pop, 3),
          _e8 = _o$pop2[0],
          _u = _o$pop2[1],
          _c2 = _o$pop2[2];

      if ("string" == typeof _c2) a.push(_c2), n -= Ye(_c2);else switch (_c2.type) {
        case "concat":
          for (var _t4 = _c2.parts.length - 1; _t4 >= 0; _t4--) {
            o.push([_e8, _u, _c2.parts[_t4]]);
          }

          break;

        case "indent":
          o.push([nt(_e8, r), _u, _c2.contents]);
          break;

        case "align":
          o.push([rt(_e8, _c2.n, r), _u, _c2.contents]);
          break;

        case "trim":
          n += it(a);
          break;

        case "group":
          if (s && _c2.break) return !1;
          o.push([_e8, _c2.break ? 1 : _u, _c2.contents]), _c2.id && (tt[_c2.id] = o[o.length - 1][1]);
          break;

        case "fill":
          for (var _t5 = _c2.parts.length - 1; _t5 >= 0; _t5--) {
            o.push([_e8, _u, _c2.parts[_t5]]);
          }

          break;

        case "if-break":
          {
            var _t6 = _c2.groupId ? tt[_c2.groupId] : _u;

            1 === _t6 && _c2.breakContents && o.push([_e8, _u, _c2.breakContents]), 2 === _t6 && _c2.flatContents && o.push([_e8, _u, _c2.flatContents]);
            break;
          }

        case "line":
          switch (_u) {
            case 2:
              if (!_c2.hard) {
                _c2.soft || (a.push(" "), n -= 1);
                break;
              }

              return !0;

            case 1:
              return !0;
          }

      }
    }

    return !1;
  }

  var at = {
    printDocToString: function printDocToString(e, t) {
      tt = {};
      var n = t.printWidth,
          r = Je(t.endOfLine);
      var s = 0;
      var i = [[{
        value: "",
        length: 0,
        queue: []
      }, 1, e]],
          o = [];
      var a = !1,
          u = [];

      for (; 0 !== i.length;) {
        var _i$pop = i.pop(),
            _i$pop2 = _slicedToArray(_i$pop, 3),
            _e9 = _i$pop2[0],
            _c3 = _i$pop2[1],
            _l = _i$pop2[2];

        if ("string" == typeof _l) {
          var _e10 = "\n" !== r && _l.includes("\n") ? _l.replace(/\n/g, r) : _l;

          o.push(_e10), s += Ye(_e10);
        } else switch (_l.type) {
          case "cursor":
            o.push(et.placeholder);
            break;

          case "concat":
            for (var _t7 = _l.parts.length - 1; _t7 >= 0; _t7--) {
              i.push([_e9, _c3, _l.parts[_t7]]);
            }

            break;

          case "indent":
            i.push([nt(_e9, t), _c3, _l.contents]);
            break;

          case "align":
            i.push([rt(_e9, _l.n, t), _c3, _l.contents]);
            break;

          case "trim":
            s -= it(o);
            break;

          case "group":
            switch (_c3) {
              case 2:
                if (!a) {
                  i.push([_e9, _l.break ? 1 : 2, _l.contents]);
                  break;
                }

              case 1:
                {
                  a = !1;

                  var _r12 = [_e9, 2, _l.contents],
                      _o3 = n - s;

                  if (!_l.break && ot(_r12, i, _o3, t)) i.push(_r12);else if (_l.expandedStates) {
                    var _n11 = _l.expandedStates[_l.expandedStates.length - 1];

                    if (_l.break) {
                      i.push([_e9, 1, _n11]);
                      break;
                    }

                    for (var _r13 = 1; _r13 < _l.expandedStates.length + 1; _r13++) {
                      if (_r13 >= _l.expandedStates.length) {
                        i.push([_e9, 1, _n11]);
                        break;
                      }

                      {
                        var _n12 = [_e9, 2, _l.expandedStates[_r13]];

                        if (ot(_n12, i, _o3, t)) {
                          i.push(_n12);
                          break;
                        }
                      }
                    }
                  } else i.push([_e9, 1, _l.contents]);
                  break;
                }
            }

            _l.id && (tt[_l.id] = i[i.length - 1][1]);
            break;

          case "fill":
            {
              var _r14 = n - s,
                  _o4 = _l.parts;

              if (0 === _o4.length) break;

              var _o5 = _slicedToArray(_o4, 2),
                  _a = _o5[0],
                  _u2 = _o5[1],
                  _p = [_e9, 2, _a],
                  _D = [_e9, 1, _a],
                  _h = ot(_p, [], _r14, t, !0);

              if (1 === _o4.length) {
                _h ? i.push(_p) : i.push(_D);
                break;
              }

              var _d = [_e9, 2, _u2],
                  _f = [_e9, 1, _u2];

              if (2 === _o4.length) {
                _h ? (i.push(_d), i.push(_p)) : (i.push(_f), i.push(_D));
                break;
              }

              _o4.splice(0, 2);

              var _m = [_e9, _c3, Ke(_o4)],
                  _g = _o4[0];
              ot([_e9, 2, Ze([_a, _u2, _g])], [], _r14, t, !0) ? (i.push(_m), i.push(_d), i.push(_p)) : _h ? (i.push(_m), i.push(_f), i.push(_p)) : (i.push(_m), i.push(_f), i.push(_D));
              break;
            }

          case "if-break":
            {
              var _t8 = _l.groupId ? tt[_l.groupId] : _c3;

              1 === _t8 && _l.breakContents && i.push([_e9, _c3, _l.breakContents]), 2 === _t8 && _l.flatContents && i.push([_e9, _c3, _l.flatContents]);
              break;
            }

          case "line-suffix":
            u.push([_e9, _c3, _l.contents]);
            break;

          case "line-suffix-boundary":
            u.length > 0 && i.push([_e9, _c3, {
              type: "line",
              hard: !0
            }]);
            break;

          case "line":
            switch (_c3) {
              case 2:
                if (!_l.hard) {
                  _l.soft || (o.push(" "), s += 1);
                  break;
                }

                a = !0;

              case 1:
                if (u.length) {
                  i.push([_e9, _c3, _l]), i.push.apply(i, _toConsumableArray(u.reverse())), u = [];
                  break;
                }

                _l.literal ? _e9.root ? (o.push(r, _e9.root.value), s = _e9.root.length) : (o.push(r), s = 0) : (s -= it(o), o.push(r + _e9.value), s = _e9.length);
            }

        }

        0 === i.length && u.length && (i.push.apply(i, _toConsumableArray(u.reverse())), u = []);
      }

      var c = o.indexOf(et.placeholder);

      if (-1 !== c) {
        var _e11 = o.indexOf(et.placeholder, c + 1),
            _t9 = o.slice(0, c).join(""),
            _n13 = o.slice(c + 1, _e11).join("");

        return {
          formatted: _t9 + _n13 + o.slice(_e11 + 1).join(""),
          cursorNodeStart: _t9.length,
          cursorNodeText: _n13
        };
      }

      return {
        formatted: o.join("")
      };
    }
  };
  var ut = f.literalline,
      ct = f.concat,
      lt = {};

  function pt(e, t, n, r) {
    var s = [e];

    for (; 0 !== s.length;) {
      var _e12 = s.pop();

      if (_e12 !== lt) {
        if (n && s.push(_e12, lt), !t || !1 !== t(_e12)) if ("concat" === _e12.type || "fill" === _e12.type) for (var _t10 = _e12.parts.length - 1; _t10 >= 0; --_t10) {
          s.push(_e12.parts[_t10]);
        } else if ("if-break" === _e12.type) _e12.flatContents && s.push(_e12.flatContents), _e12.breakContents && s.push(_e12.breakContents);else if ("group" === _e12.type && _e12.expandedStates) {
          if (r) for (var _t11 = _e12.expandedStates.length - 1; _t11 >= 0; --_t11) {
            s.push(_e12.expandedStates[_t11]);
          } else s.push(_e12.contents);
        } else _e12.contents && s.push(_e12.contents);
      } else n(s.pop());
    }
  }

  function Dt(e, t) {
    if ("concat" === e.type || "fill" === e.type) {
      var _n14 = e.parts.map(function (e) {
        return Dt(e, t);
      });

      return t(Object.assign({}, e, {
        parts: _n14
      }));
    }

    if ("if-break" === e.type) {
      var _n15 = e.breakContents && Dt(e.breakContents, t),
          _r15 = e.flatContents && Dt(e.flatContents, t);

      return t(Object.assign({}, e, {
        breakContents: _n15,
        flatContents: _r15
      }));
    }

    if (e.contents) {
      var _n16 = Dt(e.contents, t);

      return t(Object.assign({}, e, {
        contents: _n16
      }));
    }

    return t(e);
  }

  function ht(e, t, n) {
    var r = n,
        s = !1;
    return pt(e, function (e) {
      var n = t(e);
      if (void 0 !== n && (s = !0, r = n), s) return !1;
    }), r;
  }

  function dt(e) {
    return "string" != typeof e && ("line" === e.type || void 0);
  }

  function ft(e) {
    return !("group" !== e.type || !e.break) || !("line" !== e.type || !e.hard) || "break-parent" === e.type || void 0;
  }

  function mt(e) {
    if (e.length > 0) {
      var _t12 = e[e.length - 1];
      _t12.expandedStates || (_t12.break = !0);
    }

    return null;
  }

  function gt(e) {
    return "line" !== e.type || e.hard ? "if-break" === e.type ? e.flatContents || "" : e : e.soft ? "" : " ";
  }

  function Et(e) {
    var t = [],
        n = e.filter(Boolean);

    for (; 0 !== n.length;) {
      var _e13 = n.shift();

      _e13 && ("concat" !== _e13.type ? 0 === t.length || "string" != typeof t[t.length - 1] || "string" != typeof _e13 ? t.push(_e13) : t[t.length - 1] += _e13 : n.unshift.apply(n, _toConsumableArray(_e13.parts)));
    }

    return t;
  }

  function Ct(e) {
    if ("concat" === e.type) {
      var _t13 = [];

      for (var _n17 = 0; _n17 < e.parts.length; ++_n17) {
        var _r16 = e.parts[_n17];
        if ("string" != typeof _r16 && "concat" === _r16.type) _t13.push.apply(_t13, _toConsumableArray(Ct(_r16).parts));else {
          var _e14 = Ct(_r16);

          "" !== _e14 && _t13.push(_e14);
        }
      }

      return Object.assign({}, e, {
        parts: _t13
      });
    }

    return "if-break" === e.type ? Object.assign({}, e, {
      breakContents: null != e.breakContents ? Ct(e.breakContents) : null,
      flatContents: null != e.flatContents ? Ct(e.flatContents) : null
    }) : "group" === e.type ? Object.assign({}, e, {
      contents: Ct(e.contents),
      expandedStates: e.expandedStates ? e.expandedStates.map(Ct) : e.expandedStates
    }) : e.contents ? Object.assign({}, e, {
      contents: Ct(e.contents)
    }) : e;
  }

  function Tt(e) {
    if ("string" == typeof e) return JSON.stringify(e);
    if ("line" === e.type) return e.literal ? "literalline" : e.hard ? "hardline" : e.soft ? "softline" : "line";
    if ("break-parent" === e.type) return "breakParent";
    if ("trim" === e.type) return "trim";
    if ("concat" === e.type) return "[" + e.parts.map(Tt).join(", ") + "]";
    if ("indent" === e.type) return "indent(" + Tt(e.contents) + ")";
    if ("align" === e.type) return e.n === -1 / 0 ? "dedentToRoot(" + Tt(e.contents) + ")" : e.n < 0 ? "dedent(" + Tt(e.contents) + ")" : "root" === e.n.type ? "markAsRoot(" + Tt(e.contents) + ")" : "align(" + JSON.stringify(e.n) + ", " + Tt(e.contents) + ")";
    if ("if-break" === e.type) return "ifBreak(" + Tt(e.breakContents) + (e.flatContents ? ", " + Tt(e.flatContents) : "") + ")";
    if ("group" === e.type) return e.expandedStates ? "conditionalGroup([" + e.expandedStates.map(Tt).join(",") + "])" : (e.break ? "wrappedGroup" : "group") + "(" + Tt(e.contents) + ")";
    if ("fill" === e.type) return "fill(" + e.parts.map(Tt).join(", ") + ")";
    if ("line-suffix" === e.type) return "lineSuffix(" + Tt(e.contents) + ")";
    if ("line-suffix-boundary" === e.type) return "lineSuffixBoundary";
    throw new Error("Unknown doc type " + e.type);
  }

  var yt = {
    builders: f,
    printer: at,
    utils: {
      isEmpty: function isEmpty(e) {
        return "string" == typeof e && 0 === e.length;
      },
      willBreak: function willBreak(e) {
        return ht(e, ft, !1);
      },
      isLineNext: function isLineNext(e) {
        return ht(e, dt, !1);
      },
      traverseDoc: pt,
      findInDoc: ht,
      mapDoc: Dt,
      propagateBreaks: function propagateBreaks(e) {
        var t = new Set(),
            n = [];
        pt(e, function (e) {
          if ("break-parent" === e.type && mt(n), "group" === e.type) {
            if (n.push(e), t.has(e)) return !1;
            t.add(e);
          }
        }, function (e) {
          if ("group" === e.type) {
            n.pop().break && mt(n);
          }
        }, !0);
      },
      removeLines: function removeLines(e) {
        return Dt(e, gt);
      },
      stripTrailingHardline: function e(t) {
        var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

        if ("concat" === t.type && 0 !== t.parts.length) {
          var _r17 = n ? function (e) {
            var t,
                n = e.parts;

            for (var _r18 = e.parts.length; _r18 > 0 && !t; _r18--) {
              t = n[_r18 - 1];
            }

            return "group" === t.type && (n = t.contents.parts), n;
          }(t) : t.parts,
              _s4 = _r17[_r17.length - 1];

          if ("concat" === _s4.type) return 2 === _s4.parts.length && _s4.parts[0].hard && "break-parent" === _s4.parts[1].type ? {
            type: "concat",
            parts: _r17.slice(0, -1)
          } : {
            type: "concat",
            parts: t.parts.slice(0, -1).concat(e(_s4))
          };
        }

        return t;
      },
      normalizeParts: Et,
      normalizeDoc: function normalizeDoc(e) {
        return Dt(e, function (e) {
          return e.parts ? Object.assign({}, e, {
            parts: Et(e.parts)
          }) : e;
        });
      },
      replaceNewlinesWithLiterallines: function replaceNewlinesWithLiterallines(e) {
        return Dt(e, function (e) {
          return "string" == typeof e && e.includes("\n") ? ct(e.split(/(\n)/g).map(function (e, t) {
            return t % 2 == 0 ? e : ut;
          })) : e;
        });
      }
    },
    debug: {
      printDocToDebug: function printDocToDebug(e) {
        return Tt(Ct(e));
      }
    }
  };
  var _yt$builders = yt.builders,
      St = _yt$builders.hardline,
      _t = _yt$builders.concat,
      bt = _yt$builders.markAsRoot,
      Ft = {
    "---": "yaml",
    "+++": "toml"
  };
  var At = {
    parse: function parse(e) {
      var t = Object.keys(Ft).map(a).join("|"),
          n = e.match(new RegExp("^(".concat(t, ")([^\\n]*)\\n(?:([\\s\\S]*?)\\n)?\\1[^\\n\\S]*(\\n|$)")));
      if (null === n) return {
        frontMatter: null,
        content: e
      };

      var _n18 = _slicedToArray(n, 4),
          r = _n18[0],
          s = _n18[1],
          i = _n18[2],
          o = _n18[3];

      var u = Ft[s];
      return "toml" !== u && i && i.trim() && (u = i.trim()), {
        frontMatter: {
          type: "front-matter",
          lang: u,
          value: o,
          raw: r.replace(/\n$/, "")
        },
        content: r.replace(/[^\n]/g, " ") + e.slice(r.length)
      };
    },
    print: function print(e, t) {
      if ("yaml" === e.lang) {
        var _n19 = e.value.trim(),
            _r19 = _n19 ? t(_n19, {
          parser: "yaml"
        }, {
          stripTrailingHardline: !0
        }) : "";

        return bt(_t(["---", St, _r19, _r19 ? St : "", "---"]));
      }
    }
  };

  var vt = function vt(e, t) {
    var n = new SyntaxError(e + " (" + t.start.line + ":" + t.start.column + ")");
    return n.loc = t, n;
  },
      wt = {
    "*": ["accesskey", "autocapitalize", "autofocus", "class", "contenteditable", "dir", "draggable", "enterkeyhint", "hidden", "id", "inputmode", "is", "itemid", "itemprop", "itemref", "itemscope", "itemtype", "lang", "nonce", "slot", "spellcheck", "style", "tabindex", "title", "translate"],
    a: ["accesskey", "charset", "coords", "download", "href", "hreflang", "name", "ping", "referrerpolicy", "rel", "rev", "shape", "tabindex", "target", "type"],
    abbr: ["title"],
    applet: ["align", "alt", "archive", "code", "codebase", "height", "hspace", "name", "object", "vspace", "width"],
    area: ["accesskey", "alt", "coords", "download", "href", "hreflang", "nohref", "ping", "referrerpolicy", "rel", "shape", "tabindex", "target", "type"],
    audio: ["autoplay", "controls", "crossorigin", "loop", "muted", "preload", "src"],
    base: ["href", "target"],
    basefont: ["color", "face", "size"],
    bdo: ["dir"],
    blockquote: ["cite"],
    body: ["alink", "background", "bgcolor", "link", "text", "vlink"],
    br: ["clear"],
    button: ["accesskey", "autofocus", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "name", "tabindex", "type", "value"],
    canvas: ["height", "width"],
    caption: ["align"],
    col: ["align", "char", "charoff", "span", "valign", "width"],
    colgroup: ["align", "char", "charoff", "span", "valign", "width"],
    data: ["value"],
    del: ["cite", "datetime"],
    details: ["open"],
    dfn: ["title"],
    dialog: ["open"],
    dir: ["compact"],
    div: ["align"],
    dl: ["compact"],
    embed: ["height", "src", "type", "width"],
    fieldset: ["disabled", "form", "name"],
    font: ["color", "face", "size"],
    form: ["accept", "accept-charset", "action", "autocomplete", "enctype", "method", "name", "novalidate", "target"],
    frame: ["frameborder", "longdesc", "marginheight", "marginwidth", "name", "noresize", "scrolling", "src"],
    frameset: ["cols", "rows"],
    h1: ["align"],
    h2: ["align"],
    h3: ["align"],
    h4: ["align"],
    h5: ["align"],
    h6: ["align"],
    head: ["profile"],
    hr: ["align", "noshade", "size", "width"],
    html: ["manifest", "version"],
    iframe: ["align", "allow", "allowfullscreen", "allowpaymentrequest", "allowusermedia", "frameborder", "height", "loading", "longdesc", "marginheight", "marginwidth", "name", "referrerpolicy", "sandbox", "scrolling", "src", "srcdoc", "width"],
    img: ["align", "alt", "border", "crossorigin", "decoding", "height", "hspace", "ismap", "loading", "longdesc", "name", "referrerpolicy", "sizes", "src", "srcset", "usemap", "vspace", "width"],
    input: ["accept", "accesskey", "align", "alt", "autocomplete", "autofocus", "checked", "dirname", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "height", "ismap", "list", "max", "maxlength", "min", "minlength", "multiple", "name", "pattern", "placeholder", "readonly", "required", "size", "src", "step", "tabindex", "title", "type", "usemap", "value", "width"],
    ins: ["cite", "datetime"],
    isindex: ["prompt"],
    label: ["accesskey", "for", "form"],
    legend: ["accesskey", "align"],
    li: ["type", "value"],
    link: ["as", "charset", "color", "crossorigin", "disabled", "href", "hreflang", "imagesizes", "imagesrcset", "integrity", "media", "nonce", "referrerpolicy", "rel", "rev", "sizes", "target", "title", "type"],
    map: ["name"],
    menu: ["compact"],
    meta: ["charset", "content", "http-equiv", "name", "scheme"],
    meter: ["high", "low", "max", "min", "optimum", "value"],
    object: ["align", "archive", "border", "classid", "codebase", "codetype", "data", "declare", "form", "height", "hspace", "name", "standby", "tabindex", "type", "typemustmatch", "usemap", "vspace", "width"],
    ol: ["compact", "reversed", "start", "type"],
    optgroup: ["disabled", "label"],
    option: ["disabled", "label", "selected", "value"],
    output: ["for", "form", "name"],
    p: ["align"],
    param: ["name", "type", "value", "valuetype"],
    pre: ["width"],
    progress: ["max", "value"],
    q: ["cite"],
    script: ["async", "charset", "crossorigin", "defer", "integrity", "language", "nomodule", "nonce", "referrerpolicy", "src", "type"],
    select: ["autocomplete", "autofocus", "disabled", "form", "multiple", "name", "required", "size", "tabindex"],
    slot: ["name"],
    source: ["media", "sizes", "src", "srcset", "type"],
    style: ["media", "nonce", "title", "type"],
    table: ["align", "bgcolor", "border", "cellpadding", "cellspacing", "frame", "rules", "summary", "width"],
    tbody: ["align", "char", "charoff", "valign"],
    td: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"],
    textarea: ["accesskey", "autocomplete", "autofocus", "cols", "dirname", "disabled", "form", "maxlength", "minlength", "name", "placeholder", "readonly", "required", "rows", "tabindex", "wrap"],
    tfoot: ["align", "char", "charoff", "valign"],
    th: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"],
    thead: ["align", "char", "charoff", "valign"],
    time: ["datetime"],
    tr: ["align", "bgcolor", "char", "charoff", "valign"],
    track: ["default", "kind", "label", "src", "srclang"],
    ul: ["compact", "type"],
    video: ["autoplay", "controls", "crossorigin", "height", "loop", "muted", "playsinline", "poster", "preload", "src", "width"]
  };

  var kt = We.inferParserByLanguage,
      Nt = We.isFrontMatterNode,
      _CSS_DISPLAY_TAGS$CSS = {
    CSS_DISPLAY_TAGS: {
      area: "none",
      base: "none",
      basefont: "none",
      datalist: "none",
      head: "none",
      link: "none",
      meta: "none",
      noembed: "none",
      noframes: "none",
      param: "block",
      rp: "none",
      script: "block",
      source: "block",
      style: "none",
      template: "inline",
      track: "block",
      title: "none",
      html: "block",
      body: "block",
      address: "block",
      blockquote: "block",
      center: "block",
      div: "block",
      figure: "block",
      figcaption: "block",
      footer: "block",
      form: "block",
      header: "block",
      hr: "block",
      legend: "block",
      listing: "block",
      main: "block",
      p: "block",
      plaintext: "block",
      pre: "block",
      xmp: "block",
      slot: "contents",
      ruby: "ruby",
      rt: "ruby-text",
      article: "block",
      aside: "block",
      h1: "block",
      h2: "block",
      h3: "block",
      h4: "block",
      h5: "block",
      h6: "block",
      hgroup: "block",
      nav: "block",
      section: "block",
      dir: "block",
      dd: "block",
      dl: "block",
      dt: "block",
      ol: "block",
      ul: "block",
      li: "list-item",
      table: "table",
      caption: "table-caption",
      colgroup: "table-column-group",
      col: "table-column",
      thead: "table-header-group",
      tbody: "table-row-group",
      tfoot: "table-footer-group",
      tr: "table-row",
      td: "table-cell",
      th: "table-cell",
      fieldset: "block",
      button: "inline-block",
      details: "block",
      summary: "block",
      dialog: "block",
      meter: "inline-block",
      progress: "inline-block",
      object: "inline-block",
      video: "inline-block",
      audio: "inline-block",
      select: "inline-block",
      option: "block",
      optgroup: "block"
    },
    CSS_DISPLAY_DEFAULT: "inline",
    CSS_WHITE_SPACE_TAGS: {
      listing: "pre",
      plaintext: "pre",
      pre: "pre",
      xmp: "pre",
      nobr: "nowrap",
      table: "initial",
      textarea: "pre-wrap"
    },
    CSS_WHITE_SPACE_DEFAULT: "normal"
  },
      xt = _CSS_DISPLAY_TAGS$CSS.CSS_DISPLAY_TAGS,
      Ot = _CSS_DISPLAY_TAGS$CSS.CSS_DISPLAY_DEFAULT,
      Rt = _CSS_DISPLAY_TAGS$CSS.CSS_WHITE_SPACE_TAGS,
      Pt = _CSS_DISPLAY_TAGS$CSS.CSS_WHITE_SPACE_DEFAULT,
      Lt = $t(["a", "abbr", "acronym", "address", "applet", "area", "article", "aside", "audio", "b", "base", "basefont", "bdi", "bdo", "bgsound", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "command", "content", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "embed", "fieldset", "figcaption", "figure", "font", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "image", "img", "input", "ins", "isindex", "kbd", "keygen", "label", "legend", "li", "link", "listing", "main", "map", "mark", "marquee", "math", "menu", "menuitem", "meta", "meter", "multicol", "nav", "nextid", "nobr", "noembed", "noframes", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "plaintext", "pre", "progress", "q", "rb", "rbc", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "tt", "u", "ul", "var", "video", "wbr", "xmp"]),
      Bt = function (e, t) {
    var n = Object.create(null);

    for (var _i3 = 0, _Object$keys = Object.keys(e); _i3 < _Object$keys.length; _i3++) {
      var _r20 = _Object$keys[_i3];
      n[_r20] = t(e[_r20], _r20);
    }

    return n;
  }(wt, $t),
      It = new Set(["\t", "\n", "\f", "\r", " "]),
      qt = function qt(e) {
    return e.replace(/[\t\n\f\r ]+$/, "");
  };

  function $t(e) {
    var t = Object.create(null);

    var _iterator6 = _createForOfIteratorHelper(e),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _n20 = _step6.value;
        t[_n20] = !0;
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    return t;
  }

  function Mt(e, t) {
    return !("ieConditionalComment" !== e.type || !e.lastChild || e.lastChild.isSelfClosing || e.lastChild.endSourceSpan) || "ieConditionalComment" === e.type && !e.complete || !(!Zt(e) || !e.children.some(function (e) {
      return "text" !== e.type && "interpolation" !== e.type;
    })) || !(!sn(e, t) || Gt(e) || "interpolation" === e.type);
  }

  function Ut(e) {
    if ("attribute" === e.type) return !1;
    if (!e.parent) return !1;
    if ("number" != typeof e.index || 0 === e.index) return !1;
    return function (e) {
      return "comment" === e.type && "prettier-ignore" === e.value.trim();
    }(e.parent.children[e.index - 1]);
  }

  function Gt(e) {
    return "element" === e.type && ("script" === e.fullName || "style" === e.fullName || "svg:style" === e.fullName || Kt(e) && ("script" === e.name || "style" === e.name));
  }

  function Vt(e) {
    return en(e).startsWith("pre");
  }

  function jt(e) {
    return "element" === e.type && 0 !== e.children.length && (["html", "head", "ul", "ol", "select"].includes(e.name) || e.cssDisplay.startsWith("table") && "table-cell" !== e.cssDisplay);
  }

  function Ht(e) {
    return Qt(e) || "element" === e.type && "br" === e.fullName || Xt(e);
  }

  function Xt(e) {
    return zt(e) && Wt(e);
  }

  function zt(e) {
    return e.hasLeadingSpaces && (e.prev ? e.prev.sourceSpan.end.line < e.sourceSpan.start.line : "root" === e.parent.type || e.parent.startSourceSpan.end.line < e.sourceSpan.start.line);
  }

  function Wt(e) {
    return e.hasTrailingSpaces && (e.next ? e.next.sourceSpan.start.line > e.sourceSpan.end.line : "root" === e.parent.type || e.parent.endSourceSpan && e.parent.endSourceSpan.start.line > e.sourceSpan.end.line);
  }

  function Qt(e) {
    switch (e.type) {
      case "ieConditionalComment":
      case "comment":
      case "directive":
        return !0;

      case "element":
        return ["script", "select"].includes(e.name);
    }

    return !1;
  }

  function Yt(e) {
    var _e$attrMap = e.attrMap,
        t = _e$attrMap.type,
        n = _e$attrMap.lang;
    return "module" === t || "text/javascript" === t || "text/babel" === t || "application/javascript" === t || "jsx" === n ? "babel" : "application/x-typescript" === t || "ts" === n || "tsx" === n ? "typescript" : "text/markdown" === t ? "markdown" : "text/html" === t ? "html" : t && (t.endsWith("json") || t.endsWith("importmap")) ? "json" : "text/x-handlebars-template" === t ? "glimmer" : void 0;
  }

  function Jt(e) {
    return "block" === e || "list-item" === e || e.startsWith("table");
  }

  function Zt(e) {
    return en(e).startsWith("pre");
  }

  function Kt(e) {
    return "element" === e.type && !e.hasExplicitNamespace && !["html", "svg"].includes(e.namespace);
  }

  function en(e) {
    return "element" === e.type && (!e.namespace || Kt(e)) && Rt[e.name] || Pt;
  }

  var tn = new Set(["template", "style", "script"]);

  function nn(e, t) {
    return rn(e, t) && !tn.has(e.fullName);
  }

  function rn(e, t) {
    return "vue" === t.parser && "element" === e.type && "root" === e.parent.type && "html" !== e.fullName.toLowerCase();
  }

  function sn(e, t) {
    return rn(e, t) && (nn(e, t) || e.attrMap.lang && "html" !== e.attrMap.lang);
  }

  var on = {
    HTML_ELEMENT_ATTRIBUTES: Bt,
    HTML_TAGS: Lt,
    htmlTrim: function htmlTrim(e) {
      return function (e) {
        return e.replace(/^[\t\n\f\r ]+/, "");
      }(qt(e));
    },
    htmlTrimPreserveIndentation: function htmlTrimPreserveIndentation(e) {
      return function (e) {
        return e.replace(/^[\t\f\r ]*?\n/g, "");
      }(qt(e));
    },
    splitByHtmlWhitespace: function splitByHtmlWhitespace(e) {
      return e.split(/[\t\n\f\r ]+/);
    },
    hasHtmlWhitespace: function hasHtmlWhitespace(e) {
      return /[\t\n\f\r ]/.test(e);
    },
    getLeadingAndTrailingHtmlWhitespace: function getLeadingAndTrailingHtmlWhitespace(e) {
      var _e$match = e.match(/^([\t\n\f\r ]*)([\S\s]*?)([\t\n\f\r ]*)$/),
          _e$match2 = _slicedToArray(_e$match, 4),
          t = _e$match2[1],
          n = _e$match2[2],
          r = _e$match2[3];

      return {
        leadingWhitespace: t,
        trailingWhitespace: r,
        text: n
      };
    },
    canHaveInterpolation: function canHaveInterpolation(e) {
      return e.children && !Gt(e);
    },
    countChars: function countChars(e, t) {
      var n = 0;

      for (var _r21 = 0; _r21 < e.length; _r21++) {
        e[_r21] === t && n++;
      }

      return n;
    },
    countParents: function countParents(e, t) {
      var n = 0;

      for (var _r22 = e.stack.length - 1; _r22 >= 0; _r22--) {
        var _s5 = e.stack[_r22];
        _s5 && "object" == typeof _s5 && !Array.isArray(_s5) && t(_s5) && n++;
      }

      return n;
    },
    dedentString: function dedentString(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (e) {
        var t = 1 / 0;

        var _iterator7 = _createForOfIteratorHelper(e.split("\n")),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _r23 = _step7.value;
            if (0 === _r23.length) continue;
            if (!It.has(_r23[0])) return 0;
            var _e15 = (n = _r23, n.match(/^[\t\n\f\r ]*/)[0]).length;
            _r23.length !== _e15 && _e15 < t && (t = _e15);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        var n;
        return t === 1 / 0 ? 0 : t;
      }(e);
      return 0 === t ? e : e.split("\n").map(function (e) {
        return e.slice(t);
      }).join("\n");
    },
    forceBreakChildren: jt,
    forceBreakContent: function forceBreakContent(e) {
      return jt(e) || "element" === e.type && 0 !== e.children.length && (["body", "script", "style"].includes(e.name) || e.children.some(function (e) {
        return function (e) {
          return e.children && e.children.some(function (e) {
            return "text" !== e.type;
          });
        }(e);
      })) || e.firstChild && e.firstChild === e.lastChild && "text" !== e.firstChild.type && zt(e.firstChild) && (!e.lastChild.isTrailingSpaceSensitive || Wt(e.lastChild));
    },
    forceNextEmptyLine: function forceNextEmptyLine(e) {
      return Nt(e) || e.next && e.sourceSpan.end && e.sourceSpan.end.line + 1 < e.next.sourceSpan.start.line;
    },
    getLastDescendant: function e(t) {
      return t.lastChild ? e(t.lastChild) : t;
    },
    getNodeCssStyleDisplay: function getNodeCssStyleDisplay(e, t) {
      if (e.prev && "comment" === e.prev.type) {
        var _t14 = e.prev.value.match(/^\s*display:\s*([a-z]+)\s*$/);

        if (_t14) return _t14[1];
      }

      var n = !1;

      if ("element" === e.type && "svg" === e.namespace) {
        if (!function (e, t) {
          var n = e;

          for (; n;) {
            if (t(n)) return !0;
            n = n.parent;
          }

          return !1;
        }(e, function (e) {
          return "svg:foreignObject" === e.fullName;
        })) return "svg" === e.name ? "inline-block" : "block";
        n = !0;
      }

      switch (t.htmlWhitespaceSensitivity) {
        case "strict":
          return "inline";

        case "ignore":
          return "block";

        default:
          return "vue" === t.parser && e.parent && "root" === e.parent.type ? "block" : "element" === e.type && (!e.namespace || n || Kt(e)) && xt[e.name] || Ot;
      }
    },
    getNodeCssStyleWhiteSpace: en,
    getPrettierIgnoreAttributeCommentData: function getPrettierIgnoreAttributeCommentData(e) {
      var t = e.trim().match(/^prettier-ignore-attribute(?:\s+([^]+))?$/);
      return !!t && (!t[1] || t[1].split(/\s+/));
    },
    hasPrettierIgnore: Ut,
    inferScriptParser: function inferScriptParser(e, t) {
      return "script" !== e.name || e.attrMap.src ? "style" === e.name ? function (e) {
        var t = e.attrMap.lang;
        return t && "postcss" !== t && "css" !== t ? "scss" === t ? "scss" : "less" === t ? "less" : void 0 : "css";
      }(e) : t && sn(e, t) ? Yt(e) || !("src" in e.attrMap) && kt(e.attrMap.lang, t) : void 0 : e.attrMap.lang || e.attrMap.type ? Yt(e) : "babel";
    },
    isVueCustomBlock: nn,
    isVueNonHtmlBlock: sn,
    isVueSlotAttribute: function isVueSlotAttribute(e) {
      var t = e.fullName;
      return "#" === t.charAt(0) || "slot-scope" === t || "v-slot" === t || t.startsWith("v-slot:");
    },
    isVueSfcBindingsAttribute: function isVueSfcBindingsAttribute(e, t) {
      var n = e.parent;
      if (!rn(n, t)) return !1;
      var r = n.fullName,
          s = e.fullName;
      return "script" === r && "setup" === s || "style" === r && "vars" === s;
    },
    isDanglingSpaceSensitiveNode: function isDanglingSpaceSensitiveNode(e) {
      return !(t = e.cssDisplay, Jt(t) || "inline-block" === t || Gt(e));
      var t;
    },
    isIndentationSensitiveNode: Vt,
    isLeadingSpaceSensitiveNode: function isLeadingSpaceSensitiveNode(e, t) {
      var n = function () {
        if (Nt(e)) return !1;
        if (("text" === e.type || "interpolation" === e.type) && e.prev && ("text" === e.prev.type || "interpolation" === e.prev.type)) return !0;
        if (!e.parent || "none" === e.parent.cssDisplay) return !1;
        if (Zt(e.parent)) return !0;
        if (!e.prev && ("root" === e.parent.type || Zt(e) && e.parent || Gt(e.parent) || nn(e.parent, t) || (n = e.parent.cssDisplay, Jt(n) || "inline-block" === n))) return !1;
        var n;
        if (e.prev && !function (e) {
          return !Jt(e);
        }(e.prev.cssDisplay)) return !1;
        return !0;
      }();

      return n && !e.prev && e.parent && e.parent.tagDefinition && e.parent.tagDefinition.ignoreFirstLf ? "interpolation" === e.type : n;
    },
    isPreLikeNode: Zt,
    isScriptLikeTag: Gt,
    isTextLikeNode: function isTextLikeNode(e) {
      return "text" === e.type || "comment" === e.type;
    },
    isTrailingSpaceSensitiveNode: function isTrailingSpaceSensitiveNode(e, t) {
      return !Nt(e) && (!("text" !== e.type && "interpolation" !== e.type || !e.next || "text" !== e.next.type && "interpolation" !== e.next.type) || !(!e.parent || "none" === e.parent.cssDisplay) && (!!Zt(e.parent) || !(!e.next && ("root" === e.parent.type || Zt(e) && e.parent || Gt(e.parent) || nn(e.parent, t) || (n = e.parent.cssDisplay, Jt(n) || "inline-block" === n))) && !(e.next && !function (e) {
        return !Jt(e);
      }(e.next.cssDisplay))));
      var n;
    },
    isWhitespaceSensitiveNode: function isWhitespaceSensitiveNode(e) {
      return Gt(e) || "interpolation" === e.type || Vt(e);
    },
    isUnknownNamespace: Kt,
    preferHardlineAsLeadingSpaces: function preferHardlineAsLeadingSpaces(e) {
      return Qt(e) || e.prev && Ht(e.prev) || Xt(e);
    },
    preferHardlineAsTrailingSpaces: Ht,
    shouldNotPrintClosingTag: function shouldNotPrintClosingTag(e, t) {
      return !e.isSelfClosing && !e.endSourceSpan && (Ut(e) || Mt(e.parent, t));
    },
    shouldPreserveContent: Mt,
    unescapeQuoteEntities: function unescapeQuoteEntities(e) {
      return e.replace(/&apos;/g, "'").replace(/&quot;/g, '"');
    }
  };
  var an = {
    hasPragma: function hasPragma(e) {
      return /^\s*<!--\s*@(format|prettier)\s*-->/.test(e);
    },
    insertPragma: function insertPragma(e) {
      return "\x3c!-- @format --\x3e\n\n" + e.replace(/^\s*\n/, "");
    }
  };
  var un = {
    attrs: !0,
    children: !0
  };

  var cn = /*#__PURE__*/function () {
    function cn() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, cn);

      for (var _i4 = 0, _Object$keys2 = Object.keys(e); _i4 < _Object$keys2.length; _i4++) {
        var _t15 = _Object$keys2[_i4];
        var _n21 = e[_t15];
        _t15 in un ? this._setNodes(_t15, _n21) : this[_t15] = _n21;
      }
    }

    _createClass(cn, [{
      key: "_setNodes",
      value: function _setNodes(e, t) {
        t !== this[e] && (this[e] = function (e, t) {
          var n = e.map(function (e) {
            return e instanceof cn ? e.clone() : new cn(e);
          });
          var r = null,
              s = n[0],
              i = n[1] || null;

          for (var _e16 = 0; _e16 < n.length; _e16++) {
            pn(s, {
              index: _e16,
              siblings: n,
              prev: r,
              next: i,
              parent: t
            }), r = s, s = i, i = n[_e16 + 2] || null;
          }

          return n;
        }(t, this), "attrs" === e && pn(this, {
          attrMap: this[e].reduce(function (e, t) {
            return e[t.fullName] = t.value, e;
          }, Object.create(null))
        }));
      }
    }, {
      key: "map",
      value: function map(e) {
        var t = null;

        for (var _n22 in un) {
          var _r24 = this[_n22];

          if (_r24) {
            var _s6 = ln(_r24, function (t) {
              return t.map(e);
            });

            t !== _r24 && (t || (t = new cn()), t._setNodes(_n22, _s6));
          }
        }

        if (t) {
          for (var _e18 in this) {
            _e18 in un || (t[_e18] = this[_e18]);
          }

          var _e17 = this.index,
              _n23 = this.siblings,
              _r25 = this.prev,
              _s7 = this.next,
              _i5 = this.parent;
          pn(t, {
            index: _e17,
            siblings: _n23,
            prev: _r25,
            next: _s7,
            parent: _i5
          });
        }

        return e(t || this);
      }
    }, {
      key: "clone",
      value: function clone(e) {
        return new cn(e ? Object.assign({}, this, e) : this);
      }
    }, {
      key: "firstChild",
      get: function get() {
        return this.children && 0 !== this.children.length ? this.children[0] : null;
      }
    }, {
      key: "lastChild",
      get: function get() {
        return this.children && 0 !== this.children.length ? this.children[this.children.length - 1] : null;
      }
    }, {
      key: "rawName",
      get: function get() {
        return this.hasExplicitNamespace ? this.fullName : this.name;
      }
    }, {
      key: "fullName",
      get: function get() {
        return this.namespace ? this.namespace + ":" + this.name : this.name;
      }
    }]);

    return cn;
  }();

  function ln(e, t) {
    var n = e.map(t);
    return n.some(function (t, n) {
      return t !== e[n];
    }) ? n : e;
  }

  function pn(e, t) {
    var n = Object.keys(t).reduce(function (e, n) {
      return e[n] = {
        value: t[n],
        enumerable: !1
      }, e;
    }, {});
    Object.defineProperties(e, n);
  }

  var Dn = {
    Node: cn
  };
  var hn = o.ParseSourceSpan,
      dn = [[/^(\[if([^\]]*?)]>)([\S\s]*?)<!\s*\[endif]$/, function (e, t, n) {
    var _n24 = _slicedToArray(n, 4),
        r = _n24[1],
        s = _n24[2],
        i = _n24[3],
        o = "\x3c!--".length + r.length,
        a = e.sourceSpan.start.moveBy(o),
        u = a.moveBy(i.length),
        _ref16 = function () {
      try {
        return [!0, t(i, a).children];
      } catch (e) {
        return [!1, [{
          type: "text",
          value: i,
          sourceSpan: new hn(a, u)
        }]];
      }
    }(),
        _ref17 = _slicedToArray(_ref16, 2),
        c = _ref17[0],
        l = _ref17[1];

    return {
      type: "ieConditionalComment",
      complete: c,
      children: l,
      condition: s.trim().replace(/\s+/g, " "),
      sourceSpan: e.sourceSpan,
      startSourceSpan: new hn(e.sourceSpan.start, a),
      endSourceSpan: new hn(u, e.sourceSpan.end)
    };
  }], [/^\[if([^\]]*?)]><!$/, function (e, t, n) {
    var _n25 = _slicedToArray(n, 2),
        r = _n25[1];

    return {
      type: "ieConditionalStartComment",
      condition: r.trim().replace(/\s+/g, " "),
      sourceSpan: e.sourceSpan
    };
  }], [/^<!\s*\[endif]$/, function (e) {
    return {
      type: "ieConditionalEndComment",
      sourceSpan: e.sourceSpan
    };
  }]];
  var fn = {
    parseIeConditionalComment: function parseIeConditionalComment(e, t) {
      if (e.value) {
        var _n26;

        var _iterator8 = _createForOfIteratorHelper(dn),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _step8$value = _slicedToArray(_step8.value, 2),
                _r26 = _step8$value[0],
                _s8 = _step8$value[1];

            if (_n26 = e.value.match(_r26)) return _s8(e, t, _n26);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }

      return null;
    }
  };

  var mn = {
    locStart: function locStart(e) {
      return e.sourceSpan.start.offset;
    },
    locEnd: function locEnd(e) {
      return e.sourceSpan.end.offset;
    }
  },
      gn = t(function (e, t) {
    function n(e) {
      if (":" != e[0]) return [null, e];
      var t = e.indexOf(":", 1);
      if (-1 == t) throw new Error('Unsupported format "'.concat(e, '" expecting ":namespace:name"'));
      return [e.slice(1, t), e.slice(t + 1)];
    }
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */


    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.RAW_TEXT = 0] = "RAW_TEXT", e[e.ESCAPABLE_RAW_TEXT = 1] = "ESCAPABLE_RAW_TEXT", e[e.PARSABLE_DATA = 2] = "PARSABLE_DATA";
    }(t.TagContentType || (t.TagContentType = {})), t.splitNsName = n, t.isNgContainer = function (e) {
      return "ng-container" === n(e)[1];
    }, t.isNgContent = function (e) {
      return "ng-content" === n(e)[1];
    }, t.isNgTemplate = function (e) {
      return "ng-template" === n(e)[1];
    }, t.getNsPrefix = function (e) {
      return null === e ? null : n(e)[0];
    }, t.mergeNsAndName = function (e, t) {
      return e ? ":".concat(e, ":").concat(t) : t;
    }, t.NAMED_ENTITIES = {
      Aacute: "\xc1",
      aacute: "\xe1",
      Abreve: "\u0102",
      abreve: "\u0103",
      ac: "\u223E",
      acd: "\u223F",
      acE: "\u223E\u0333",
      Acirc: "\xc2",
      acirc: "\xe2",
      acute: "\xb4",
      Acy: "\u0410",
      acy: "\u0430",
      AElig: "\xc6",
      aelig: "\xe6",
      af: "\u2061",
      Afr: "\uD835\uDD04",
      afr: "\uD835\uDD1E",
      Agrave: "\xc0",
      agrave: "\xe0",
      alefsym: "\u2135",
      aleph: "\u2135",
      Alpha: "\u0391",
      alpha: "\u03B1",
      Amacr: "\u0100",
      amacr: "\u0101",
      amalg: "\u2A3F",
      AMP: "&",
      amp: "&",
      And: "\u2A53",
      and: "\u2227",
      andand: "\u2A55",
      andd: "\u2A5C",
      andslope: "\u2A58",
      andv: "\u2A5A",
      ang: "\u2220",
      ange: "\u29A4",
      angle: "\u2220",
      angmsd: "\u2221",
      angmsdaa: "\u29A8",
      angmsdab: "\u29A9",
      angmsdac: "\u29AA",
      angmsdad: "\u29AB",
      angmsdae: "\u29AC",
      angmsdaf: "\u29AD",
      angmsdag: "\u29AE",
      angmsdah: "\u29AF",
      angrt: "\u221F",
      angrtvb: "\u22BE",
      angrtvbd: "\u299D",
      angsph: "\u2222",
      angst: "\xc5",
      angzarr: "\u237C",
      Aogon: "\u0104",
      aogon: "\u0105",
      Aopf: "\uD835\uDD38",
      aopf: "\uD835\uDD52",
      ap: "\u2248",
      apacir: "\u2A6F",
      apE: "\u2A70",
      ape: "\u224A",
      apid: "\u224B",
      apos: "'",
      ApplyFunction: "\u2061",
      approx: "\u2248",
      approxeq: "\u224A",
      Aring: "\xc5",
      aring: "\xe5",
      Ascr: "\uD835\uDC9C",
      ascr: "\uD835\uDCB6",
      Assign: "\u2254",
      ast: "*",
      asymp: "\u2248",
      asympeq: "\u224D",
      Atilde: "\xc3",
      atilde: "\xe3",
      Auml: "\xc4",
      auml: "\xe4",
      awconint: "\u2233",
      awint: "\u2A11",
      backcong: "\u224C",
      backepsilon: "\u03F6",
      backprime: "\u2035",
      backsim: "\u223D",
      backsimeq: "\u22CD",
      Backslash: "\u2216",
      Barv: "\u2AE7",
      barvee: "\u22BD",
      Barwed: "\u2306",
      barwed: "\u2305",
      barwedge: "\u2305",
      bbrk: "\u23B5",
      bbrktbrk: "\u23B6",
      bcong: "\u224C",
      Bcy: "\u0411",
      bcy: "\u0431",
      bdquo: "\u201E",
      becaus: "\u2235",
      Because: "\u2235",
      because: "\u2235",
      bemptyv: "\u29B0",
      bepsi: "\u03F6",
      bernou: "\u212C",
      Bernoullis: "\u212C",
      Beta: "\u0392",
      beta: "\u03B2",
      beth: "\u2136",
      between: "\u226C",
      Bfr: "\uD835\uDD05",
      bfr: "\uD835\uDD1F",
      bigcap: "\u22C2",
      bigcirc: "\u25EF",
      bigcup: "\u22C3",
      bigodot: "\u2A00",
      bigoplus: "\u2A01",
      bigotimes: "\u2A02",
      bigsqcup: "\u2A06",
      bigstar: "\u2605",
      bigtriangledown: "\u25BD",
      bigtriangleup: "\u25B3",
      biguplus: "\u2A04",
      bigvee: "\u22C1",
      bigwedge: "\u22C0",
      bkarow: "\u290D",
      blacklozenge: "\u29EB",
      blacksquare: "\u25AA",
      blacktriangle: "\u25B4",
      blacktriangledown: "\u25BE",
      blacktriangleleft: "\u25C2",
      blacktriangleright: "\u25B8",
      blank: "\u2423",
      blk12: "\u2592",
      blk14: "\u2591",
      blk34: "\u2593",
      block: "\u2588",
      bne: "=\u20E5",
      bnequiv: "\u2261\u20E5",
      bNot: "\u2AED",
      bnot: "\u2310",
      Bopf: "\uD835\uDD39",
      bopf: "\uD835\uDD53",
      bot: "\u22A5",
      bottom: "\u22A5",
      bowtie: "\u22C8",
      boxbox: "\u29C9",
      boxDL: "\u2557",
      boxDl: "\u2556",
      boxdL: "\u2555",
      boxdl: "\u2510",
      boxDR: "\u2554",
      boxDr: "\u2553",
      boxdR: "\u2552",
      boxdr: "\u250C",
      boxH: "\u2550",
      boxh: "\u2500",
      boxHD: "\u2566",
      boxHd: "\u2564",
      boxhD: "\u2565",
      boxhd: "\u252C",
      boxHU: "\u2569",
      boxHu: "\u2567",
      boxhU: "\u2568",
      boxhu: "\u2534",
      boxminus: "\u229F",
      boxplus: "\u229E",
      boxtimes: "\u22A0",
      boxUL: "\u255D",
      boxUl: "\u255C",
      boxuL: "\u255B",
      boxul: "\u2518",
      boxUR: "\u255A",
      boxUr: "\u2559",
      boxuR: "\u2558",
      boxur: "\u2514",
      boxV: "\u2551",
      boxv: "\u2502",
      boxVH: "\u256C",
      boxVh: "\u256B",
      boxvH: "\u256A",
      boxvh: "\u253C",
      boxVL: "\u2563",
      boxVl: "\u2562",
      boxvL: "\u2561",
      boxvl: "\u2524",
      boxVR: "\u2560",
      boxVr: "\u255F",
      boxvR: "\u255E",
      boxvr: "\u251C",
      bprime: "\u2035",
      Breve: "\u02D8",
      breve: "\u02D8",
      brvbar: "\xa6",
      Bscr: "\u212C",
      bscr: "\uD835\uDCB7",
      bsemi: "\u204F",
      bsim: "\u223D",
      bsime: "\u22CD",
      bsol: "\\",
      bsolb: "\u29C5",
      bsolhsub: "\u27C8",
      bull: "\u2022",
      bullet: "\u2022",
      bump: "\u224E",
      bumpE: "\u2AAE",
      bumpe: "\u224F",
      Bumpeq: "\u224E",
      bumpeq: "\u224F",
      Cacute: "\u0106",
      cacute: "\u0107",
      Cap: "\u22D2",
      cap: "\u2229",
      capand: "\u2A44",
      capbrcup: "\u2A49",
      capcap: "\u2A4B",
      capcup: "\u2A47",
      capdot: "\u2A40",
      CapitalDifferentialD: "\u2145",
      caps: "\u2229\uFE00",
      caret: "\u2041",
      caron: "\u02C7",
      Cayleys: "\u212D",
      ccaps: "\u2A4D",
      Ccaron: "\u010C",
      ccaron: "\u010D",
      Ccedil: "\xc7",
      ccedil: "\xe7",
      Ccirc: "\u0108",
      ccirc: "\u0109",
      Cconint: "\u2230",
      ccups: "\u2A4C",
      ccupssm: "\u2A50",
      Cdot: "\u010A",
      cdot: "\u010B",
      cedil: "\xb8",
      Cedilla: "\xb8",
      cemptyv: "\u29B2",
      cent: "\xa2",
      CenterDot: "\xb7",
      centerdot: "\xb7",
      Cfr: "\u212D",
      cfr: "\uD835\uDD20",
      CHcy: "\u0427",
      chcy: "\u0447",
      check: "\u2713",
      checkmark: "\u2713",
      Chi: "\u03A7",
      chi: "\u03C7",
      cir: "\u25CB",
      circ: "\u02C6",
      circeq: "\u2257",
      circlearrowleft: "\u21BA",
      circlearrowright: "\u21BB",
      circledast: "\u229B",
      circledcirc: "\u229A",
      circleddash: "\u229D",
      CircleDot: "\u2299",
      circledR: "\xae",
      circledS: "\u24C8",
      CircleMinus: "\u2296",
      CirclePlus: "\u2295",
      CircleTimes: "\u2297",
      cirE: "\u29C3",
      cire: "\u2257",
      cirfnint: "\u2A10",
      cirmid: "\u2AEF",
      cirscir: "\u29C2",
      ClockwiseContourIntegral: "\u2232",
      CloseCurlyDoubleQuote: "\u201D",
      CloseCurlyQuote: "\u2019",
      clubs: "\u2663",
      clubsuit: "\u2663",
      Colon: "\u2237",
      colon: ":",
      Colone: "\u2A74",
      colone: "\u2254",
      coloneq: "\u2254",
      comma: ",",
      commat: "@",
      comp: "\u2201",
      compfn: "\u2218",
      complement: "\u2201",
      complexes: "\u2102",
      cong: "\u2245",
      congdot: "\u2A6D",
      Congruent: "\u2261",
      Conint: "\u222F",
      conint: "\u222E",
      ContourIntegral: "\u222E",
      Copf: "\u2102",
      copf: "\uD835\uDD54",
      coprod: "\u2210",
      Coproduct: "\u2210",
      COPY: "\xa9",
      copy: "\xa9",
      copysr: "\u2117",
      CounterClockwiseContourIntegral: "\u2233",
      crarr: "\u21B5",
      Cross: "\u2A2F",
      cross: "\u2717",
      Cscr: "\uD835\uDC9E",
      cscr: "\uD835\uDCB8",
      csub: "\u2ACF",
      csube: "\u2AD1",
      csup: "\u2AD0",
      csupe: "\u2AD2",
      ctdot: "\u22EF",
      cudarrl: "\u2938",
      cudarrr: "\u2935",
      cuepr: "\u22DE",
      cuesc: "\u22DF",
      cularr: "\u21B6",
      cularrp: "\u293D",
      Cup: "\u22D3",
      cup: "\u222A",
      cupbrcap: "\u2A48",
      CupCap: "\u224D",
      cupcap: "\u2A46",
      cupcup: "\u2A4A",
      cupdot: "\u228D",
      cupor: "\u2A45",
      cups: "\u222A\uFE00",
      curarr: "\u21B7",
      curarrm: "\u293C",
      curlyeqprec: "\u22DE",
      curlyeqsucc: "\u22DF",
      curlyvee: "\u22CE",
      curlywedge: "\u22CF",
      curren: "\xa4",
      curvearrowleft: "\u21B6",
      curvearrowright: "\u21B7",
      cuvee: "\u22CE",
      cuwed: "\u22CF",
      cwconint: "\u2232",
      cwint: "\u2231",
      cylcty: "\u232D",
      Dagger: "\u2021",
      dagger: "\u2020",
      daleth: "\u2138",
      Darr: "\u21A1",
      dArr: "\u21D3",
      darr: "\u2193",
      dash: "\u2010",
      Dashv: "\u2AE4",
      dashv: "\u22A3",
      dbkarow: "\u290F",
      dblac: "\u02DD",
      Dcaron: "\u010E",
      dcaron: "\u010F",
      Dcy: "\u0414",
      dcy: "\u0434",
      DD: "\u2145",
      dd: "\u2146",
      ddagger: "\u2021",
      ddarr: "\u21CA",
      DDotrahd: "\u2911",
      ddotseq: "\u2A77",
      deg: "\xb0",
      Del: "\u2207",
      Delta: "\u0394",
      delta: "\u03B4",
      demptyv: "\u29B1",
      dfisht: "\u297F",
      Dfr: "\uD835\uDD07",
      dfr: "\uD835\uDD21",
      dHar: "\u2965",
      dharl: "\u21C3",
      dharr: "\u21C2",
      DiacriticalAcute: "\xb4",
      DiacriticalDot: "\u02D9",
      DiacriticalDoubleAcute: "\u02DD",
      DiacriticalGrave: "`",
      DiacriticalTilde: "\u02DC",
      diam: "\u22C4",
      Diamond: "\u22C4",
      diamond: "\u22C4",
      diamondsuit: "\u2666",
      diams: "\u2666",
      die: "\xa8",
      DifferentialD: "\u2146",
      digamma: "\u03DD",
      disin: "\u22F2",
      div: "\xf7",
      divide: "\xf7",
      divideontimes: "\u22C7",
      divonx: "\u22C7",
      DJcy: "\u0402",
      djcy: "\u0452",
      dlcorn: "\u231E",
      dlcrop: "\u230D",
      dollar: "$",
      Dopf: "\uD835\uDD3B",
      dopf: "\uD835\uDD55",
      Dot: "\xa8",
      dot: "\u02D9",
      DotDot: "\u20DC",
      doteq: "\u2250",
      doteqdot: "\u2251",
      DotEqual: "\u2250",
      dotminus: "\u2238",
      dotplus: "\u2214",
      dotsquare: "\u22A1",
      doublebarwedge: "\u2306",
      DoubleContourIntegral: "\u222F",
      DoubleDot: "\xa8",
      DoubleDownArrow: "\u21D3",
      DoubleLeftArrow: "\u21D0",
      DoubleLeftRightArrow: "\u21D4",
      DoubleLeftTee: "\u2AE4",
      DoubleLongLeftArrow: "\u27F8",
      DoubleLongLeftRightArrow: "\u27FA",
      DoubleLongRightArrow: "\u27F9",
      DoubleRightArrow: "\u21D2",
      DoubleRightTee: "\u22A8",
      DoubleUpArrow: "\u21D1",
      DoubleUpDownArrow: "\u21D5",
      DoubleVerticalBar: "\u2225",
      DownArrow: "\u2193",
      Downarrow: "\u21D3",
      downarrow: "\u2193",
      DownArrowBar: "\u2913",
      DownArrowUpArrow: "\u21F5",
      DownBreve: "\u0311",
      downdownarrows: "\u21CA",
      downharpoonleft: "\u21C3",
      downharpoonright: "\u21C2",
      DownLeftRightVector: "\u2950",
      DownLeftTeeVector: "\u295E",
      DownLeftVector: "\u21BD",
      DownLeftVectorBar: "\u2956",
      DownRightTeeVector: "\u295F",
      DownRightVector: "\u21C1",
      DownRightVectorBar: "\u2957",
      DownTee: "\u22A4",
      DownTeeArrow: "\u21A7",
      drbkarow: "\u2910",
      drcorn: "\u231F",
      drcrop: "\u230C",
      Dscr: "\uD835\uDC9F",
      dscr: "\uD835\uDCB9",
      DScy: "\u0405",
      dscy: "\u0455",
      dsol: "\u29F6",
      Dstrok: "\u0110",
      dstrok: "\u0111",
      dtdot: "\u22F1",
      dtri: "\u25BF",
      dtrif: "\u25BE",
      duarr: "\u21F5",
      duhar: "\u296F",
      dwangle: "\u29A6",
      DZcy: "\u040F",
      dzcy: "\u045F",
      dzigrarr: "\u27FF",
      Eacute: "\xc9",
      eacute: "\xe9",
      easter: "\u2A6E",
      Ecaron: "\u011A",
      ecaron: "\u011B",
      ecir: "\u2256",
      Ecirc: "\xca",
      ecirc: "\xea",
      ecolon: "\u2255",
      Ecy: "\u042D",
      ecy: "\u044D",
      eDDot: "\u2A77",
      Edot: "\u0116",
      eDot: "\u2251",
      edot: "\u0117",
      ee: "\u2147",
      efDot: "\u2252",
      Efr: "\uD835\uDD08",
      efr: "\uD835\uDD22",
      eg: "\u2A9A",
      Egrave: "\xc8",
      egrave: "\xe8",
      egs: "\u2A96",
      egsdot: "\u2A98",
      el: "\u2A99",
      Element: "\u2208",
      elinters: "\u23E7",
      ell: "\u2113",
      els: "\u2A95",
      elsdot: "\u2A97",
      Emacr: "\u0112",
      emacr: "\u0113",
      empty: "\u2205",
      emptyset: "\u2205",
      EmptySmallSquare: "\u25FB",
      emptyv: "\u2205",
      EmptyVerySmallSquare: "\u25AB",
      emsp: "\u2003",
      emsp13: "\u2004",
      emsp14: "\u2005",
      ENG: "\u014A",
      eng: "\u014B",
      ensp: "\u2002",
      Eogon: "\u0118",
      eogon: "\u0119",
      Eopf: "\uD835\uDD3C",
      eopf: "\uD835\uDD56",
      epar: "\u22D5",
      eparsl: "\u29E3",
      eplus: "\u2A71",
      epsi: "\u03B5",
      Epsilon: "\u0395",
      epsilon: "\u03B5",
      epsiv: "\u03F5",
      eqcirc: "\u2256",
      eqcolon: "\u2255",
      eqsim: "\u2242",
      eqslantgtr: "\u2A96",
      eqslantless: "\u2A95",
      Equal: "\u2A75",
      equals: "=",
      EqualTilde: "\u2242",
      equest: "\u225F",
      Equilibrium: "\u21CC",
      equiv: "\u2261",
      equivDD: "\u2A78",
      eqvparsl: "\u29E5",
      erarr: "\u2971",
      erDot: "\u2253",
      Escr: "\u2130",
      escr: "\u212F",
      esdot: "\u2250",
      Esim: "\u2A73",
      esim: "\u2242",
      Eta: "\u0397",
      eta: "\u03B7",
      ETH: "\xd0",
      eth: "\xf0",
      Euml: "\xcb",
      euml: "\xeb",
      euro: "\u20AC",
      excl: "!",
      exist: "\u2203",
      Exists: "\u2203",
      expectation: "\u2130",
      ExponentialE: "\u2147",
      exponentiale: "\u2147",
      fallingdotseq: "\u2252",
      Fcy: "\u0424",
      fcy: "\u0444",
      female: "\u2640",
      ffilig: "\uFB03",
      fflig: "\uFB00",
      ffllig: "\uFB04",
      Ffr: "\uD835\uDD09",
      ffr: "\uD835\uDD23",
      filig: "\uFB01",
      FilledSmallSquare: "\u25FC",
      FilledVerySmallSquare: "\u25AA",
      fjlig: "fj",
      flat: "\u266D",
      fllig: "\uFB02",
      fltns: "\u25B1",
      fnof: "\u0192",
      Fopf: "\uD835\uDD3D",
      fopf: "\uD835\uDD57",
      ForAll: "\u2200",
      forall: "\u2200",
      fork: "\u22D4",
      forkv: "\u2AD9",
      Fouriertrf: "\u2131",
      fpartint: "\u2A0D",
      frac12: "\xbd",
      frac13: "\u2153",
      frac14: "\xbc",
      frac15: "\u2155",
      frac16: "\u2159",
      frac18: "\u215B",
      frac23: "\u2154",
      frac25: "\u2156",
      frac34: "\xbe",
      frac35: "\u2157",
      frac38: "\u215C",
      frac45: "\u2158",
      frac56: "\u215A",
      frac58: "\u215D",
      frac78: "\u215E",
      frasl: "\u2044",
      frown: "\u2322",
      Fscr: "\u2131",
      fscr: "\uD835\uDCBB",
      gacute: "\u01F5",
      Gamma: "\u0393",
      gamma: "\u03B3",
      Gammad: "\u03DC",
      gammad: "\u03DD",
      gap: "\u2A86",
      Gbreve: "\u011E",
      gbreve: "\u011F",
      Gcedil: "\u0122",
      Gcirc: "\u011C",
      gcirc: "\u011D",
      Gcy: "\u0413",
      gcy: "\u0433",
      Gdot: "\u0120",
      gdot: "\u0121",
      gE: "\u2267",
      ge: "\u2265",
      gEl: "\u2A8C",
      gel: "\u22DB",
      geq: "\u2265",
      geqq: "\u2267",
      geqslant: "\u2A7E",
      ges: "\u2A7E",
      gescc: "\u2AA9",
      gesdot: "\u2A80",
      gesdoto: "\u2A82",
      gesdotol: "\u2A84",
      gesl: "\u22DB\uFE00",
      gesles: "\u2A94",
      Gfr: "\uD835\uDD0A",
      gfr: "\uD835\uDD24",
      Gg: "\u22D9",
      gg: "\u226B",
      ggg: "\u22D9",
      gimel: "\u2137",
      GJcy: "\u0403",
      gjcy: "\u0453",
      gl: "\u2277",
      gla: "\u2AA5",
      glE: "\u2A92",
      glj: "\u2AA4",
      gnap: "\u2A8A",
      gnapprox: "\u2A8A",
      gnE: "\u2269",
      gne: "\u2A88",
      gneq: "\u2A88",
      gneqq: "\u2269",
      gnsim: "\u22E7",
      Gopf: "\uD835\uDD3E",
      gopf: "\uD835\uDD58",
      grave: "`",
      GreaterEqual: "\u2265",
      GreaterEqualLess: "\u22DB",
      GreaterFullEqual: "\u2267",
      GreaterGreater: "\u2AA2",
      GreaterLess: "\u2277",
      GreaterSlantEqual: "\u2A7E",
      GreaterTilde: "\u2273",
      Gscr: "\uD835\uDCA2",
      gscr: "\u210A",
      gsim: "\u2273",
      gsime: "\u2A8E",
      gsiml: "\u2A90",
      GT: ">",
      Gt: "\u226B",
      gt: ">",
      gtcc: "\u2AA7",
      gtcir: "\u2A7A",
      gtdot: "\u22D7",
      gtlPar: "\u2995",
      gtquest: "\u2A7C",
      gtrapprox: "\u2A86",
      gtrarr: "\u2978",
      gtrdot: "\u22D7",
      gtreqless: "\u22DB",
      gtreqqless: "\u2A8C",
      gtrless: "\u2277",
      gtrsim: "\u2273",
      gvertneqq: "\u2269\uFE00",
      gvnE: "\u2269\uFE00",
      Hacek: "\u02C7",
      hairsp: "\u200A",
      half: "\xbd",
      hamilt: "\u210B",
      HARDcy: "\u042A",
      hardcy: "\u044A",
      hArr: "\u21D4",
      harr: "\u2194",
      harrcir: "\u2948",
      harrw: "\u21AD",
      Hat: "^",
      hbar: "\u210F",
      Hcirc: "\u0124",
      hcirc: "\u0125",
      hearts: "\u2665",
      heartsuit: "\u2665",
      hellip: "\u2026",
      hercon: "\u22B9",
      Hfr: "\u210C",
      hfr: "\uD835\uDD25",
      HilbertSpace: "\u210B",
      hksearow: "\u2925",
      hkswarow: "\u2926",
      hoarr: "\u21FF",
      homtht: "\u223B",
      hookleftarrow: "\u21A9",
      hookrightarrow: "\u21AA",
      Hopf: "\u210D",
      hopf: "\uD835\uDD59",
      horbar: "\u2015",
      HorizontalLine: "\u2500",
      Hscr: "\u210B",
      hscr: "\uD835\uDCBD",
      hslash: "\u210F",
      Hstrok: "\u0126",
      hstrok: "\u0127",
      HumpDownHump: "\u224E",
      HumpEqual: "\u224F",
      hybull: "\u2043",
      hyphen: "\u2010",
      Iacute: "\xcd",
      iacute: "\xed",
      ic: "\u2063",
      Icirc: "\xce",
      icirc: "\xee",
      Icy: "\u0418",
      icy: "\u0438",
      Idot: "\u0130",
      IEcy: "\u0415",
      iecy: "\u0435",
      iexcl: "\xa1",
      iff: "\u21D4",
      Ifr: "\u2111",
      ifr: "\uD835\uDD26",
      Igrave: "\xcc",
      igrave: "\xec",
      ii: "\u2148",
      iiiint: "\u2A0C",
      iiint: "\u222D",
      iinfin: "\u29DC",
      iiota: "\u2129",
      IJlig: "\u0132",
      ijlig: "\u0133",
      Im: "\u2111",
      Imacr: "\u012A",
      imacr: "\u012B",
      image: "\u2111",
      ImaginaryI: "\u2148",
      imagline: "\u2110",
      imagpart: "\u2111",
      imath: "\u0131",
      imof: "\u22B7",
      imped: "\u01B5",
      Implies: "\u21D2",
      in: "\u2208",
      incare: "\u2105",
      infin: "\u221E",
      infintie: "\u29DD",
      inodot: "\u0131",
      Int: "\u222C",
      int: "\u222B",
      intcal: "\u22BA",
      integers: "\u2124",
      Integral: "\u222B",
      intercal: "\u22BA",
      Intersection: "\u22C2",
      intlarhk: "\u2A17",
      intprod: "\u2A3C",
      InvisibleComma: "\u2063",
      InvisibleTimes: "\u2062",
      IOcy: "\u0401",
      iocy: "\u0451",
      Iogon: "\u012E",
      iogon: "\u012F",
      Iopf: "\uD835\uDD40",
      iopf: "\uD835\uDD5A",
      Iota: "\u0399",
      iota: "\u03B9",
      iprod: "\u2A3C",
      iquest: "\xbf",
      Iscr: "\u2110",
      iscr: "\uD835\uDCBE",
      isin: "\u2208",
      isindot: "\u22F5",
      isinE: "\u22F9",
      isins: "\u22F4",
      isinsv: "\u22F3",
      isinv: "\u2208",
      it: "\u2062",
      Itilde: "\u0128",
      itilde: "\u0129",
      Iukcy: "\u0406",
      iukcy: "\u0456",
      Iuml: "\xcf",
      iuml: "\xef",
      Jcirc: "\u0134",
      jcirc: "\u0135",
      Jcy: "\u0419",
      jcy: "\u0439",
      Jfr: "\uD835\uDD0D",
      jfr: "\uD835\uDD27",
      jmath: "\u0237",
      Jopf: "\uD835\uDD41",
      jopf: "\uD835\uDD5B",
      Jscr: "\uD835\uDCA5",
      jscr: "\uD835\uDCBF",
      Jsercy: "\u0408",
      jsercy: "\u0458",
      Jukcy: "\u0404",
      jukcy: "\u0454",
      Kappa: "\u039A",
      kappa: "\u03BA",
      kappav: "\u03F0",
      Kcedil: "\u0136",
      kcedil: "\u0137",
      Kcy: "\u041A",
      kcy: "\u043A",
      Kfr: "\uD835\uDD0E",
      kfr: "\uD835\uDD28",
      kgreen: "\u0138",
      KHcy: "\u0425",
      khcy: "\u0445",
      KJcy: "\u040C",
      kjcy: "\u045C",
      Kopf: "\uD835\uDD42",
      kopf: "\uD835\uDD5C",
      Kscr: "\uD835\uDCA6",
      kscr: "\uD835\uDCC0",
      lAarr: "\u21DA",
      Lacute: "\u0139",
      lacute: "\u013A",
      laemptyv: "\u29B4",
      lagran: "\u2112",
      Lambda: "\u039B",
      lambda: "\u03BB",
      Lang: "\u27EA",
      lang: "\u27E8",
      langd: "\u2991",
      langle: "\u27E8",
      lap: "\u2A85",
      Laplacetrf: "\u2112",
      laquo: "\xab",
      Larr: "\u219E",
      lArr: "\u21D0",
      larr: "\u2190",
      larrb: "\u21E4",
      larrbfs: "\u291F",
      larrfs: "\u291D",
      larrhk: "\u21A9",
      larrlp: "\u21AB",
      larrpl: "\u2939",
      larrsim: "\u2973",
      larrtl: "\u21A2",
      lat: "\u2AAB",
      lAtail: "\u291B",
      latail: "\u2919",
      late: "\u2AAD",
      lates: "\u2AAD\uFE00",
      lBarr: "\u290E",
      lbarr: "\u290C",
      lbbrk: "\u2772",
      lbrace: "{",
      lbrack: "[",
      lbrke: "\u298B",
      lbrksld: "\u298F",
      lbrkslu: "\u298D",
      Lcaron: "\u013D",
      lcaron: "\u013E",
      Lcedil: "\u013B",
      lcedil: "\u013C",
      lceil: "\u2308",
      lcub: "{",
      Lcy: "\u041B",
      lcy: "\u043B",
      ldca: "\u2936",
      ldquo: "\u201C",
      ldquor: "\u201E",
      ldrdhar: "\u2967",
      ldrushar: "\u294B",
      ldsh: "\u21B2",
      lE: "\u2266",
      le: "\u2264",
      LeftAngleBracket: "\u27E8",
      LeftArrow: "\u2190",
      Leftarrow: "\u21D0",
      leftarrow: "\u2190",
      LeftArrowBar: "\u21E4",
      LeftArrowRightArrow: "\u21C6",
      leftarrowtail: "\u21A2",
      LeftCeiling: "\u2308",
      LeftDoubleBracket: "\u27E6",
      LeftDownTeeVector: "\u2961",
      LeftDownVector: "\u21C3",
      LeftDownVectorBar: "\u2959",
      LeftFloor: "\u230A",
      leftharpoondown: "\u21BD",
      leftharpoonup: "\u21BC",
      leftleftarrows: "\u21C7",
      LeftRightArrow: "\u2194",
      Leftrightarrow: "\u21D4",
      leftrightarrow: "\u2194",
      leftrightarrows: "\u21C6",
      leftrightharpoons: "\u21CB",
      leftrightsquigarrow: "\u21AD",
      LeftRightVector: "\u294E",
      LeftTee: "\u22A3",
      LeftTeeArrow: "\u21A4",
      LeftTeeVector: "\u295A",
      leftthreetimes: "\u22CB",
      LeftTriangle: "\u22B2",
      LeftTriangleBar: "\u29CF",
      LeftTriangleEqual: "\u22B4",
      LeftUpDownVector: "\u2951",
      LeftUpTeeVector: "\u2960",
      LeftUpVector: "\u21BF",
      LeftUpVectorBar: "\u2958",
      LeftVector: "\u21BC",
      LeftVectorBar: "\u2952",
      lEg: "\u2A8B",
      leg: "\u22DA",
      leq: "\u2264",
      leqq: "\u2266",
      leqslant: "\u2A7D",
      les: "\u2A7D",
      lescc: "\u2AA8",
      lesdot: "\u2A7F",
      lesdoto: "\u2A81",
      lesdotor: "\u2A83",
      lesg: "\u22DA\uFE00",
      lesges: "\u2A93",
      lessapprox: "\u2A85",
      lessdot: "\u22D6",
      lesseqgtr: "\u22DA",
      lesseqqgtr: "\u2A8B",
      LessEqualGreater: "\u22DA",
      LessFullEqual: "\u2266",
      LessGreater: "\u2276",
      lessgtr: "\u2276",
      LessLess: "\u2AA1",
      lesssim: "\u2272",
      LessSlantEqual: "\u2A7D",
      LessTilde: "\u2272",
      lfisht: "\u297C",
      lfloor: "\u230A",
      Lfr: "\uD835\uDD0F",
      lfr: "\uD835\uDD29",
      lg: "\u2276",
      lgE: "\u2A91",
      lHar: "\u2962",
      lhard: "\u21BD",
      lharu: "\u21BC",
      lharul: "\u296A",
      lhblk: "\u2584",
      LJcy: "\u0409",
      ljcy: "\u0459",
      Ll: "\u22D8",
      ll: "\u226A",
      llarr: "\u21C7",
      llcorner: "\u231E",
      Lleftarrow: "\u21DA",
      llhard: "\u296B",
      lltri: "\u25FA",
      Lmidot: "\u013F",
      lmidot: "\u0140",
      lmoust: "\u23B0",
      lmoustache: "\u23B0",
      lnap: "\u2A89",
      lnapprox: "\u2A89",
      lnE: "\u2268",
      lne: "\u2A87",
      lneq: "\u2A87",
      lneqq: "\u2268",
      lnsim: "\u22E6",
      loang: "\u27EC",
      loarr: "\u21FD",
      lobrk: "\u27E6",
      LongLeftArrow: "\u27F5",
      Longleftarrow: "\u27F8",
      longleftarrow: "\u27F5",
      LongLeftRightArrow: "\u27F7",
      Longleftrightarrow: "\u27FA",
      longleftrightarrow: "\u27F7",
      longmapsto: "\u27FC",
      LongRightArrow: "\u27F6",
      Longrightarrow: "\u27F9",
      longrightarrow: "\u27F6",
      looparrowleft: "\u21AB",
      looparrowright: "\u21AC",
      lopar: "\u2985",
      Lopf: "\uD835\uDD43",
      lopf: "\uD835\uDD5D",
      loplus: "\u2A2D",
      lotimes: "\u2A34",
      lowast: "\u2217",
      lowbar: "_",
      LowerLeftArrow: "\u2199",
      LowerRightArrow: "\u2198",
      loz: "\u25CA",
      lozenge: "\u25CA",
      lozf: "\u29EB",
      lpar: "(",
      lparlt: "\u2993",
      lrarr: "\u21C6",
      lrcorner: "\u231F",
      lrhar: "\u21CB",
      lrhard: "\u296D",
      lrm: "\u200E",
      lrtri: "\u22BF",
      lsaquo: "\u2039",
      Lscr: "\u2112",
      lscr: "\uD835\uDCC1",
      Lsh: "\u21B0",
      lsh: "\u21B0",
      lsim: "\u2272",
      lsime: "\u2A8D",
      lsimg: "\u2A8F",
      lsqb: "[",
      lsquo: "\u2018",
      lsquor: "\u201A",
      Lstrok: "\u0141",
      lstrok: "\u0142",
      LT: "<",
      Lt: "\u226A",
      lt: "<",
      ltcc: "\u2AA6",
      ltcir: "\u2A79",
      ltdot: "\u22D6",
      lthree: "\u22CB",
      ltimes: "\u22C9",
      ltlarr: "\u2976",
      ltquest: "\u2A7B",
      ltri: "\u25C3",
      ltrie: "\u22B4",
      ltrif: "\u25C2",
      ltrPar: "\u2996",
      lurdshar: "\u294A",
      luruhar: "\u2966",
      lvertneqq: "\u2268\uFE00",
      lvnE: "\u2268\uFE00",
      macr: "\xaf",
      male: "\u2642",
      malt: "\u2720",
      maltese: "\u2720",
      Map: "\u2905",
      map: "\u21A6",
      mapsto: "\u21A6",
      mapstodown: "\u21A7",
      mapstoleft: "\u21A4",
      mapstoup: "\u21A5",
      marker: "\u25AE",
      mcomma: "\u2A29",
      Mcy: "\u041C",
      mcy: "\u043C",
      mdash: "\u2014",
      mDDot: "\u223A",
      measuredangle: "\u2221",
      MediumSpace: "\u205F",
      Mellintrf: "\u2133",
      Mfr: "\uD835\uDD10",
      mfr: "\uD835\uDD2A",
      mho: "\u2127",
      micro: "\xb5",
      mid: "\u2223",
      midast: "*",
      midcir: "\u2AF0",
      middot: "\xb7",
      minus: "\u2212",
      minusb: "\u229F",
      minusd: "\u2238",
      minusdu: "\u2A2A",
      MinusPlus: "\u2213",
      mlcp: "\u2ADB",
      mldr: "\u2026",
      mnplus: "\u2213",
      models: "\u22A7",
      Mopf: "\uD835\uDD44",
      mopf: "\uD835\uDD5E",
      mp: "\u2213",
      Mscr: "\u2133",
      mscr: "\uD835\uDCC2",
      mstpos: "\u223E",
      Mu: "\u039C",
      mu: "\u03BC",
      multimap: "\u22B8",
      mumap: "\u22B8",
      nabla: "\u2207",
      Nacute: "\u0143",
      nacute: "\u0144",
      nang: "\u2220\u20D2",
      nap: "\u2249",
      napE: "\u2A70\u0338",
      napid: "\u224B\u0338",
      napos: "\u0149",
      napprox: "\u2249",
      natur: "\u266E",
      natural: "\u266E",
      naturals: "\u2115",
      nbsp: "\xa0",
      nbump: "\u224E\u0338",
      nbumpe: "\u224F\u0338",
      ncap: "\u2A43",
      Ncaron: "\u0147",
      ncaron: "\u0148",
      Ncedil: "\u0145",
      ncedil: "\u0146",
      ncong: "\u2247",
      ncongdot: "\u2A6D\u0338",
      ncup: "\u2A42",
      Ncy: "\u041D",
      ncy: "\u043D",
      ndash: "\u2013",
      ne: "\u2260",
      nearhk: "\u2924",
      neArr: "\u21D7",
      nearr: "\u2197",
      nearrow: "\u2197",
      nedot: "\u2250\u0338",
      NegativeMediumSpace: "\u200B",
      NegativeThickSpace: "\u200B",
      NegativeThinSpace: "\u200B",
      NegativeVeryThinSpace: "\u200B",
      nequiv: "\u2262",
      nesear: "\u2928",
      nesim: "\u2242\u0338",
      NestedGreaterGreater: "\u226B",
      NestedLessLess: "\u226A",
      NewLine: "\n",
      nexist: "\u2204",
      nexists: "\u2204",
      Nfr: "\uD835\uDD11",
      nfr: "\uD835\uDD2B",
      ngE: "\u2267\u0338",
      nge: "\u2271",
      ngeq: "\u2271",
      ngeqq: "\u2267\u0338",
      ngeqslant: "\u2A7E\u0338",
      nges: "\u2A7E\u0338",
      nGg: "\u22D9\u0338",
      ngsim: "\u2275",
      nGt: "\u226B\u20D2",
      ngt: "\u226F",
      ngtr: "\u226F",
      nGtv: "\u226B\u0338",
      nhArr: "\u21CE",
      nharr: "\u21AE",
      nhpar: "\u2AF2",
      ni: "\u220B",
      nis: "\u22FC",
      nisd: "\u22FA",
      niv: "\u220B",
      NJcy: "\u040A",
      njcy: "\u045A",
      nlArr: "\u21CD",
      nlarr: "\u219A",
      nldr: "\u2025",
      nlE: "\u2266\u0338",
      nle: "\u2270",
      nLeftarrow: "\u21CD",
      nleftarrow: "\u219A",
      nLeftrightarrow: "\u21CE",
      nleftrightarrow: "\u21AE",
      nleq: "\u2270",
      nleqq: "\u2266\u0338",
      nleqslant: "\u2A7D\u0338",
      nles: "\u2A7D\u0338",
      nless: "\u226E",
      nLl: "\u22D8\u0338",
      nlsim: "\u2274",
      nLt: "\u226A\u20D2",
      nlt: "\u226E",
      nltri: "\u22EA",
      nltrie: "\u22EC",
      nLtv: "\u226A\u0338",
      nmid: "\u2224",
      NoBreak: "\u2060",
      NonBreakingSpace: "\xa0",
      Nopf: "\u2115",
      nopf: "\uD835\uDD5F",
      Not: "\u2AEC",
      not: "\xac",
      NotCongruent: "\u2262",
      NotCupCap: "\u226D",
      NotDoubleVerticalBar: "\u2226",
      NotElement: "\u2209",
      NotEqual: "\u2260",
      NotEqualTilde: "\u2242\u0338",
      NotExists: "\u2204",
      NotGreater: "\u226F",
      NotGreaterEqual: "\u2271",
      NotGreaterFullEqual: "\u2267\u0338",
      NotGreaterGreater: "\u226B\u0338",
      NotGreaterLess: "\u2279",
      NotGreaterSlantEqual: "\u2A7E\u0338",
      NotGreaterTilde: "\u2275",
      NotHumpDownHump: "\u224E\u0338",
      NotHumpEqual: "\u224F\u0338",
      notin: "\u2209",
      notindot: "\u22F5\u0338",
      notinE: "\u22F9\u0338",
      notinva: "\u2209",
      notinvb: "\u22F7",
      notinvc: "\u22F6",
      NotLeftTriangle: "\u22EA",
      NotLeftTriangleBar: "\u29CF\u0338",
      NotLeftTriangleEqual: "\u22EC",
      NotLess: "\u226E",
      NotLessEqual: "\u2270",
      NotLessGreater: "\u2278",
      NotLessLess: "\u226A\u0338",
      NotLessSlantEqual: "\u2A7D\u0338",
      NotLessTilde: "\u2274",
      NotNestedGreaterGreater: "\u2AA2\u0338",
      NotNestedLessLess: "\u2AA1\u0338",
      notni: "\u220C",
      notniva: "\u220C",
      notnivb: "\u22FE",
      notnivc: "\u22FD",
      NotPrecedes: "\u2280",
      NotPrecedesEqual: "\u2AAF\u0338",
      NotPrecedesSlantEqual: "\u22E0",
      NotReverseElement: "\u220C",
      NotRightTriangle: "\u22EB",
      NotRightTriangleBar: "\u29D0\u0338",
      NotRightTriangleEqual: "\u22ED",
      NotSquareSubset: "\u228F\u0338",
      NotSquareSubsetEqual: "\u22E2",
      NotSquareSuperset: "\u2290\u0338",
      NotSquareSupersetEqual: "\u22E3",
      NotSubset: "\u2282\u20D2",
      NotSubsetEqual: "\u2288",
      NotSucceeds: "\u2281",
      NotSucceedsEqual: "\u2AB0\u0338",
      NotSucceedsSlantEqual: "\u22E1",
      NotSucceedsTilde: "\u227F\u0338",
      NotSuperset: "\u2283\u20D2",
      NotSupersetEqual: "\u2289",
      NotTilde: "\u2241",
      NotTildeEqual: "\u2244",
      NotTildeFullEqual: "\u2247",
      NotTildeTilde: "\u2249",
      NotVerticalBar: "\u2224",
      npar: "\u2226",
      nparallel: "\u2226",
      nparsl: "\u2AFD\u20E5",
      npart: "\u2202\u0338",
      npolint: "\u2A14",
      npr: "\u2280",
      nprcue: "\u22E0",
      npre: "\u2AAF\u0338",
      nprec: "\u2280",
      npreceq: "\u2AAF\u0338",
      nrArr: "\u21CF",
      nrarr: "\u219B",
      nrarrc: "\u2933\u0338",
      nrarrw: "\u219D\u0338",
      nRightarrow: "\u21CF",
      nrightarrow: "\u219B",
      nrtri: "\u22EB",
      nrtrie: "\u22ED",
      nsc: "\u2281",
      nsccue: "\u22E1",
      nsce: "\u2AB0\u0338",
      Nscr: "\uD835\uDCA9",
      nscr: "\uD835\uDCC3",
      nshortmid: "\u2224",
      nshortparallel: "\u2226",
      nsim: "\u2241",
      nsime: "\u2244",
      nsimeq: "\u2244",
      nsmid: "\u2224",
      nspar: "\u2226",
      nsqsube: "\u22E2",
      nsqsupe: "\u22E3",
      nsub: "\u2284",
      nsubE: "\u2AC5\u0338",
      nsube: "\u2288",
      nsubset: "\u2282\u20D2",
      nsubseteq: "\u2288",
      nsubseteqq: "\u2AC5\u0338",
      nsucc: "\u2281",
      nsucceq: "\u2AB0\u0338",
      nsup: "\u2285",
      nsupE: "\u2AC6\u0338",
      nsupe: "\u2289",
      nsupset: "\u2283\u20D2",
      nsupseteq: "\u2289",
      nsupseteqq: "\u2AC6\u0338",
      ntgl: "\u2279",
      Ntilde: "\xd1",
      ntilde: "\xf1",
      ntlg: "\u2278",
      ntriangleleft: "\u22EA",
      ntrianglelefteq: "\u22EC",
      ntriangleright: "\u22EB",
      ntrianglerighteq: "\u22ED",
      Nu: "\u039D",
      nu: "\u03BD",
      num: "#",
      numero: "\u2116",
      numsp: "\u2007",
      nvap: "\u224D\u20D2",
      nVDash: "\u22AF",
      nVdash: "\u22AE",
      nvDash: "\u22AD",
      nvdash: "\u22AC",
      nvge: "\u2265\u20D2",
      nvgt: ">\u20D2",
      nvHarr: "\u2904",
      nvinfin: "\u29DE",
      nvlArr: "\u2902",
      nvle: "\u2264\u20D2",
      nvlt: "<\u20D2",
      nvltrie: "\u22B4\u20D2",
      nvrArr: "\u2903",
      nvrtrie: "\u22B5\u20D2",
      nvsim: "\u223C\u20D2",
      nwarhk: "\u2923",
      nwArr: "\u21D6",
      nwarr: "\u2196",
      nwarrow: "\u2196",
      nwnear: "\u2927",
      Oacute: "\xd3",
      oacute: "\xf3",
      oast: "\u229B",
      ocir: "\u229A",
      Ocirc: "\xd4",
      ocirc: "\xf4",
      Ocy: "\u041E",
      ocy: "\u043E",
      odash: "\u229D",
      Odblac: "\u0150",
      odblac: "\u0151",
      odiv: "\u2A38",
      odot: "\u2299",
      odsold: "\u29BC",
      OElig: "\u0152",
      oelig: "\u0153",
      ofcir: "\u29BF",
      Ofr: "\uD835\uDD12",
      ofr: "\uD835\uDD2C",
      ogon: "\u02DB",
      Ograve: "\xd2",
      ograve: "\xf2",
      ogt: "\u29C1",
      ohbar: "\u29B5",
      ohm: "\u03A9",
      oint: "\u222E",
      olarr: "\u21BA",
      olcir: "\u29BE",
      olcross: "\u29BB",
      oline: "\u203E",
      olt: "\u29C0",
      Omacr: "\u014C",
      omacr: "\u014D",
      Omega: "\u03A9",
      omega: "\u03C9",
      Omicron: "\u039F",
      omicron: "\u03BF",
      omid: "\u29B6",
      ominus: "\u2296",
      Oopf: "\uD835\uDD46",
      oopf: "\uD835\uDD60",
      opar: "\u29B7",
      OpenCurlyDoubleQuote: "\u201C",
      OpenCurlyQuote: "\u2018",
      operp: "\u29B9",
      oplus: "\u2295",
      Or: "\u2A54",
      or: "\u2228",
      orarr: "\u21BB",
      ord: "\u2A5D",
      order: "\u2134",
      orderof: "\u2134",
      ordf: "\xaa",
      ordm: "\xba",
      origof: "\u22B6",
      oror: "\u2A56",
      orslope: "\u2A57",
      orv: "\u2A5B",
      oS: "\u24C8",
      Oscr: "\uD835\uDCAA",
      oscr: "\u2134",
      Oslash: "\xd8",
      oslash: "\xf8",
      osol: "\u2298",
      Otilde: "\xd5",
      otilde: "\xf5",
      Otimes: "\u2A37",
      otimes: "\u2297",
      otimesas: "\u2A36",
      Ouml: "\xd6",
      ouml: "\xf6",
      ovbar: "\u233D",
      OverBar: "\u203E",
      OverBrace: "\u23DE",
      OverBracket: "\u23B4",
      OverParenthesis: "\u23DC",
      par: "\u2225",
      para: "\xb6",
      parallel: "\u2225",
      parsim: "\u2AF3",
      parsl: "\u2AFD",
      part: "\u2202",
      PartialD: "\u2202",
      Pcy: "\u041F",
      pcy: "\u043F",
      percnt: "%",
      period: ".",
      permil: "\u2030",
      perp: "\u22A5",
      pertenk: "\u2031",
      Pfr: "\uD835\uDD13",
      pfr: "\uD835\uDD2D",
      Phi: "\u03A6",
      phi: "\u03C6",
      phiv: "\u03D5",
      phmmat: "\u2133",
      phone: "\u260E",
      Pi: "\u03A0",
      pi: "\u03C0",
      pitchfork: "\u22D4",
      piv: "\u03D6",
      planck: "\u210F",
      planckh: "\u210E",
      plankv: "\u210F",
      plus: "+",
      plusacir: "\u2A23",
      plusb: "\u229E",
      pluscir: "\u2A22",
      plusdo: "\u2214",
      plusdu: "\u2A25",
      pluse: "\u2A72",
      PlusMinus: "\xb1",
      plusmn: "\xb1",
      plussim: "\u2A26",
      plustwo: "\u2A27",
      pm: "\xb1",
      Poincareplane: "\u210C",
      pointint: "\u2A15",
      Popf: "\u2119",
      popf: "\uD835\uDD61",
      pound: "\xa3",
      Pr: "\u2ABB",
      pr: "\u227A",
      prap: "\u2AB7",
      prcue: "\u227C",
      prE: "\u2AB3",
      pre: "\u2AAF",
      prec: "\u227A",
      precapprox: "\u2AB7",
      preccurlyeq: "\u227C",
      Precedes: "\u227A",
      PrecedesEqual: "\u2AAF",
      PrecedesSlantEqual: "\u227C",
      PrecedesTilde: "\u227E",
      preceq: "\u2AAF",
      precnapprox: "\u2AB9",
      precneqq: "\u2AB5",
      precnsim: "\u22E8",
      precsim: "\u227E",
      Prime: "\u2033",
      prime: "\u2032",
      primes: "\u2119",
      prnap: "\u2AB9",
      prnE: "\u2AB5",
      prnsim: "\u22E8",
      prod: "\u220F",
      Product: "\u220F",
      profalar: "\u232E",
      profline: "\u2312",
      profsurf: "\u2313",
      prop: "\u221D",
      Proportion: "\u2237",
      Proportional: "\u221D",
      propto: "\u221D",
      prsim: "\u227E",
      prurel: "\u22B0",
      Pscr: "\uD835\uDCAB",
      pscr: "\uD835\uDCC5",
      Psi: "\u03A8",
      psi: "\u03C8",
      puncsp: "\u2008",
      Qfr: "\uD835\uDD14",
      qfr: "\uD835\uDD2E",
      qint: "\u2A0C",
      Qopf: "\u211A",
      qopf: "\uD835\uDD62",
      qprime: "\u2057",
      Qscr: "\uD835\uDCAC",
      qscr: "\uD835\uDCC6",
      quaternions: "\u210D",
      quatint: "\u2A16",
      quest: "?",
      questeq: "\u225F",
      QUOT: '"',
      quot: '"',
      rAarr: "\u21DB",
      race: "\u223D\u0331",
      Racute: "\u0154",
      racute: "\u0155",
      radic: "\u221A",
      raemptyv: "\u29B3",
      Rang: "\u27EB",
      rang: "\u27E9",
      rangd: "\u2992",
      range: "\u29A5",
      rangle: "\u27E9",
      raquo: "\xbb",
      Rarr: "\u21A0",
      rArr: "\u21D2",
      rarr: "\u2192",
      rarrap: "\u2975",
      rarrb: "\u21E5",
      rarrbfs: "\u2920",
      rarrc: "\u2933",
      rarrfs: "\u291E",
      rarrhk: "\u21AA",
      rarrlp: "\u21AC",
      rarrpl: "\u2945",
      rarrsim: "\u2974",
      Rarrtl: "\u2916",
      rarrtl: "\u21A3",
      rarrw: "\u219D",
      rAtail: "\u291C",
      ratail: "\u291A",
      ratio: "\u2236",
      rationals: "\u211A",
      RBarr: "\u2910",
      rBarr: "\u290F",
      rbarr: "\u290D",
      rbbrk: "\u2773",
      rbrace: "}",
      rbrack: "]",
      rbrke: "\u298C",
      rbrksld: "\u298E",
      rbrkslu: "\u2990",
      Rcaron: "\u0158",
      rcaron: "\u0159",
      Rcedil: "\u0156",
      rcedil: "\u0157",
      rceil: "\u2309",
      rcub: "}",
      Rcy: "\u0420",
      rcy: "\u0440",
      rdca: "\u2937",
      rdldhar: "\u2969",
      rdquo: "\u201D",
      rdquor: "\u201D",
      rdsh: "\u21B3",
      Re: "\u211C",
      real: "\u211C",
      realine: "\u211B",
      realpart: "\u211C",
      reals: "\u211D",
      rect: "\u25AD",
      REG: "\xae",
      reg: "\xae",
      ReverseElement: "\u220B",
      ReverseEquilibrium: "\u21CB",
      ReverseUpEquilibrium: "\u296F",
      rfisht: "\u297D",
      rfloor: "\u230B",
      Rfr: "\u211C",
      rfr: "\uD835\uDD2F",
      rHar: "\u2964",
      rhard: "\u21C1",
      rharu: "\u21C0",
      rharul: "\u296C",
      Rho: "\u03A1",
      rho: "\u03C1",
      rhov: "\u03F1",
      RightAngleBracket: "\u27E9",
      RightArrow: "\u2192",
      Rightarrow: "\u21D2",
      rightarrow: "\u2192",
      RightArrowBar: "\u21E5",
      RightArrowLeftArrow: "\u21C4",
      rightarrowtail: "\u21A3",
      RightCeiling: "\u2309",
      RightDoubleBracket: "\u27E7",
      RightDownTeeVector: "\u295D",
      RightDownVector: "\u21C2",
      RightDownVectorBar: "\u2955",
      RightFloor: "\u230B",
      rightharpoondown: "\u21C1",
      rightharpoonup: "\u21C0",
      rightleftarrows: "\u21C4",
      rightleftharpoons: "\u21CC",
      rightrightarrows: "\u21C9",
      rightsquigarrow: "\u219D",
      RightTee: "\u22A2",
      RightTeeArrow: "\u21A6",
      RightTeeVector: "\u295B",
      rightthreetimes: "\u22CC",
      RightTriangle: "\u22B3",
      RightTriangleBar: "\u29D0",
      RightTriangleEqual: "\u22B5",
      RightUpDownVector: "\u294F",
      RightUpTeeVector: "\u295C",
      RightUpVector: "\u21BE",
      RightUpVectorBar: "\u2954",
      RightVector: "\u21C0",
      RightVectorBar: "\u2953",
      ring: "\u02DA",
      risingdotseq: "\u2253",
      rlarr: "\u21C4",
      rlhar: "\u21CC",
      rlm: "\u200F",
      rmoust: "\u23B1",
      rmoustache: "\u23B1",
      rnmid: "\u2AEE",
      roang: "\u27ED",
      roarr: "\u21FE",
      robrk: "\u27E7",
      ropar: "\u2986",
      Ropf: "\u211D",
      ropf: "\uD835\uDD63",
      roplus: "\u2A2E",
      rotimes: "\u2A35",
      RoundImplies: "\u2970",
      rpar: ")",
      rpargt: "\u2994",
      rppolint: "\u2A12",
      rrarr: "\u21C9",
      Rrightarrow: "\u21DB",
      rsaquo: "\u203A",
      Rscr: "\u211B",
      rscr: "\uD835\uDCC7",
      Rsh: "\u21B1",
      rsh: "\u21B1",
      rsqb: "]",
      rsquo: "\u2019",
      rsquor: "\u2019",
      rthree: "\u22CC",
      rtimes: "\u22CA",
      rtri: "\u25B9",
      rtrie: "\u22B5",
      rtrif: "\u25B8",
      rtriltri: "\u29CE",
      RuleDelayed: "\u29F4",
      ruluhar: "\u2968",
      rx: "\u211E",
      Sacute: "\u015A",
      sacute: "\u015B",
      sbquo: "\u201A",
      Sc: "\u2ABC",
      sc: "\u227B",
      scap: "\u2AB8",
      Scaron: "\u0160",
      scaron: "\u0161",
      sccue: "\u227D",
      scE: "\u2AB4",
      sce: "\u2AB0",
      Scedil: "\u015E",
      scedil: "\u015F",
      Scirc: "\u015C",
      scirc: "\u015D",
      scnap: "\u2ABA",
      scnE: "\u2AB6",
      scnsim: "\u22E9",
      scpolint: "\u2A13",
      scsim: "\u227F",
      Scy: "\u0421",
      scy: "\u0441",
      sdot: "\u22C5",
      sdotb: "\u22A1",
      sdote: "\u2A66",
      searhk: "\u2925",
      seArr: "\u21D8",
      searr: "\u2198",
      searrow: "\u2198",
      sect: "\xa7",
      semi: ";",
      seswar: "\u2929",
      setminus: "\u2216",
      setmn: "\u2216",
      sext: "\u2736",
      Sfr: "\uD835\uDD16",
      sfr: "\uD835\uDD30",
      sfrown: "\u2322",
      sharp: "\u266F",
      SHCHcy: "\u0429",
      shchcy: "\u0449",
      SHcy: "\u0428",
      shcy: "\u0448",
      ShortDownArrow: "\u2193",
      ShortLeftArrow: "\u2190",
      shortmid: "\u2223",
      shortparallel: "\u2225",
      ShortRightArrow: "\u2192",
      ShortUpArrow: "\u2191",
      shy: "\xad",
      Sigma: "\u03A3",
      sigma: "\u03C3",
      sigmaf: "\u03C2",
      sigmav: "\u03C2",
      sim: "\u223C",
      simdot: "\u2A6A",
      sime: "\u2243",
      simeq: "\u2243",
      simg: "\u2A9E",
      simgE: "\u2AA0",
      siml: "\u2A9D",
      simlE: "\u2A9F",
      simne: "\u2246",
      simplus: "\u2A24",
      simrarr: "\u2972",
      slarr: "\u2190",
      SmallCircle: "\u2218",
      smallsetminus: "\u2216",
      smashp: "\u2A33",
      smeparsl: "\u29E4",
      smid: "\u2223",
      smile: "\u2323",
      smt: "\u2AAA",
      smte: "\u2AAC",
      smtes: "\u2AAC\uFE00",
      SOFTcy: "\u042C",
      softcy: "\u044C",
      sol: "/",
      solb: "\u29C4",
      solbar: "\u233F",
      Sopf: "\uD835\uDD4A",
      sopf: "\uD835\uDD64",
      spades: "\u2660",
      spadesuit: "\u2660",
      spar: "\u2225",
      sqcap: "\u2293",
      sqcaps: "\u2293\uFE00",
      sqcup: "\u2294",
      sqcups: "\u2294\uFE00",
      Sqrt: "\u221A",
      sqsub: "\u228F",
      sqsube: "\u2291",
      sqsubset: "\u228F",
      sqsubseteq: "\u2291",
      sqsup: "\u2290",
      sqsupe: "\u2292",
      sqsupset: "\u2290",
      sqsupseteq: "\u2292",
      squ: "\u25A1",
      Square: "\u25A1",
      square: "\u25A1",
      SquareIntersection: "\u2293",
      SquareSubset: "\u228F",
      SquareSubsetEqual: "\u2291",
      SquareSuperset: "\u2290",
      SquareSupersetEqual: "\u2292",
      SquareUnion: "\u2294",
      squarf: "\u25AA",
      squf: "\u25AA",
      srarr: "\u2192",
      Sscr: "\uD835\uDCAE",
      sscr: "\uD835\uDCC8",
      ssetmn: "\u2216",
      ssmile: "\u2323",
      sstarf: "\u22C6",
      Star: "\u22C6",
      star: "\u2606",
      starf: "\u2605",
      straightepsilon: "\u03F5",
      straightphi: "\u03D5",
      strns: "\xaf",
      Sub: "\u22D0",
      sub: "\u2282",
      subdot: "\u2ABD",
      subE: "\u2AC5",
      sube: "\u2286",
      subedot: "\u2AC3",
      submult: "\u2AC1",
      subnE: "\u2ACB",
      subne: "\u228A",
      subplus: "\u2ABF",
      subrarr: "\u2979",
      Subset: "\u22D0",
      subset: "\u2282",
      subseteq: "\u2286",
      subseteqq: "\u2AC5",
      SubsetEqual: "\u2286",
      subsetneq: "\u228A",
      subsetneqq: "\u2ACB",
      subsim: "\u2AC7",
      subsub: "\u2AD5",
      subsup: "\u2AD3",
      succ: "\u227B",
      succapprox: "\u2AB8",
      succcurlyeq: "\u227D",
      Succeeds: "\u227B",
      SucceedsEqual: "\u2AB0",
      SucceedsSlantEqual: "\u227D",
      SucceedsTilde: "\u227F",
      succeq: "\u2AB0",
      succnapprox: "\u2ABA",
      succneqq: "\u2AB6",
      succnsim: "\u22E9",
      succsim: "\u227F",
      SuchThat: "\u220B",
      Sum: "\u2211",
      sum: "\u2211",
      sung: "\u266A",
      Sup: "\u22D1",
      sup: "\u2283",
      sup1: "\xb9",
      sup2: "\xb2",
      sup3: "\xb3",
      supdot: "\u2ABE",
      supdsub: "\u2AD8",
      supE: "\u2AC6",
      supe: "\u2287",
      supedot: "\u2AC4",
      Superset: "\u2283",
      SupersetEqual: "\u2287",
      suphsol: "\u27C9",
      suphsub: "\u2AD7",
      suplarr: "\u297B",
      supmult: "\u2AC2",
      supnE: "\u2ACC",
      supne: "\u228B",
      supplus: "\u2AC0",
      Supset: "\u22D1",
      supset: "\u2283",
      supseteq: "\u2287",
      supseteqq: "\u2AC6",
      supsetneq: "\u228B",
      supsetneqq: "\u2ACC",
      supsim: "\u2AC8",
      supsub: "\u2AD4",
      supsup: "\u2AD6",
      swarhk: "\u2926",
      swArr: "\u21D9",
      swarr: "\u2199",
      swarrow: "\u2199",
      swnwar: "\u292A",
      szlig: "\xdf",
      Tab: "\t",
      target: "\u2316",
      Tau: "\u03A4",
      tau: "\u03C4",
      tbrk: "\u23B4",
      Tcaron: "\u0164",
      tcaron: "\u0165",
      Tcedil: "\u0162",
      tcedil: "\u0163",
      Tcy: "\u0422",
      tcy: "\u0442",
      tdot: "\u20DB",
      telrec: "\u2315",
      Tfr: "\uD835\uDD17",
      tfr: "\uD835\uDD31",
      there4: "\u2234",
      Therefore: "\u2234",
      therefore: "\u2234",
      Theta: "\u0398",
      theta: "\u03B8",
      thetasym: "\u03D1",
      thetav: "\u03D1",
      thickapprox: "\u2248",
      thicksim: "\u223C",
      ThickSpace: "\u205F\u200A",
      thinsp: "\u2009",
      ThinSpace: "\u2009",
      thkap: "\u2248",
      thksim: "\u223C",
      THORN: "\xde",
      thorn: "\xfe",
      Tilde: "\u223C",
      tilde: "\u02DC",
      TildeEqual: "\u2243",
      TildeFullEqual: "\u2245",
      TildeTilde: "\u2248",
      times: "\xd7",
      timesb: "\u22A0",
      timesbar: "\u2A31",
      timesd: "\u2A30",
      tint: "\u222D",
      toea: "\u2928",
      top: "\u22A4",
      topbot: "\u2336",
      topcir: "\u2AF1",
      Topf: "\uD835\uDD4B",
      topf: "\uD835\uDD65",
      topfork: "\u2ADA",
      tosa: "\u2929",
      tprime: "\u2034",
      TRADE: "\u2122",
      trade: "\u2122",
      triangle: "\u25B5",
      triangledown: "\u25BF",
      triangleleft: "\u25C3",
      trianglelefteq: "\u22B4",
      triangleq: "\u225C",
      triangleright: "\u25B9",
      trianglerighteq: "\u22B5",
      tridot: "\u25EC",
      trie: "\u225C",
      triminus: "\u2A3A",
      TripleDot: "\u20DB",
      triplus: "\u2A39",
      trisb: "\u29CD",
      tritime: "\u2A3B",
      trpezium: "\u23E2",
      Tscr: "\uD835\uDCAF",
      tscr: "\uD835\uDCC9",
      TScy: "\u0426",
      tscy: "\u0446",
      TSHcy: "\u040B",
      tshcy: "\u045B",
      Tstrok: "\u0166",
      tstrok: "\u0167",
      twixt: "\u226C",
      twoheadleftarrow: "\u219E",
      twoheadrightarrow: "\u21A0",
      Uacute: "\xda",
      uacute: "\xfa",
      Uarr: "\u219F",
      uArr: "\u21D1",
      uarr: "\u2191",
      Uarrocir: "\u2949",
      Ubrcy: "\u040E",
      ubrcy: "\u045E",
      Ubreve: "\u016C",
      ubreve: "\u016D",
      Ucirc: "\xdb",
      ucirc: "\xfb",
      Ucy: "\u0423",
      ucy: "\u0443",
      udarr: "\u21C5",
      Udblac: "\u0170",
      udblac: "\u0171",
      udhar: "\u296E",
      ufisht: "\u297E",
      Ufr: "\uD835\uDD18",
      ufr: "\uD835\uDD32",
      Ugrave: "\xd9",
      ugrave: "\xf9",
      uHar: "\u2963",
      uharl: "\u21BF",
      uharr: "\u21BE",
      uhblk: "\u2580",
      ulcorn: "\u231C",
      ulcorner: "\u231C",
      ulcrop: "\u230F",
      ultri: "\u25F8",
      Umacr: "\u016A",
      umacr: "\u016B",
      uml: "\xa8",
      UnderBar: "_",
      UnderBrace: "\u23DF",
      UnderBracket: "\u23B5",
      UnderParenthesis: "\u23DD",
      Union: "\u22C3",
      UnionPlus: "\u228E",
      Uogon: "\u0172",
      uogon: "\u0173",
      Uopf: "\uD835\uDD4C",
      uopf: "\uD835\uDD66",
      UpArrow: "\u2191",
      Uparrow: "\u21D1",
      uparrow: "\u2191",
      UpArrowBar: "\u2912",
      UpArrowDownArrow: "\u21C5",
      UpDownArrow: "\u2195",
      Updownarrow: "\u21D5",
      updownarrow: "\u2195",
      UpEquilibrium: "\u296E",
      upharpoonleft: "\u21BF",
      upharpoonright: "\u21BE",
      uplus: "\u228E",
      UpperLeftArrow: "\u2196",
      UpperRightArrow: "\u2197",
      Upsi: "\u03D2",
      upsi: "\u03C5",
      upsih: "\u03D2",
      Upsilon: "\u03A5",
      upsilon: "\u03C5",
      UpTee: "\u22A5",
      UpTeeArrow: "\u21A5",
      upuparrows: "\u21C8",
      urcorn: "\u231D",
      urcorner: "\u231D",
      urcrop: "\u230E",
      Uring: "\u016E",
      uring: "\u016F",
      urtri: "\u25F9",
      Uscr: "\uD835\uDCB0",
      uscr: "\uD835\uDCCA",
      utdot: "\u22F0",
      Utilde: "\u0168",
      utilde: "\u0169",
      utri: "\u25B5",
      utrif: "\u25B4",
      uuarr: "\u21C8",
      Uuml: "\xdc",
      uuml: "\xfc",
      uwangle: "\u29A7",
      vangrt: "\u299C",
      varepsilon: "\u03F5",
      varkappa: "\u03F0",
      varnothing: "\u2205",
      varphi: "\u03D5",
      varpi: "\u03D6",
      varpropto: "\u221D",
      vArr: "\u21D5",
      varr: "\u2195",
      varrho: "\u03F1",
      varsigma: "\u03C2",
      varsubsetneq: "\u228A\uFE00",
      varsubsetneqq: "\u2ACB\uFE00",
      varsupsetneq: "\u228B\uFE00",
      varsupsetneqq: "\u2ACC\uFE00",
      vartheta: "\u03D1",
      vartriangleleft: "\u22B2",
      vartriangleright: "\u22B3",
      Vbar: "\u2AEB",
      vBar: "\u2AE8",
      vBarv: "\u2AE9",
      Vcy: "\u0412",
      vcy: "\u0432",
      VDash: "\u22AB",
      Vdash: "\u22A9",
      vDash: "\u22A8",
      vdash: "\u22A2",
      Vdashl: "\u2AE6",
      Vee: "\u22C1",
      vee: "\u2228",
      veebar: "\u22BB",
      veeeq: "\u225A",
      vellip: "\u22EE",
      Verbar: "\u2016",
      verbar: "|",
      Vert: "\u2016",
      vert: "|",
      VerticalBar: "\u2223",
      VerticalLine: "|",
      VerticalSeparator: "\u2758",
      VerticalTilde: "\u2240",
      VeryThinSpace: "\u200A",
      Vfr: "\uD835\uDD19",
      vfr: "\uD835\uDD33",
      vltri: "\u22B2",
      vnsub: "\u2282\u20D2",
      vnsup: "\u2283\u20D2",
      Vopf: "\uD835\uDD4D",
      vopf: "\uD835\uDD67",
      vprop: "\u221D",
      vrtri: "\u22B3",
      Vscr: "\uD835\uDCB1",
      vscr: "\uD835\uDCCB",
      vsubnE: "\u2ACB\uFE00",
      vsubne: "\u228A\uFE00",
      vsupnE: "\u2ACC\uFE00",
      vsupne: "\u228B\uFE00",
      Vvdash: "\u22AA",
      vzigzag: "\u299A",
      Wcirc: "\u0174",
      wcirc: "\u0175",
      wedbar: "\u2A5F",
      Wedge: "\u22C0",
      wedge: "\u2227",
      wedgeq: "\u2259",
      weierp: "\u2118",
      Wfr: "\uD835\uDD1A",
      wfr: "\uD835\uDD34",
      Wopf: "\uD835\uDD4E",
      wopf: "\uD835\uDD68",
      wp: "\u2118",
      wr: "\u2240",
      wreath: "\u2240",
      Wscr: "\uD835\uDCB2",
      wscr: "\uD835\uDCCC",
      xcap: "\u22C2",
      xcirc: "\u25EF",
      xcup: "\u22C3",
      xdtri: "\u25BD",
      Xfr: "\uD835\uDD1B",
      xfr: "\uD835\uDD35",
      xhArr: "\u27FA",
      xharr: "\u27F7",
      Xi: "\u039E",
      xi: "\u03BE",
      xlArr: "\u27F8",
      xlarr: "\u27F5",
      xmap: "\u27FC",
      xnis: "\u22FB",
      xodot: "\u2A00",
      Xopf: "\uD835\uDD4F",
      xopf: "\uD835\uDD69",
      xoplus: "\u2A01",
      xotime: "\u2A02",
      xrArr: "\u27F9",
      xrarr: "\u27F6",
      Xscr: "\uD835\uDCB3",
      xscr: "\uD835\uDCCD",
      xsqcup: "\u2A06",
      xuplus: "\u2A04",
      xutri: "\u25B3",
      xvee: "\u22C1",
      xwedge: "\u22C0",
      Yacute: "\xdd",
      yacute: "\xfd",
      YAcy: "\u042F",
      yacy: "\u044F",
      Ycirc: "\u0176",
      ycirc: "\u0177",
      Ycy: "\u042B",
      ycy: "\u044B",
      yen: "\xa5",
      Yfr: "\uD835\uDD1C",
      yfr: "\uD835\uDD36",
      YIcy: "\u0407",
      yicy: "\u0457",
      Yopf: "\uD835\uDD50",
      yopf: "\uD835\uDD6A",
      Yscr: "\uD835\uDCB4",
      yscr: "\uD835\uDCCE",
      YUcy: "\u042E",
      yucy: "\u044E",
      Yuml: "\u0178",
      yuml: "\xff",
      Zacute: "\u0179",
      zacute: "\u017A",
      Zcaron: "\u017D",
      zcaron: "\u017E",
      Zcy: "\u0417",
      zcy: "\u0437",
      Zdot: "\u017B",
      zdot: "\u017C",
      zeetrf: "\u2128",
      ZeroWidthSpace: "\u200B",
      Zeta: "\u0396",
      zeta: "\u03B6",
      Zfr: "\u2128",
      zfr: "\uD835\uDD37",
      ZHcy: "\u0416",
      zhcy: "\u0436",
      zigrarr: "\u21DD",
      Zopf: "\u2124",
      zopf: "\uD835\uDD6B",
      Zscr: "\uD835\uDCB5",
      zscr: "\uD835\uDCCF",
      zwj: "\u200D",
      zwnj: "\u200C"
    }, t.NGSP_UNICODE = "\uE500", t.NAMED_ENTITIES.ngsp = t.NGSP_UNICODE;
  }),
      En = t(function (e, t) {
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = /*#__PURE__*/function () {
      function n() {
        var _this3 = this;

        var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            e = _ref18.closedByChildren,
            t = _ref18.implicitNamespacePrefix,
            _ref18$contentType = _ref18.contentType,
            _n27 = _ref18$contentType === void 0 ? gn.TagContentType.PARSABLE_DATA : _ref18$contentType,
            _ref18$closedByParent = _ref18.closedByParent,
            r = _ref18$closedByParent === void 0 ? !1 : _ref18$closedByParent,
            _ref18$isVoid = _ref18.isVoid,
            s = _ref18$isVoid === void 0 ? !1 : _ref18$isVoid,
            _ref18$ignoreFirstLf = _ref18.ignoreFirstLf,
            i = _ref18$ignoreFirstLf === void 0 ? !1 : _ref18$ignoreFirstLf;

        _classCallCheck(this, n);

        this.closedByChildren = {}, this.closedByParent = !1, this.canSelfClose = !1, e && e.length > 0 && e.forEach(function (e) {
          return _this3.closedByChildren[e] = !0;
        }), this.isVoid = s, this.closedByParent = r || s, this.implicitNamespacePrefix = t || null, this.contentType = _n27, this.ignoreFirstLf = i;
      }

      _createClass(n, [{
        key: "isClosedByChild",
        value: function isClosedByChild(e) {
          return this.isVoid || e.toLowerCase() in this.closedByChildren;
        }
      }]);

      return n;
    }();

    var r, s;
    t.HtmlTagDefinition = n, t.getHtmlTagDefinition = function (e) {
      return s || (r = new n(), s = {
        base: new n({
          isVoid: !0
        }),
        meta: new n({
          isVoid: !0
        }),
        area: new n({
          isVoid: !0
        }),
        embed: new n({
          isVoid: !0
        }),
        link: new n({
          isVoid: !0
        }),
        img: new n({
          isVoid: !0
        }),
        input: new n({
          isVoid: !0
        }),
        param: new n({
          isVoid: !0
        }),
        hr: new n({
          isVoid: !0
        }),
        br: new n({
          isVoid: !0
        }),
        source: new n({
          isVoid: !0
        }),
        track: new n({
          isVoid: !0
        }),
        wbr: new n({
          isVoid: !0
        }),
        p: new n({
          closedByChildren: ["address", "article", "aside", "blockquote", "div", "dl", "fieldset", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "main", "nav", "ol", "p", "pre", "section", "table", "ul"],
          closedByParent: !0
        }),
        thead: new n({
          closedByChildren: ["tbody", "tfoot"]
        }),
        tbody: new n({
          closedByChildren: ["tbody", "tfoot"],
          closedByParent: !0
        }),
        tfoot: new n({
          closedByChildren: ["tbody"],
          closedByParent: !0
        }),
        tr: new n({
          closedByChildren: ["tr"],
          closedByParent: !0
        }),
        td: new n({
          closedByChildren: ["td", "th"],
          closedByParent: !0
        }),
        th: new n({
          closedByChildren: ["td", "th"],
          closedByParent: !0
        }),
        col: new n({
          isVoid: !0
        }),
        svg: new n({
          implicitNamespacePrefix: "svg"
        }),
        math: new n({
          implicitNamespacePrefix: "math"
        }),
        li: new n({
          closedByChildren: ["li"],
          closedByParent: !0
        }),
        dt: new n({
          closedByChildren: ["dt", "dd"]
        }),
        dd: new n({
          closedByChildren: ["dt", "dd"],
          closedByParent: !0
        }),
        rb: new n({
          closedByChildren: ["rb", "rt", "rtc", "rp"],
          closedByParent: !0
        }),
        rt: new n({
          closedByChildren: ["rb", "rt", "rtc", "rp"],
          closedByParent: !0
        }),
        rtc: new n({
          closedByChildren: ["rb", "rtc", "rp"],
          closedByParent: !0
        }),
        rp: new n({
          closedByChildren: ["rb", "rt", "rtc", "rp"],
          closedByParent: !0
        }),
        optgroup: new n({
          closedByChildren: ["optgroup"],
          closedByParent: !0
        }),
        option: new n({
          closedByChildren: ["option", "optgroup"],
          closedByParent: !0
        }),
        pre: new n({
          ignoreFirstLf: !0
        }),
        listing: new n({
          ignoreFirstLf: !0
        }),
        style: new n({
          contentType: gn.TagContentType.RAW_TEXT
        }),
        script: new n({
          contentType: gn.TagContentType.RAW_TEXT
        }),
        title: new n({
          contentType: gn.TagContentType.ESCAPABLE_RAW_TEXT
        }),
        textarea: new n({
          contentType: gn.TagContentType.ESCAPABLE_RAW_TEXT,
          ignoreFirstLf: !0
        })
      }), s[e] || r;
    };
  }),
      Cn = t(function (e, t) {
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    t.AstPath = /*#__PURE__*/function () {
      function _class12(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

        _classCallCheck(this, _class12);

        this.path = e, this.position = t;
      }

      _createClass(_class12, [{
        key: "empty",
        get: function get() {
          return !this.path || !this.path.length;
        }
      }, {
        key: "head",
        get: function get() {
          return this.path[0];
        }
      }, {
        key: "tail",
        get: function get() {
          return this.path[this.path.length - 1];
        }
      }, {
        key: "parentOf",
        value: function parentOf(e) {
          return e && this.path[this.path.indexOf(e) - 1];
        }
      }, {
        key: "childOf",
        value: function childOf(e) {
          return this.path[this.path.indexOf(e) + 1];
        }
      }, {
        key: "first",
        value: function first(e) {
          for (var _t16 = this.path.length - 1; _t16 >= 0; _t16--) {
            var _n28 = this.path[_t16];
            if (_n28 instanceof e) return _n28;
          }
        }
      }, {
        key: "push",
        value: function push(e) {
          this.path.push(e);
        }
      }, {
        key: "pop",
        value: function pop() {
          return this.path.pop();
        }
      }]);

      return _class12;
    }();
  }),
      Tn = t(function (e, t) {
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    t.Text = /*#__PURE__*/function () {
      function _class13(e, t, n) {
        _classCallCheck(this, _class13);

        this.value = e, this.sourceSpan = t, this.i18n = n;
      }

      _createClass(_class13, [{
        key: "visit",
        value: function visit(e, t) {
          return e.visitText(this, t);
        }
      }]);

      return _class13;
    }();

    t.CDATA = /*#__PURE__*/function () {
      function _class14(e, t) {
        _classCallCheck(this, _class14);

        this.value = e, this.sourceSpan = t;
      }

      _createClass(_class14, [{
        key: "visit",
        value: function visit(e, t) {
          return e.visitCdata(this, t);
        }
      }]);

      return _class14;
    }();

    t.Expansion = /*#__PURE__*/function () {
      function _class15(e, t, n, r, s, i) {
        _classCallCheck(this, _class15);

        this.switchValue = e, this.type = t, this.cases = n, this.sourceSpan = r, this.switchValueSourceSpan = s, this.i18n = i;
      }

      _createClass(_class15, [{
        key: "visit",
        value: function visit(e, t) {
          return e.visitExpansion(this, t);
        }
      }]);

      return _class15;
    }();

    t.ExpansionCase = /*#__PURE__*/function () {
      function _class16(e, t, n, r, s) {
        _classCallCheck(this, _class16);

        this.value = e, this.expression = t, this.sourceSpan = n, this.valueSourceSpan = r, this.expSourceSpan = s;
      }

      _createClass(_class16, [{
        key: "visit",
        value: function visit(e, t) {
          return e.visitExpansionCase(this, t);
        }
      }]);

      return _class16;
    }();

    t.Attribute = /*#__PURE__*/function () {
      function _class17(e, t, n) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

        _classCallCheck(this, _class17);

        this.name = e, this.value = t, this.sourceSpan = n, this.valueSpan = r, this.nameSpan = s, this.i18n = i;
      }

      _createClass(_class17, [{
        key: "visit",
        value: function visit(e, t) {
          return e.visitAttribute(this, t);
        }
      }]);

      return _class17;
    }();

    var n = /*#__PURE__*/function () {
      function n(e, t, _n29, r) {
        var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
        var o = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        var a = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

        _classCallCheck(this, n);

        this.name = e, this.attrs = t, this.children = _n29, this.sourceSpan = r, this.startSourceSpan = s, this.endSourceSpan = i, this.nameSpan = o, this.i18n = a;
      }

      _createClass(n, [{
        key: "visit",
        value: function visit(e, t) {
          return e.visitElement(this, t);
        }
      }]);

      return n;
    }();

    t.Element = n;

    t.Comment = /*#__PURE__*/function () {
      function _class18(e, t) {
        _classCallCheck(this, _class18);

        this.value = e, this.sourceSpan = t;
      }

      _createClass(_class18, [{
        key: "visit",
        value: function visit(e, t) {
          return e.visitComment(this, t);
        }
      }]);

      return _class18;
    }();

    function r(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var r = [],
          s = e.visit ? function (t) {
        return e.visit(t, n) || t.visit(e, n);
      } : function (t) {
        return t.visit(e, n);
      };
      return t.forEach(function (e) {
        var t = s(e);
        t && r.push(t);
      }), r;
    }

    t.DocType = /*#__PURE__*/function () {
      function _class19(e, t) {
        _classCallCheck(this, _class19);

        this.value = e, this.sourceSpan = t;
      }

      _createClass(_class19, [{
        key: "visit",
        value: function visit(e, t) {
          return e.visitDocType(this, t);
        }
      }]);

      return _class19;
    }(), t.visitAll = r;

    var s = /*#__PURE__*/function () {
      function s() {
        _classCallCheck(this, s);
      }

      _createClass(s, [{
        key: "visitElement",
        value: function visitElement(e, t) {
          this.visitChildren(t, function (t) {
            t(e.attrs), t(e.children);
          });
        }
      }, {
        key: "visitAttribute",
        value: function visitAttribute(e, t) {}
      }, {
        key: "visitText",
        value: function visitText(e, t) {}
      }, {
        key: "visitCdata",
        value: function visitCdata(e, t) {}
      }, {
        key: "visitComment",
        value: function visitComment(e, t) {}
      }, {
        key: "visitDocType",
        value: function visitDocType(e, t) {}
      }, {
        key: "visitExpansion",
        value: function visitExpansion(e, t) {
          return this.visitChildren(t, function (t) {
            t(e.cases);
          });
        }
      }, {
        key: "visitExpansionCase",
        value: function visitExpansionCase(e, t) {}
      }, {
        key: "visitChildren",
        value: function visitChildren(e, t) {
          var n = [],
              _s9 = this;

          return t(function (t) {
            t && n.push(r(_s9, t, e));
          }), Array.prototype.concat.apply([], n);
        }
      }]);

      return s;
    }();

    function i(e) {
      var t = e.sourceSpan.start.offset;
      var r = e.sourceSpan.end.offset;
      return e instanceof n && (e.endSourceSpan ? r = e.endSourceSpan.end.offset : e.children && e.children.length && (r = i(e.children[e.children.length - 1]).end)), {
        start: t,
        end: r
      };
    }

    t.RecursiveVisitor = s, t.findNode = function (e, t) {
      var n = [];
      return r(new ( /*#__PURE__*/function (_s10) {
        _inherits(_class20, _s10);

        var _super = _createSuper(_class20);

        function _class20() {
          _classCallCheck(this, _class20);

          return _super.apply(this, arguments);
        }

        _createClass(_class20, [{
          key: "visit",
          value: function visit(e, r) {
            var s = i(e);
            if (!(s.start <= t && t < s.end)) return !0;
            n.push(e);
          }
        }]);

        return _class20;
      }(s))(), e), new Cn.AstPath(n, t);
    };
  }),
      yn = t(function (e, t) {
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.assertArrayOfStrings = function (e, t) {
      if (null != t) {
        if (!Array.isArray(t)) throw new Error("Expected '".concat(e, "' to be an array of strings."));

        for (var _n30 = 0; _n30 < t.length; _n30 += 1) {
          if ("string" != typeof t[_n30]) throw new Error("Expected '".concat(e, "' to be an array of strings."));
        }
      }
    };
    var n = [/^\s*$/, /[<>]/, /^[{}]$/, /&(#|[a-z])/i, /^\/\//];

    t.assertInterpolationSymbols = function (e, t) {
      if (!(null == t || Array.isArray(t) && 2 == t.length)) throw new Error("Expected '".concat(e, "' to be an array, [start, end]."));

      if (null != t) {
        var _e19 = t[0],
            _r27 = t[1];
        n.forEach(function (t) {
          if (t.test(_e19) || t.test(_r27)) throw new Error("['".concat(_e19, "', '").concat(_r27, "'] contains unusable interpolation symbol."));
        });
      }
    };
  }),
      Sn = t(function (e, t) {
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = /*#__PURE__*/function () {
      function n(e, t) {
        _classCallCheck(this, n);

        this.start = e, this.end = t;
      }

      _createClass(n, null, [{
        key: "fromArray",
        value: function fromArray(e) {
          return e ? (yn.assertInterpolationSymbols("interpolation", e), new n(e[0], e[1])) : t.DEFAULT_INTERPOLATION_CONFIG;
        }
      }]);

      return n;
    }();

    t.InterpolationConfig = n, t.DEFAULT_INTERPOLATION_CONFIG = new n("{{", "}}");
  }),
      _n = t(function (e, t) {
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n;
    var s;
    !function (e) {
      e[e.TAG_OPEN_START = 0] = "TAG_OPEN_START", e[e.TAG_OPEN_END = 1] = "TAG_OPEN_END", e[e.TAG_OPEN_END_VOID = 2] = "TAG_OPEN_END_VOID", e[e.TAG_CLOSE = 3] = "TAG_CLOSE", e[e.TEXT = 4] = "TEXT", e[e.ESCAPABLE_RAW_TEXT = 5] = "ESCAPABLE_RAW_TEXT", e[e.RAW_TEXT = 6] = "RAW_TEXT", e[e.COMMENT_START = 7] = "COMMENT_START", e[e.COMMENT_END = 8] = "COMMENT_END", e[e.CDATA_START = 9] = "CDATA_START", e[e.CDATA_END = 10] = "CDATA_END", e[e.ATTR_NAME = 11] = "ATTR_NAME", e[e.ATTR_QUOTE = 12] = "ATTR_QUOTE", e[e.ATTR_VALUE = 13] = "ATTR_VALUE", e[e.DOC_TYPE_START = 14] = "DOC_TYPE_START", e[e.DOC_TYPE_END = 15] = "DOC_TYPE_END", e[e.EXPANSION_FORM_START = 16] = "EXPANSION_FORM_START", e[e.EXPANSION_CASE_VALUE = 17] = "EXPANSION_CASE_VALUE", e[e.EXPANSION_CASE_EXP_START = 18] = "EXPANSION_CASE_EXP_START", e[e.EXPANSION_CASE_EXP_END = 19] = "EXPANSION_CASE_EXP_END", e[e.EXPANSION_FORM_END = 20] = "EXPANSION_FORM_END", e[e.EOF = 21] = "EOF";
    }(s = t.TokenType || (t.TokenType = {}));

    var i = function i(e, t, n) {
      _classCallCheck(this, i);

      this.type = e, this.parts = t, this.sourceSpan = n;
    };

    t.Token = i;

    var a = /*#__PURE__*/function (_o$ParseError) {
      _inherits(a, _o$ParseError);

      var _super2 = _createSuper(a);

      function a(e, t, n) {
        var _this4;

        _classCallCheck(this, a);

        _this4 = _super2.call(this, n, e), _this4.tokenType = t;
        return _this4;
      }

      return a;
    }(o.ParseError);

    t.TokenError = a;

    var u = function u(e, t) {
      _classCallCheck(this, u);

      this.tokens = e, this.errors = t;
    };

    t.TokenizeResult = u, t.tokenize = function (e, t, n) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return new h(new o.ParseSourceFile(e, t), n, r).tokenize();
    };
    var c = /\r\n?/g;

    function l(e) {
      var t = e === r.$EOF ? "EOF" : String.fromCharCode(e);
      return 'Unexpected character "'.concat(t, '"');
    }

    function p(e) {
      return 'Unknown entity "'.concat(e, '" - use the "&#<decimal>;" or  "&#x<hex>;" syntax');
    }

    var D = function D(e) {
      _classCallCheck(this, D);

      this.error = e;
    };

    var h = /*#__PURE__*/function () {
      function h(e, t, n) {
        _classCallCheck(this, h);

        this._getTagContentType = t, this._currentTokenStart = null, this._currentTokenType = null, this._expansionCaseStack = [], this._inInterpolation = !1, this._fullNameStack = [], this.tokens = [], this.errors = [], this._tokenizeIcu = n.tokenizeExpansionForms || !1, this._interpolationConfig = n.interpolationConfig || Sn.DEFAULT_INTERPOLATION_CONFIG, this._leadingTriviaCodePoints = n.leadingTriviaChars && n.leadingTriviaChars.map(function (e) {
          return e.codePointAt(0) || 0;
        }), this._canSelfClose = n.canSelfClose || !1, this._allowHtmComponentClosingTags = n.allowHtmComponentClosingTags || !1;
        var r = n.range || {
          endPos: e.content.length,
          startPos: 0,
          startLine: 0,
          startCol: 0
        };
        this._cursor = n.escapedString ? new T(e, r) : new C(e, r);

        try {
          this._cursor.init();
        } catch (e) {
          this.handleError(e);
        }
      }

      _createClass(h, [{
        key: "_processCarriageReturns",
        value: function _processCarriageReturns(e) {
          return e.replace(c, "\n");
        }
      }, {
        key: "tokenize",
        value: function tokenize() {
          for (; this._cursor.peek() !== r.$EOF;) {
            var _e20 = this._cursor.clone();

            try {
              if (this._attemptCharCode(r.$LT)) {
                if (this._attemptCharCode(r.$BANG)) this._attemptStr("[CDATA[") ? this._consumeCdata(_e20) : this._attemptStr("--") ? this._consumeComment(_e20) : this._attemptStrCaseInsensitive("doctype") ? this._consumeDocType(_e20) : this._consumeBogusComment(_e20);else if (this._attemptCharCode(r.$SLASH)) this._consumeTagClose(_e20);else {
                  var _t17 = this._cursor.clone();

                  this._attemptCharCode(r.$QUESTION) ? (this._cursor = _t17, this._consumeBogusComment(_e20)) : this._consumeTagOpen(_e20);
                }
              } else this._tokenizeIcu && this._tokenizeExpansionForm() || this._consumeText();
            } catch (e) {
              this.handleError(e);
            }
          }

          return this._beginToken(s.EOF), this._endToken([]), new u(function (e) {
            var t = [];
            var n = void 0;

            for (var _r28 = 0; _r28 < e.length; _r28++) {
              var _i6 = e[_r28];
              n && n.type == s.TEXT && _i6.type == s.TEXT ? (n.parts[0] += _i6.parts[0], n.sourceSpan.end = _i6.sourceSpan.end) : (n = _i6, t.push(n));
            }

            return t;
          }(this.tokens), this.errors);
        }
      }, {
        key: "_tokenizeExpansionForm",
        value: function _tokenizeExpansionForm() {
          if (this.isExpansionFormStart()) return this._consumeExpansionFormStart(), !0;
          if (((e = this._cursor.peek()) === r.$EQ || r.isAsciiLetter(e) || r.isDigit(e)) && this._isInExpansionForm()) return this._consumeExpansionCaseStart(), !0;
          var e;

          if (this._cursor.peek() === r.$RBRACE) {
            if (this._isInExpansionCase()) return this._consumeExpansionCaseEnd(), !0;
            if (this._isInExpansionForm()) return this._consumeExpansionFormEnd(), !0;
          }

          return !1;
        }
      }, {
        key: "_beginToken",
        value: function _beginToken(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._cursor.clone();
          this._currentTokenStart = t, this._currentTokenType = e;
        }
      }, {
        key: "_endToken",
        value: function _endToken(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._cursor.clone();
          if (null === this._currentTokenStart) throw new a("Programming error - attempted to end a token when there was no start to the token", this._currentTokenType, this._cursor.getSpan(t));
          if (null === this._currentTokenType) throw new a("Programming error - attempted to end a token which has no token type", null, this._cursor.getSpan(this._currentTokenStart));
          var n = new i(this._currentTokenType, e, this._cursor.getSpan(this._currentTokenStart, this._leadingTriviaCodePoints));
          return this.tokens.push(n), this._currentTokenStart = null, this._currentTokenType = null, n;
        }
      }, {
        key: "_createError",
        value: function _createError(e, t) {
          this._isInExpansionForm() && (e += ' (Do you have an unescaped "{" in your template? Use "{{ \'{\' }}") to escape it.)');
          var n = new a(e, this._currentTokenType, t);
          return this._currentTokenStart = null, this._currentTokenType = null, new D(n);
        }
      }, {
        key: "handleError",
        value: function handleError(e) {
          if (e instanceof y && (e = this._createError(e.msg, this._cursor.getSpan(e.cursor))), !(e instanceof D)) throw e;
          this.errors.push(e.error);
        }
      }, {
        key: "_attemptCharCode",
        value: function _attemptCharCode(e) {
          return this._cursor.peek() === e && (this._cursor.advance(), !0);
        }
      }, {
        key: "_attemptCharCodeCaseInsensitive",
        value: function _attemptCharCodeCaseInsensitive(e) {
          return t = this._cursor.peek(), n = e, E(t) == E(n) && (this._cursor.advance(), !0);
          var t, n;
        }
      }, {
        key: "_requireCharCode",
        value: function _requireCharCode(e) {
          var t = this._cursor.clone();

          if (!this._attemptCharCode(e)) throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(t));
        }
      }, {
        key: "_attemptStr",
        value: function _attemptStr(e) {
          var t = e.length;
          if (this._cursor.charsLeft() < t) return !1;

          var n = this._cursor.clone();

          for (var _r29 = 0; _r29 < t; _r29++) {
            if (!this._attemptCharCode(e.charCodeAt(_r29))) return this._cursor = n, !1;
          }

          return !0;
        }
      }, {
        key: "_attemptStrCaseInsensitive",
        value: function _attemptStrCaseInsensitive(e) {
          for (var _t18 = 0; _t18 < e.length; _t18++) {
            if (!this._attemptCharCodeCaseInsensitive(e.charCodeAt(_t18))) return !1;
          }

          return !0;
        }
      }, {
        key: "_requireStr",
        value: function _requireStr(e) {
          var t = this._cursor.clone();

          if (!this._attemptStr(e)) throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(t));
        }
      }, {
        key: "_requireStrCaseInsensitive",
        value: function _requireStrCaseInsensitive(e) {
          var t = this._cursor.clone();

          if (!this._attemptStrCaseInsensitive(e)) throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(t));
        }
      }, {
        key: "_attemptCharCodeUntilFn",
        value: function _attemptCharCodeUntilFn(e) {
          for (; !e(this._cursor.peek());) {
            this._cursor.advance();
          }
        }
      }, {
        key: "_requireCharCodeUntilFn",
        value: function _requireCharCodeUntilFn(e, t) {
          var n = this._cursor.clone();

          this._attemptCharCodeUntilFn(e);

          if (this._cursor.clone().diff(n) < t) throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(n));
        }
      }, {
        key: "_attemptUntilChar",
        value: function _attemptUntilChar(e) {
          for (; this._cursor.peek() !== e;) {
            this._cursor.advance();
          }
        }
      }, {
        key: "_readChar",
        value: function _readChar(e) {
          if (e && this._cursor.peek() === r.$AMPERSAND) return this._decodeEntity();
          {
            var _e21 = String.fromCodePoint(this._cursor.peek());

            return this._cursor.advance(), _e21;
          }
        }
      }, {
        key: "_decodeEntity",
        value: function _decodeEntity() {
          var e = this._cursor.clone();

          if (this._cursor.advance(), !this._attemptCharCode(r.$HASH)) {
            var _t19 = this._cursor.clone();

            if (this._attemptCharCodeUntilFn(g), this._cursor.peek() != r.$SEMICOLON) return this._cursor = _t19, "&";

            var _n31 = this._cursor.getChars(_t19);

            this._cursor.advance();

            var _s11 = gn.NAMED_ENTITIES[_n31];
            if (!_s11) throw this._createError(p(_n31), this._cursor.getSpan(e));
            return _s11;
          }

          {
            var _t20 = this._attemptCharCode(r.$x) || this._attemptCharCode(r.$X),
                _n32 = this._cursor.clone();

            if (this._attemptCharCodeUntilFn(m), this._cursor.peek() != r.$SEMICOLON) throw this._createError(l(this._cursor.peek()), this._cursor.getSpan());

            var _s12 = this._cursor.getChars(_n32);

            this._cursor.advance();

            try {
              var _e22 = parseInt(_s12, _t20 ? 16 : 10);

              return String.fromCharCode(_e22);
            } catch (t) {
              throw this._createError(p(this._cursor.getChars(e)), this._cursor.getSpan());
            }
          }
        }
      }, {
        key: "_consumeRawText",
        value: function _consumeRawText(e, t) {
          this._beginToken(e ? s.ESCAPABLE_RAW_TEXT : s.RAW_TEXT);

          var n = [];

          for (;;) {
            var _r30 = this._cursor.clone(),
                _s13 = t();

            if (this._cursor = _r30, _s13) break;
            n.push(this._readChar(e));
          }

          return this._endToken([this._processCarriageReturns(n.join(""))]);
        }
      }, {
        key: "_consumeComment",
        value: function _consumeComment(e) {
          var _this5 = this;

          this._beginToken(s.COMMENT_START, e), this._endToken([]), this._consumeRawText(!1, function () {
            return _this5._attemptStr("--\x3e");
          }), this._beginToken(s.COMMENT_END), this._requireStr("--\x3e"), this._endToken([]);
        }
      }, {
        key: "_consumeBogusComment",
        value: function _consumeBogusComment(e) {
          var _this6 = this;

          this._beginToken(s.COMMENT_START, e), this._endToken([]), this._consumeRawText(!1, function () {
            return _this6._cursor.peek() === r.$GT;
          }), this._beginToken(s.COMMENT_END), this._cursor.advance(), this._endToken([]);
        }
      }, {
        key: "_consumeCdata",
        value: function _consumeCdata(e) {
          var _this7 = this;

          this._beginToken(s.CDATA_START, e), this._endToken([]), this._consumeRawText(!1, function () {
            return _this7._attemptStr("]]>");
          }), this._beginToken(s.CDATA_END), this._requireStr("]]>"), this._endToken([]);
        }
      }, {
        key: "_consumeDocType",
        value: function _consumeDocType(e) {
          var _this8 = this;

          this._beginToken(s.DOC_TYPE_START, e), this._endToken([]), this._consumeRawText(!1, function () {
            return _this8._cursor.peek() === r.$GT;
          }), this._beginToken(s.DOC_TYPE_END), this._cursor.advance(), this._endToken([]);
        }
      }, {
        key: "_consumePrefixAndName",
        value: function _consumePrefixAndName() {
          var e = this._cursor.clone();

          var t = "";

          for (; this._cursor.peek() !== r.$COLON && !(((n = this._cursor.peek()) < r.$a || r.$z < n) && (n < r.$A || r.$Z < n) && (n < r.$0 || n > r.$9));) {
            this._cursor.advance();
          }

          var n;
          var s;
          this._cursor.peek() === r.$COLON ? (t = this._cursor.getChars(e), this._cursor.advance(), s = this._cursor.clone()) : s = e, this._requireCharCodeUntilFn(f, "" === t ? 0 : 1);
          return [t, this._cursor.getChars(s)];
        }
      }, {
        key: "_consumeTagOpen",
        value: function _consumeTagOpen(e) {
          var t,
              n,
              i,
              o = this.tokens.length;

          var a = this._cursor.clone(),
              u = [];

          try {
            if (!r.isAsciiLetter(this._cursor.peek())) throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(e));

            for (i = this._consumeTagOpenStart(e), n = i.parts[0], t = i.parts[1], this._attemptCharCodeUntilFn(d); this._cursor.peek() !== r.$SLASH && this._cursor.peek() !== r.$GT;) {
              var _this$_consumeAttribu = this._consumeAttributeName(),
                  _this$_consumeAttribu2 = _slicedToArray(_this$_consumeAttribu, 2),
                  _e23 = _this$_consumeAttribu2[0],
                  _t21 = _this$_consumeAttribu2[1];

              if (this._attemptCharCodeUntilFn(d), this._attemptCharCode(r.$EQ)) {
                this._attemptCharCodeUntilFn(d);

                var _n33 = this._consumeAttributeValue();

                u.push({
                  prefix: _e23,
                  name: _t21,
                  value: _n33
                });
              } else u.push({
                prefix: _e23,
                name: _t21
              });

              this._attemptCharCodeUntilFn(d);
            }

            this._consumeTagOpenEnd();
          } catch (t) {
            if (t instanceof D) return this._cursor = a, i && (this.tokens.length = o), this._beginToken(s.TEXT, e), void this._endToken(["<"]);
            throw t;
          }

          if (this._canSelfClose && this.tokens[this.tokens.length - 1].type === s.TAG_OPEN_END_VOID) return;

          var c = this._getTagContentType(t, n, this._fullNameStack.length > 0, u);

          this._handleFullNameStackForTagOpen(n, t), c === gn.TagContentType.RAW_TEXT ? this._consumeRawTextWithTagClose(n, t, !1) : c === gn.TagContentType.ESCAPABLE_RAW_TEXT && this._consumeRawTextWithTagClose(n, t, !0);
        }
      }, {
        key: "_consumeRawTextWithTagClose",
        value: function _consumeRawTextWithTagClose(e, t, n) {
          var _this9 = this;

          this._consumeRawText(n, function () {
            return !!_this9._attemptCharCode(r.$LT) && !!_this9._attemptCharCode(r.$SLASH) && (_this9._attemptCharCodeUntilFn(d), !!_this9._attemptStrCaseInsensitive(e ? "".concat(e, ":").concat(t) : t) && (_this9._attemptCharCodeUntilFn(d), _this9._attemptCharCode(r.$GT)));
          });

          this._beginToken(s.TAG_CLOSE), this._requireCharCodeUntilFn(function (e) {
            return e === r.$GT;
          }, 3), this._cursor.advance(), this._endToken([e, t]), this._handleFullNameStackForTagClose(e, t);
        }
      }, {
        key: "_consumeTagOpenStart",
        value: function _consumeTagOpenStart(e) {
          this._beginToken(s.TAG_OPEN_START, e);

          var t = this._consumePrefixAndName();

          return this._endToken(t);
        }
      }, {
        key: "_consumeAttributeName",
        value: function _consumeAttributeName() {
          var e = this._cursor.peek();

          if (e === r.$SQ || e === r.$DQ) throw this._createError(l(e), this._cursor.getSpan());

          this._beginToken(s.ATTR_NAME);

          var t = this._consumePrefixAndName();

          return this._endToken(t), t;
        }
      }, {
        key: "_consumeAttributeValue",
        value: function _consumeAttributeValue() {
          var e;

          if (this._cursor.peek() === r.$SQ || this._cursor.peek() === r.$DQ) {
            this._beginToken(s.ATTR_QUOTE);

            var _t22 = this._cursor.peek();

            this._cursor.advance(), this._endToken([String.fromCodePoint(_t22)]), this._beginToken(s.ATTR_VALUE);
            var _n34 = [];

            for (; this._cursor.peek() !== _t22;) {
              _n34.push(this._readChar(!0));
            }

            e = this._processCarriageReturns(_n34.join("")), this._endToken([e]), this._beginToken(s.ATTR_QUOTE), this._cursor.advance(), this._endToken([String.fromCodePoint(_t22)]);
          } else {
            this._beginToken(s.ATTR_VALUE);

            var _t23 = this._cursor.clone();

            this._requireCharCodeUntilFn(f, 1), e = this._processCarriageReturns(this._cursor.getChars(_t23)), this._endToken([e]);
          }

          return e;
        }
      }, {
        key: "_consumeTagOpenEnd",
        value: function _consumeTagOpenEnd() {
          var e = this._attemptCharCode(r.$SLASH) ? s.TAG_OPEN_END_VOID : s.TAG_OPEN_END;
          this._beginToken(e), this._requireCharCode(r.$GT), this._endToken([]);
        }
      }, {
        key: "_consumeTagClose",
        value: function _consumeTagClose(e) {
          if (this._beginToken(s.TAG_CLOSE, e), this._attemptCharCodeUntilFn(d), this._allowHtmComponentClosingTags && this._attemptCharCode(r.$SLASH)) this._attemptCharCodeUntilFn(d), this._requireCharCode(r.$GT), this._endToken([]);else {
            var _this$_consumePrefixA = this._consumePrefixAndName(),
                _this$_consumePrefixA2 = _slicedToArray(_this$_consumePrefixA, 2),
                _e24 = _this$_consumePrefixA2[0],
                _t24 = _this$_consumePrefixA2[1];

            this._attemptCharCodeUntilFn(d), this._requireCharCode(r.$GT), this._endToken([_e24, _t24]), this._handleFullNameStackForTagClose(_e24, _t24);
          }
        }
      }, {
        key: "_consumeExpansionFormStart",
        value: function _consumeExpansionFormStart() {
          this._beginToken(s.EXPANSION_FORM_START), this._requireCharCode(r.$LBRACE), this._endToken([]), this._expansionCaseStack.push(s.EXPANSION_FORM_START), this._beginToken(s.RAW_TEXT);

          var e = this._readUntil(r.$COMMA);

          this._endToken([e]), this._requireCharCode(r.$COMMA), this._attemptCharCodeUntilFn(d), this._beginToken(s.RAW_TEXT);

          var t = this._readUntil(r.$COMMA);

          this._endToken([t]), this._requireCharCode(r.$COMMA), this._attemptCharCodeUntilFn(d);
        }
      }, {
        key: "_consumeExpansionCaseStart",
        value: function _consumeExpansionCaseStart() {
          this._beginToken(s.EXPANSION_CASE_VALUE);

          var e = this._readUntil(r.$LBRACE).trim();

          this._endToken([e]), this._attemptCharCodeUntilFn(d), this._beginToken(s.EXPANSION_CASE_EXP_START), this._requireCharCode(r.$LBRACE), this._endToken([]), this._attemptCharCodeUntilFn(d), this._expansionCaseStack.push(s.EXPANSION_CASE_EXP_START);
        }
      }, {
        key: "_consumeExpansionCaseEnd",
        value: function _consumeExpansionCaseEnd() {
          this._beginToken(s.EXPANSION_CASE_EXP_END), this._requireCharCode(r.$RBRACE), this._endToken([]), this._attemptCharCodeUntilFn(d), this._expansionCaseStack.pop();
        }
      }, {
        key: "_consumeExpansionFormEnd",
        value: function _consumeExpansionFormEnd() {
          this._beginToken(s.EXPANSION_FORM_END), this._requireCharCode(r.$RBRACE), this._endToken([]), this._expansionCaseStack.pop();
        }
      }, {
        key: "_consumeText",
        value: function _consumeText() {
          var e = this._cursor.clone();

          this._beginToken(s.TEXT, e);

          var t = [];

          do {
            this._interpolationConfig && this._attemptStr(this._interpolationConfig.start) ? (t.push(this._interpolationConfig.start), this._inInterpolation = !0) : this._interpolationConfig && this._inInterpolation && this._attemptStr(this._interpolationConfig.end) ? (t.push(this._interpolationConfig.end), this._inInterpolation = !1) : t.push(this._readChar(!0));
          } while (!this._isTextEnd());

          this._endToken([this._processCarriageReturns(t.join(""))]);
        }
      }, {
        key: "_isTextEnd",
        value: function _isTextEnd() {
          if (this._cursor.peek() === r.$LT || this._cursor.peek() === r.$EOF) return !0;

          if (this._tokenizeIcu && !this._inInterpolation) {
            if (this.isExpansionFormStart()) return !0;
            if (this._cursor.peek() === r.$RBRACE && this._isInExpansionCase()) return !0;
          }

          return !1;
        }
      }, {
        key: "_readUntil",
        value: function _readUntil(e) {
          var t = this._cursor.clone();

          return this._attemptUntilChar(e), this._cursor.getChars(t);
        }
      }, {
        key: "_isInExpansionCase",
        value: function _isInExpansionCase() {
          return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === s.EXPANSION_CASE_EXP_START;
        }
      }, {
        key: "_isInExpansionForm",
        value: function _isInExpansionForm() {
          return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === s.EXPANSION_FORM_START;
        }
      }, {
        key: "isExpansionFormStart",
        value: function isExpansionFormStart() {
          if (this._cursor.peek() !== r.$LBRACE) return !1;

          if (this._interpolationConfig) {
            var _e25 = this._cursor.clone(),
                _t25 = this._attemptStr(this._interpolationConfig.start);

            return this._cursor = _e25, !_t25;
          }

          return !0;
        }
      }, {
        key: "_handleFullNameStackForTagOpen",
        value: function _handleFullNameStackForTagOpen(e, t) {
          var n = gn.mergeNsAndName(e, t);
          0 !== this._fullNameStack.length && this._fullNameStack[this._fullNameStack.length - 1] !== n || this._fullNameStack.push(n);
        }
      }, {
        key: "_handleFullNameStackForTagClose",
        value: function _handleFullNameStackForTagClose(e, t) {
          var n = gn.mergeNsAndName(e, t);
          0 !== this._fullNameStack.length && this._fullNameStack[this._fullNameStack.length - 1] === n && this._fullNameStack.pop();
        }
      }]);

      return h;
    }();

    function d(e) {
      return !r.isWhitespace(e) || e === r.$EOF;
    }

    function f(e) {
      return r.isWhitespace(e) || e === r.$GT || e === r.$SLASH || e === r.$SQ || e === r.$DQ || e === r.$EQ;
    }

    function m(e) {
      return e == r.$SEMICOLON || e == r.$EOF || !r.isAsciiHexDigit(e);
    }

    function g(e) {
      return e == r.$SEMICOLON || e == r.$EOF || !r.isAsciiLetter(e);
    }

    function E(e) {
      return e >= r.$a && e <= r.$z ? e - r.$a + r.$A : e;
    }

    var C = /*#__PURE__*/function () {
      function C(e, t) {
        _classCallCheck(this, C);

        if (e instanceof C) this.file = e.file, this.input = e.input, this.end = e.end, this.state = Object.assign({}, e.state);else {
          if (!t) throw new Error("Programming error: the range argument must be provided with a file argument.");
          this.file = e, this.input = e.content, this.end = t.endPos, this.state = {
            peek: -1,
            offset: t.startPos,
            line: t.startLine,
            column: t.startCol
          };
        }
      }

      _createClass(C, [{
        key: "clone",
        value: function clone() {
          return new C(this);
        }
      }, {
        key: "peek",
        value: function peek() {
          return this.state.peek;
        }
      }, {
        key: "charsLeft",
        value: function charsLeft() {
          return this.end - this.state.offset;
        }
      }, {
        key: "diff",
        value: function diff(e) {
          return this.state.offset - e.state.offset;
        }
      }, {
        key: "advance",
        value: function advance() {
          this.advanceState(this.state);
        }
      }, {
        key: "init",
        value: function init() {
          this.updatePeek(this.state);
        }
      }, {
        key: "getSpan",
        value: function getSpan(e, t) {
          if (e = e || this, t) for (e = e.clone(); this.diff(e) > 0 && -1 !== t.indexOf(e.peek());) {
            e.advance();
          }
          return new o.ParseSourceSpan(new o.ParseLocation(e.file, e.state.offset, e.state.line, e.state.column), new o.ParseLocation(this.file, this.state.offset, this.state.line, this.state.column));
        }
      }, {
        key: "getChars",
        value: function getChars(e) {
          return this.input.substring(e.state.offset, this.state.offset);
        }
      }, {
        key: "charAt",
        value: function charAt(e) {
          return this.input.charCodeAt(e);
        }
      }, {
        key: "advanceState",
        value: function advanceState(e) {
          if (e.offset >= this.end) throw this.state = e, new y('Unexpected character "EOF"', this);
          var t = this.charAt(e.offset);
          t === r.$LF ? (e.line++, e.column = 0) : r.isNewLine(t) || e.column++, e.offset++, this.updatePeek(e);
        }
      }, {
        key: "updatePeek",
        value: function updatePeek(e) {
          e.peek = e.offset >= this.end ? r.$EOF : this.charAt(e.offset);
        }
      }]);

      return C;
    }();

    var T = /*#__PURE__*/function (_C) {
      _inherits(T, _C);

      var _super3 = _createSuper(T);

      function T(e, t) {
        var _this10;

        _classCallCheck(this, T);

        e instanceof T ? (_this10 = _super3.call(this, e), _this10.internalState = Object.assign({}, e.internalState)) : (_this10 = _super3.call(this, e, t), _this10.internalState = _this10.state);
        return _possibleConstructorReturn(_this10);
      }

      _createClass(T, [{
        key: "advance",
        value: function advance() {
          this.state = this.internalState, _get(_getPrototypeOf(T.prototype), "advance", this).call(this), this.processEscapeSequence();
        }
      }, {
        key: "init",
        value: function init() {
          _get(_getPrototypeOf(T.prototype), "init", this).call(this), this.processEscapeSequence();
        }
      }, {
        key: "clone",
        value: function clone() {
          return new T(this);
        }
      }, {
        key: "getChars",
        value: function getChars(e) {
          var t = e.clone();
          var n = "";

          for (; t.internalState.offset < this.internalState.offset;) {
            n += String.fromCodePoint(t.peek()), t.advance();
          }

          return n;
        }
      }, {
        key: "processEscapeSequence",
        value: function processEscapeSequence() {
          var _this11 = this;

          var e = function e() {
            return _this11.internalState.peek;
          };

          if (e() === r.$BACKSLASH) if (this.internalState = Object.assign({}, this.state), this.advanceState(this.internalState), e() === r.$n) this.state.peek = r.$LF;else if (e() === r.$r) this.state.peek = r.$CR;else if (e() === r.$v) this.state.peek = r.$VTAB;else if (e() === r.$t) this.state.peek = r.$TAB;else if (e() === r.$b) this.state.peek = r.$BSPACE;else if (e() === r.$f) this.state.peek = r.$FF;else if (e() === r.$u) {
            if (this.advanceState(this.internalState), e() === r.$LBRACE) {
              this.advanceState(this.internalState);

              var _t26 = this.clone();

              var _n35 = 0;

              for (; e() !== r.$RBRACE;) {
                this.advanceState(this.internalState), _n35++;
              }

              this.state.peek = this.decodeHexDigits(_t26, _n35);
            } else {
              var _e26 = this.clone();

              this.advanceState(this.internalState), this.advanceState(this.internalState), this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(_e26, 4);
            }
          } else if (e() === r.$x) {
            this.advanceState(this.internalState);

            var _e27 = this.clone();

            this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(_e27, 2);
          } else if (r.isOctalDigit(e())) {
            var _t27 = "",
                _n36 = 0,
                _s14 = this.clone();

            for (; r.isOctalDigit(e()) && _n36 < 3;) {
              _s14 = this.clone(), _t27 += String.fromCodePoint(e()), this.advanceState(this.internalState), _n36++;
            }

            this.state.peek = parseInt(_t27, 8), this.internalState = _s14.internalState;
          } else r.isNewLine(this.internalState.peek) ? (this.advanceState(this.internalState), this.state = this.internalState) : this.state.peek = this.internalState.peek;
        }
      }, {
        key: "decodeHexDigits",
        value: function decodeHexDigits(e, t) {
          var n = this.input.substr(e.internalState.offset, t),
              r = parseInt(n, 16);
          if (isNaN(r)) throw e.state = e.internalState, new y("Invalid hexadecimal escape sequence", e);
          return r;
        }
      }]);

      return T;
    }(C);

    var y = function y(e, t) {
      _classCallCheck(this, y);

      this.msg = e, this.cursor = t;
    };

    t.CursorError = y;
  }),
      bn = t(function (e, t) {
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = /*#__PURE__*/function (_o$ParseError2) {
      _inherits(n, _o$ParseError2);

      var _super4 = _createSuper(n);

      function n(e, t, _n37) {
        var _this12;

        _classCallCheck(this, n);

        _this12 = _super4.call(this, t, _n37), _this12.elementName = e;
        return _this12;
      }

      _createClass(n, null, [{
        key: "create",
        value: function create(e, t, r) {
          return new n(e, t, r);
        }
      }]);

      return n;
    }(o.ParseError);

    t.TreeError = n;

    var r = function r(e, t) {
      _classCallCheck(this, r);

      this.rootNodes = e, this.errors = t;
    };

    t.ParseTreeResult = r;

    t.Parser = /*#__PURE__*/function () {
      function _class21(e) {
        _classCallCheck(this, _class21);

        this.getTagDefinition = e;
      }

      _createClass(_class21, [{
        key: "parse",
        value: function parse(e, t, n) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          var o = arguments.length > 4 ? arguments[4] : undefined;

          var a = function a(e) {
            return function (t) {
              for (var _len3 = arguments.length, n = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                n[_key3 - 1] = arguments[_key3];
              }

              return e.apply(void 0, [t.toLowerCase()].concat(n));
            };
          },
              u = i ? this.getTagDefinition : a(this.getTagDefinition),
              c = function c(e) {
            return u(e).contentType;
          },
              l = i ? o : a(o),
              p = o ? function (e, t, n, r) {
            var s = l(e, t, n, r);
            return void 0 !== s ? s : c(e);
          } : c,
              D = _n.tokenize(e, t, p, n),
              h = n && n.canSelfClose || !1,
              d = n && n.allowHtmComponentClosingTags || !1,
              f = new s(D.tokens, u, h, d, i).build();

          return new r(f.rootNodes, D.errors.concat(f.errors));
        }
      }]);

      return _class21;
    }();

    var s = /*#__PURE__*/function () {
      function s(e, t, n, r, _s15) {
        _classCallCheck(this, s);

        this.tokens = e, this.getTagDefinition = t, this.canSelfClose = n, this.allowHtmComponentClosingTags = r, this.isTagNameCaseSensitive = _s15, this._index = -1, this._rootNodes = [], this._errors = [], this._elementStack = [], this._advance();
      }

      _createClass(s, [{
        key: "build",
        value: function build() {
          for (; this._peek.type !== _n.TokenType.EOF;) {
            this._peek.type === _n.TokenType.TAG_OPEN_START ? this._consumeStartTag(this._advance()) : this._peek.type === _n.TokenType.TAG_CLOSE ? (this._closeVoidElement(), this._consumeEndTag(this._advance())) : this._peek.type === _n.TokenType.CDATA_START ? (this._closeVoidElement(), this._consumeCdata(this._advance())) : this._peek.type === _n.TokenType.COMMENT_START ? (this._closeVoidElement(), this._consumeComment(this._advance())) : this._peek.type === _n.TokenType.TEXT || this._peek.type === _n.TokenType.RAW_TEXT || this._peek.type === _n.TokenType.ESCAPABLE_RAW_TEXT ? (this._closeVoidElement(), this._consumeText(this._advance())) : this._peek.type === _n.TokenType.EXPANSION_FORM_START ? this._consumeExpansion(this._advance()) : this._peek.type === _n.TokenType.DOC_TYPE_START ? this._consumeDocType(this._advance()) : this._advance();
          }

          return new r(this._rootNodes, this._errors);
        }
      }, {
        key: "_advance",
        value: function _advance() {
          var e = this._peek;
          return this._index < this.tokens.length - 1 && this._index++, this._peek = this.tokens[this._index], e;
        }
      }, {
        key: "_advanceIf",
        value: function _advanceIf(e) {
          return this._peek.type === e ? this._advance() : null;
        }
      }, {
        key: "_consumeCdata",
        value: function _consumeCdata(e) {
          var t = this._advance(),
              n = this._getText(t),
              r = this._advanceIf(_n.TokenType.CDATA_END);

          this._addToParent(new Tn.CDATA(n, new o.ParseSourceSpan(e.sourceSpan.start, (r || t).sourceSpan.end)));
        }
      }, {
        key: "_consumeComment",
        value: function _consumeComment(e) {
          var t = this._advanceIf(_n.TokenType.RAW_TEXT),
              n = this._advanceIf(_n.TokenType.COMMENT_END),
              r = null != t ? t.parts[0].trim() : null,
              _s16 = new o.ParseSourceSpan(e.sourceSpan.start, (n || t || e).sourceSpan.end);

          this._addToParent(new Tn.Comment(r, _s16));
        }
      }, {
        key: "_consumeDocType",
        value: function _consumeDocType(e) {
          var t = this._advanceIf(_n.TokenType.RAW_TEXT),
              n = this._advanceIf(_n.TokenType.DOC_TYPE_END),
              r = null != t ? t.parts[0].trim() : null,
              _s17 = new o.ParseSourceSpan(e.sourceSpan.start, (n || t || e).sourceSpan.end);

          this._addToParent(new Tn.DocType(r, _s17));
        }
      }, {
        key: "_consumeExpansion",
        value: function _consumeExpansion(e) {
          var t = this._advance(),
              r = this._advance(),
              _s18 = [];

          for (; this._peek.type === _n.TokenType.EXPANSION_CASE_VALUE;) {
            var _e28 = this._parseExpansionCase();

            if (!_e28) return;

            _s18.push(_e28);
          }

          if (this._peek.type !== _n.TokenType.EXPANSION_FORM_END) return void this._errors.push(n.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '}'."));
          var i = new o.ParseSourceSpan(e.sourceSpan.start, this._peek.sourceSpan.end);
          this._addToParent(new Tn.Expansion(t.parts[0], r.parts[0], _s18, i, t.sourceSpan)), this._advance();
        }
      }, {
        key: "_parseExpansionCase",
        value: function _parseExpansionCase() {
          var e = this._advance();

          if (this._peek.type !== _n.TokenType.EXPANSION_CASE_EXP_START) return this._errors.push(n.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '{'.")), null;

          var t = this._advance(),
              r = this._collectExpansionExpTokens(t);

          if (!r) return null;

          var i = this._advance();

          r.push(new _n.Token(_n.TokenType.EOF, [], i.sourceSpan));
          var a = new s(r, this.getTagDefinition, this.canSelfClose, this.allowHtmComponentClosingTags, this.isTagNameCaseSensitive).build();
          if (a.errors.length > 0) return this._errors = this._errors.concat(a.errors), null;
          var u = new o.ParseSourceSpan(e.sourceSpan.start, i.sourceSpan.end),
              c = new o.ParseSourceSpan(t.sourceSpan.start, i.sourceSpan.end);
          return new Tn.ExpansionCase(e.parts[0], a.rootNodes, u, e.sourceSpan, c);
        }
      }, {
        key: "_collectExpansionExpTokens",
        value: function _collectExpansionExpTokens(e) {
          var t = [],
              r = [_n.TokenType.EXPANSION_CASE_EXP_START];

          for (;;) {
            if (this._peek.type !== _n.TokenType.EXPANSION_FORM_START && this._peek.type !== _n.TokenType.EXPANSION_CASE_EXP_START || r.push(this._peek.type), this._peek.type === _n.TokenType.EXPANSION_CASE_EXP_END) {
              if (!i(r, _n.TokenType.EXPANSION_CASE_EXP_START)) return this._errors.push(n.create(null, e.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
              if (r.pop(), 0 == r.length) return t;
            }

            if (this._peek.type === _n.TokenType.EXPANSION_FORM_END) {
              if (!i(r, _n.TokenType.EXPANSION_FORM_START)) return this._errors.push(n.create(null, e.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
              r.pop();
            }

            if (this._peek.type === _n.TokenType.EOF) return this._errors.push(n.create(null, e.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
            t.push(this._advance());
          }
        }
      }, {
        key: "_getText",
        value: function _getText(e) {
          var t = e.parts[0];

          if (t.length > 0 && "\n" == t[0]) {
            var _e29 = this._getParentElement();

            null != _e29 && 0 == _e29.children.length && this.getTagDefinition(_e29.name).ignoreFirstLf && (t = t.substring(1));
          }

          return t;
        }
      }, {
        key: "_consumeText",
        value: function _consumeText(e) {
          var t = this._getText(e);

          t.length > 0 && this._addToParent(new Tn.Text(t, e.sourceSpan));
        }
      }, {
        key: "_closeVoidElement",
        value: function _closeVoidElement() {
          var e = this._getParentElement();

          e && this.getTagDefinition(e.name).isVoid && this._elementStack.pop();
        }
      }, {
        key: "_consumeStartTag",
        value: function _consumeStartTag(e) {
          var t = e.parts[0],
              r = e.parts[1],
              _s19 = [];

          for (; this._peek.type === _n.TokenType.ATTR_NAME;) {
            _s19.push(this._consumeAttr(this._advance()));
          }

          var i = this._getElementFullName(t, r, this._getParentElement());

          var a = !1;

          if (this._peek.type === _n.TokenType.TAG_OPEN_END_VOID) {
            this._advance(), a = !0;

            var _t28 = this.getTagDefinition(i);

            this.canSelfClose || _t28.canSelfClose || null !== gn.getNsPrefix(i) || _t28.isVoid || this._errors.push(n.create(i, e.sourceSpan, 'Only void and foreign elements can be self closed "'.concat(e.parts[1], '"')));
          } else this._peek.type === _n.TokenType.TAG_OPEN_END && (this._advance(), a = !1);

          var u = this._peek.sourceSpan.start,
              c = new o.ParseSourceSpan(e.sourceSpan.start, u),
              l = new o.ParseSourceSpan(e.sourceSpan.start.moveBy(1), e.sourceSpan.end),
              p = new Tn.Element(i, _s19, [], c, c, void 0, l);
          this._pushElement(p), a && (this._popElement(i), p.endSourceSpan = c);
        }
      }, {
        key: "_pushElement",
        value: function _pushElement(e) {
          var t = this._getParentElement();

          t && this.getTagDefinition(t.name).isClosedByChild(e.name) && this._elementStack.pop(), this._addToParent(e), this._elementStack.push(e);
        }
      }, {
        key: "_consumeEndTag",
        value: function _consumeEndTag(e) {
          var t = this.allowHtmComponentClosingTags && 0 === e.parts.length ? null : this._getElementFullName(e.parts[0], e.parts[1], this._getParentElement());
          if (this._getParentElement() && (this._getParentElement().endSourceSpan = e.sourceSpan), t && this.getTagDefinition(t).isVoid) this._errors.push(n.create(t, e.sourceSpan, 'Void elements do not have end tags "'.concat(e.parts[1], '"')));else if (!this._popElement(t)) {
            var _r31 = 'Unexpected closing tag "'.concat(t, '". It may happen when the tag has already been closed by another tag. For more info see https://www.w3.org/TR/html5/syntax.html#closing-elements-that-have-implied-end-tags');

            this._errors.push(n.create(t, e.sourceSpan, _r31));
          }
        }
      }, {
        key: "_popElement",
        value: function _popElement(e) {
          for (var _t29 = this._elementStack.length - 1; _t29 >= 0; _t29--) {
            var _n38 = this._elementStack[_t29];
            if (!e || (gn.getNsPrefix(_n38.name) ? _n38.name == e : _n38.name.toLowerCase() == e.toLowerCase())) return this._elementStack.splice(_t29, this._elementStack.length - _t29), !0;
            if (!this.getTagDefinition(_n38.name).closedByParent) return !1;
          }

          return !1;
        }
      }, {
        key: "_consumeAttr",
        value: function _consumeAttr(e) {
          var t = gn.mergeNsAndName(e.parts[0], e.parts[1]);

          var n = e.sourceSpan.end,
              r = "",
              _s20 = void 0,
              i = void 0;

          if (this._peek.type === _n.TokenType.ATTR_QUOTE) {
            i = this._advance().sourceSpan.start;
          }

          if (this._peek.type === _n.TokenType.ATTR_VALUE) {
            var _e30 = this._advance();

            r = _e30.parts[0], n = _e30.sourceSpan.end, _s20 = _e30.sourceSpan;
          }

          if (this._peek.type === _n.TokenType.ATTR_QUOTE) {
            n = this._advance().sourceSpan.end, _s20 = new o.ParseSourceSpan(i, n);
          }

          return new Tn.Attribute(t, r, new o.ParseSourceSpan(e.sourceSpan.start, n), _s20, e.sourceSpan);
        }
      }, {
        key: "_getParentElement",
        value: function _getParentElement() {
          return this._elementStack.length > 0 ? this._elementStack[this._elementStack.length - 1] : null;
        }
      }, {
        key: "_getParentElementSkippingContainers",
        value: function _getParentElementSkippingContainers() {
          var e = null;

          for (var _t30 = this._elementStack.length - 1; _t30 >= 0; _t30--) {
            if (!gn.isNgContainer(this._elementStack[_t30].name)) return {
              parent: this._elementStack[_t30],
              container: e
            };
            e = this._elementStack[_t30];
          }

          return {
            parent: null,
            container: e
          };
        }
      }, {
        key: "_addToParent",
        value: function _addToParent(e) {
          var t = this._getParentElement();

          null != t ? t.children.push(e) : this._rootNodes.push(e);
        }
      }, {
        key: "_insertBeforeContainer",
        value: function _insertBeforeContainer(e, t, n) {
          if (t) {
            if (e) {
              var _r32 = e.children.indexOf(t);

              e.children[_r32] = n;
            } else this._rootNodes.push(n);

            n.children.push(t), this._elementStack.splice(this._elementStack.indexOf(t), 0, n);
          } else this._addToParent(n), this._elementStack.push(n);
        }
      }, {
        key: "_getElementFullName",
        value: function _getElementFullName(e, t, n) {
          return "" === e && "" === (e = this.getTagDefinition(t).implicitNamespacePrefix || "") && null != n && (e = gn.getNsPrefix(n.name)), gn.mergeNsAndName(e, t);
        }
      }]);

      return s;
    }();

    function i(e, t) {
      return e.length > 0 && e[e.length - 1] === t;
    }
  }),
      Fn = t(function (e, t) {
    /**
    	   * @license
    	   * Copyright Google Inc. All Rights Reserved.
    	   *
    	   * Use of this source code is governed by an MIT-style license that can be
    	   * found in the LICENSE file at https://angular.io/license
    	   */
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = bn;
    t.ParseTreeResult = n.ParseTreeResult, t.TreeError = n.TreeError;

    var r = /*#__PURE__*/function (_bn$Parser) {
      _inherits(r, _bn$Parser);

      var _super5 = _createSuper(r);

      function r() {
        _classCallCheck(this, r);

        return _super5.call(this, En.getHtmlTagDefinition);
      }

      _createClass(r, [{
        key: "parse",
        value: function parse(e, t, n) {
          var _r33 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

          var s = arguments.length > 4 ? arguments[4] : undefined;
          return _get(_getPrototypeOf(r.prototype), "parse", this).call(this, e, t, n, _r33, s);
        }
      }]);

      return r;
    }(bn.Parser);

    t.HtmlParser = r;
  }),
      An = t(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TagContentType = gn.TagContentType;
    var n = null;

    t.parse = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _t$canSelfClose = t.canSelfClose,
          r = _t$canSelfClose === void 0 ? !1 : _t$canSelfClose,
          _t$allowHtmComponentC = t.allowHtmComponentClosingTags,
          s = _t$allowHtmComponentC === void 0 ? !1 : _t$allowHtmComponentC,
          _t$isTagNameCaseSensi = t.isTagNameCaseSensitive,
          i = _t$isTagNameCaseSensi === void 0 ? !1 : _t$isTagNameCaseSensi,
          o = t.getTagContentType;
      return (n || (n = new Fn.HtmlParser()), n).parse(e, "angular-html-parser", {
        tokenizeExpansionForms: !1,
        interpolationConfig: void 0,
        canSelfClose: r,
        allowHtmComponentClosingTags: s
      }, i, o);
    };
  });

  var vn = o.ParseSourceSpan,
      wn = o.ParseLocation,
      kn = o.ParseSourceFile,
      Nn = At.parse,
      xn = We.inferParserByLanguage,
      On = on.HTML_ELEMENT_ATTRIBUTES,
      Rn = on.HTML_TAGS,
      Pn = on.isUnknownNamespace,
      Ln = an.hasPragma,
      Bn = Dn.Node,
      In = fn.parseIeConditionalComment,
      qn = mn.locStart,
      $n = mn.locEnd;

  function Mn(e, _ref19, u) {
    var t = _ref19.recognizeSelfClosing,
        n = _ref19.normalizeTagName,
        r = _ref19.normalizeAttributeName,
        s = _ref19.allowHtmComponentClosingTags,
        i = _ref19.isTagNameCaseSensitive,
        a = _ref19.getTagContentType;
    var c = An,
        l = Tn.RecursiveVisitor,
        p = Tn.visitAll,
        D = Tn.Attribute,
        h = Tn.CDATA,
        d = Tn.Comment,
        f = Tn.DocType,
        m = Tn.Element,
        g = Tn.Text,
        E = o.ParseSourceSpan,
        C = En.getHtmlTagDefinition;

    var _c$parse = c.parse(e, {
      canSelfClose: t,
      allowHtmComponentClosingTags: s,
      isTagNameCaseSensitive: i,
      getTagContentType: a
    }),
        T = _c$parse.rootNodes,
        y = _c$parse.errors;

    var S = "vue" === u.parser && T.some(function (e) {
      return e instanceof f && "html" === e.value || e instanceof m && "html" === e.name.toLowerCase();
    });

    if ("vue" !== u.parser || S) {
      if (S) {
        t = !0, n = !0, r = !0, s = !0, i = !1;

        var _o6 = c.parse(e, {
          canSelfClose: t,
          allowHtmComponentClosingTags: s,
          isTagNameCaseSensitive: i
        });

        T = _o6.rootNodes, y = _o6.errors;
      }
    } else {
      var _n39 = function _n39(e) {
        if (!e) return !1;
        if ("template" !== e.name) return !1;
        var t = e.attrs.find(function (e) {
          return "lang" === e.name;
        }),
            n = t && t.value;
        return null == n || "html" === xn(n, u);
      };

      if (T.some(_n39)) {
        var _r34;

        var _o7 = function _o7() {
          return c.parse(e, {
            canSelfClose: t,
            allowHtmComponentClosingTags: s,
            isTagNameCaseSensitive: i
          });
        },
            _a2 = function _a2() {
          return _r34 || (_r34 = _o7());
        },
            _u3 = function _u3(e) {
          return _a2().rootNodes.find(function (_ref20) {
            var t = _ref20.startSourceSpan;
            return t && t.start.offset === e.startSourceSpan.start.offset;
          });
        };

        for (var _e31 = 0; _e31 < T.length; _e31++) {
          var _t31 = T[_e31],
              _r35 = _t31.endSourceSpan,
              _s21 = _t31.startSourceSpan;

          if (null === _r35) {
            y = _a2().errors, T[_e31] = _u3(_t31) || _t31;
          } else if (_n39(_t31)) {
            var _n40 = _a2(),
                _i7 = _s21.end.offset,
                _o8 = _r35.start.offset;

            var _iterator9 = _createForOfIteratorHelper(_n40.errors),
                _step9;

            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var _e32 = _step9.value;
                var _t32 = _e32.span.start.offset;

                if (_i7 < _t32 && _t32 < _o8) {
                  y = [_e32];
                  break;
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }

            T[_e31] = _u3(_t31) || _t31;
          }
        }
      }
    }

    if (0 !== y.length) {
      var _y$ = y[0],
          _e33 = _y$.msg,
          _y$$span = _y$.span,
          _t33 = _y$$span.start,
          _n41 = _y$$span.end;
      throw vt(_e33, {
        start: {
          line: _t33.line + 1,
          column: _t33.col + 1
        },
        end: {
          line: _n41.line + 1,
          column: _n41.col + 1
        }
      });
    }

    var _ = function _(e) {
      var t = e.name.startsWith(":") ? e.name.slice(1).split(":")[0] : null,
          n = e.nameSpan.toString(),
          r = n.startsWith("".concat(t, ":")),
          s = r ? n.slice(t.length + 1) : n;
      e.name = s, e.namespace = t, e.hasExplicitNamespace = r;
    },
        b = function b(e, t) {
      var n = e.toLowerCase();
      return t(n) ? n : e;
    };

    return p(new ( /*#__PURE__*/function (_l2) {
      _inherits(_class22, _l2);

      var _super6 = _createSuper(_class22);

      function _class22() {
        _classCallCheck(this, _class22);

        return _super6.apply(this, arguments);
      }

      _createClass(_class22, [{
        key: "visit",
        value: function visit(e) {
          (function (e) {
            if (e instanceof D) e.type = "attribute";else if (e instanceof h) e.type = "cdata";else if (e instanceof d) e.type = "comment";else if (e instanceof f) e.type = "docType";else if (e instanceof m) e.type = "element";else {
              if (!(e instanceof g)) throw new Error("Unexpected node ".concat(JSON.stringify(e)));
              e.type = "text";
            }
          })(e), function (e) {
            e instanceof m ? (_(e), e.attrs.forEach(function (e) {
              _(e), e.valueSpan ? (e.value = e.valueSpan.toString(), /["']/.test(e.value[0]) && (e.value = e.value.slice(1, -1))) : e.value = null;
            })) : e instanceof d ? e.value = e.sourceSpan.toString().slice("\x3c!--".length, -"--\x3e".length) : e instanceof g && (e.value = e.sourceSpan.toString());
          }(e), function (e) {
            if (e instanceof m) {
              var _t34 = C(i ? e.name : e.name.toLowerCase());

              !e.namespace || e.namespace === _t34.implicitNamespacePrefix || Pn(e) ? e.tagDefinition = _t34 : e.tagDefinition = C("");
            }
          }(e), function (e) {
            if (e instanceof m && (!n || e.namespace && e.namespace !== e.tagDefinition.implicitNamespacePrefix && !Pn(e) || (e.name = b(e.name, function (e) {
              return e in Rn;
            })), r)) {
              var _t35 = On[e.name] || Object.create(null);

              e.attrs.forEach(function (n) {
                n.namespace || (n.name = b(n.name, function (n) {
                  return e.name in On && (n in On["*"] || n in _t35);
                }));
              });
            }
          }(e), function (e) {
            e.sourceSpan && e.endSourceSpan && (e.sourceSpan = new E(e.sourceSpan.start, e.endSourceSpan.end));
          }(e);
        }
      }]);

      return _class22;
    }(l))(), T), T;
  }

  function Un(e, t, n) {
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;

    var _ref21 = r ? Nn(e) : {
      frontMatter: null,
      content: e
    },
        s = _ref21.frontMatter,
        i = _ref21.content,
        o = new kn(e, t.filepath),
        a = new wn(o, 0, 0, 0),
        u = a.moveBy(e.length),
        c = {
      type: "root",
      sourceSpan: new vn(a, u),
      children: Mn(i, n, t)
    };

    if (s) {
      var _e34 = new wn(o, 0, 0, 0),
          _t36 = _e34.moveBy(s.raw.length);

      s.sourceSpan = new vn(_e34, _t36), c.children.unshift(s);
    }

    var l = new Bn(c),
        p = function p(r, s) {
      var i = s.offset,
          o = Un(e.slice(0, i).replace(/[^\n\r]/g, " ") + r, t, n, !1);
      o.sourceSpan = new vn(s, o.children[o.children.length - 1].sourceSpan.end);
      var a = o.children[0];
      return a.length === i ? o.children.shift() : (a.sourceSpan = new vn(a.sourceSpan.start.moveBy(i), a.sourceSpan.end), a.value = a.value.slice(i)), o;
    };

    return l.map(function (e) {
      if ("comment" === e.type) {
        var _t37 = In(e, p);

        if (_t37) return _t37;
      }

      return e;
    });
  }

  function Gn() {
    var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref22$recognizeSelfC = _ref22.recognizeSelfClosing,
        e = _ref22$recognizeSelfC === void 0 ? !1 : _ref22$recognizeSelfC,
        _ref22$normalizeTagNa = _ref22.normalizeTagName,
        t = _ref22$normalizeTagNa === void 0 ? !1 : _ref22$normalizeTagNa,
        _ref22$normalizeAttri = _ref22.normalizeAttributeName,
        n = _ref22$normalizeAttri === void 0 ? !1 : _ref22$normalizeAttri,
        _ref22$allowHtmCompon = _ref22.allowHtmComponentClosingTags,
        r = _ref22$allowHtmCompon === void 0 ? !1 : _ref22$allowHtmCompon,
        _ref22$isTagNameCaseS = _ref22.isTagNameCaseSensitive,
        s = _ref22$isTagNameCaseS === void 0 ? !1 : _ref22$isTagNameCaseS,
        i = _ref22.getTagContentType;

    return {
      parse: function parse(o, a, u) {
        return Un(o, u, {
          recognizeSelfClosing: e,
          normalizeTagName: t,
          normalizeAttributeName: n,
          allowHtmComponentClosingTags: r,
          isTagNameCaseSensitive: s,
          getTagContentType: i
        });
      },
      hasPragma: Ln,
      astFormat: "html",
      locStart: qn,
      locEnd: $n
    };
  }

  return {
    parsers: {
      html: Gn({
        recognizeSelfClosing: !0,
        normalizeTagName: !0,
        normalizeAttributeName: !0,
        allowHtmComponentClosingTags: !0
      }),
      angular: Gn(),
      vue: Gn({
        recognizeSelfClosing: !0,
        isTagNameCaseSensitive: !0,
        getTagContentType: function getTagContentType(e, t, n, r) {
          if ("html" !== e.toLowerCase() && !n && ("template" !== e || r.some(function (_ref23) {
            var e = _ref23.name,
                t = _ref23.value;
            return "lang" === e && "html" !== t;
          }))) return An.TagContentType.RAW_TEXT;
        }
      }),
      lwc: Gn()
    }
  };
});